document.addEventListener('DOMContentLoaded', () => {
          /* PDF.js lazy loader — only fetches the library when a PDF is uploaded */
          let _pdfReady = false;
          function ensurePdfJs() {
            if (_pdfReady) return Promise.resolve();
            return new Promise((resolve, reject) => {
              const s = document.createElement('script');
              s.src = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.min.js';
              s.crossOrigin = 'anonymous';
              s.referrerPolicy = 'no-referrer';
              s.onload = () => {
                if (typeof pdfjsLib !== 'undefined') {
                  pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/build/pdf.worker.min.js';
                }
                _pdfReady = true;
                resolve();
              };
              s.onerror = reject;
              document.head.appendChild(s);
            });
          }

          const $ = (s, r = document) => r.querySelector(s);
          const $$ = (s, r = document) => [...r.querySelectorAll(s)];
          const slug = t => (t || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
          const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
          /* On the international locale path (/en-intl/...) prefix prices with "US$" to
             disambiguate from CAD/AUD/NZD/HKD which also use the $ glyph. */
          const IS_INTL = typeof location !== 'undefined' && /\/en-intl(\/|$)/.test(location.pathname || '');
          const CURRENCY_SYMBOL = IS_INTL ? 'US$' : '$';
          const formatMoney = n => CURRENCY_SYMBOL + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

          /* On /en-intl/, say "Free international shipping" so global shoppers know shipping is
             included to their country (not just domestic US free shipping). */
          if (IS_INTL) {
            const freeShipEl = document.querySelector('.ldm-free-ship');
            if (freeShipEl) freeShipEl.textContent = '+ Free international shipping';
            const breakdownNote = document.querySelector('#ldm-breakdown .ldm-tooltip-note');
            if (breakdownNote) breakdownNote.textContent = '*Free international shipping included. Excludes taxes. No hidden setup fees.';
            const shipLong = document.querySelector('.ldm-social-proof-stat:last-of-type .ldm-sp-long');
            const shipShort = document.querySelector('.ldm-social-proof-stat:last-of-type .ldm-sp-short');
            if (shipLong) shipLong.textContent = 'Free international shipping';
            if (shipShort) shipShort.textContent = 'Free intl shipping';
          }

          const NETLIFY_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/create-beanie-draft-order';
          const EMAIL_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/send-wholesale-email';
          const SAVE_DESIGN_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/save-beanie-design';
          const LOAD_DESIGN_URL = 'https://phenomenal-capybara-bef72d.netlify.app/.netlify/functions/load-design';
          
          const SHOPIFY_FILES_CDN = 'https://cdn.shopify.com/s/files/1/0068/5123/1797/files/';

          /* ========== META PIXEL HELPERS ========== */
          /* Pixel ID is auto-detected from the already-loaded Shopify pixel — no manual paste. */
          function detectPixelId() {
            try {
              if (window._fbq && window._fbq.instance && window._fbq.instance.pixelsByID) {
                const ids = Object.keys(window._fbq.instance.pixelsByID);
                if (ids.length) return ids[0];
              }
              if (window.fbq && typeof window.fbq.getState === 'function') {
                const st = window.fbq.getState();
                if (st && st.pixels && st.pixels[0] && st.pixels[0].id) return st.pixels[0].id;
              }
            } catch (e) {}
            return '';
          }

          function _cookie(name) {
            const m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
            return m ? m[1] : '';
          }
          /* Meta CAPI subdomain index: 1 for apex (liftdown.com), 2 for one-level
             subdomain (shop.liftdown.com), etc. Hardcoding `1` produced a modified
             fbc whenever the configurator loaded under a subdomain. */
          function _subdomainIndex() {
            const h = (location.hostname || '').toLowerCase();
            if (!h || h === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(h)) return 0;
            const n = h.split('.').length;
            return n <= 1 ? 0 : n - 1;
          }
          /* Capture fbclid raw from the URL on script init and persist. Meta's
             _fbc cookie (set by their pixel) always wins in getFbc(); this only
             fills the gap if the cookie isn't set yet or SPA navigation strips
             fbclid from the URL between landing and event fire. Read fbclid via
             a regex on location.search so URL decoding can never mutate it. */
          try {
            const _m = (location.search || '').match(/[?&]fbclid=([^&#]+)/);
            const _fbcl = _m ? _m[1] : '';
            if (_fbcl) {
              const _existing = localStorage.getItem('_ld_fbc') || '';
              if (!_existing.endsWith('.' + _fbcl)) {
                localStorage.setItem('_ld_fbc', 'fb.' + _subdomainIndex() + '.' + Date.now() + '.' + _fbcl);
              }
            }
          } catch (e) {}
          function getFbp() { return _cookie('_fbp') || ''; }
          function getFbc() {
            const c = _cookie('_fbc');
            if (c) return c;
            try { return localStorage.getItem('_ld_fbc') || ''; } catch (e) {}
            return '';
          }
          function genEventId(prefix) {
            const rand = (crypto && crypto.randomUUID)
              ? crypto.randomUUID().replace(/-/g, '').slice(0, 16)
              : Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 10);
            return (prefix || 'ev') + '_' + Date.now() + '_' + rand;
          }
          function fbAdvancedInit(email) {
            if (typeof fbq !== 'function' || !email) return;
            const pid = detectPixelId();
            if (!pid) return;
            try { fbq('init', pid, { em: email.trim().toLowerCase() }); } catch (e) {}
          }

          const TIERS = [
            {q:50, price:24.00},
            {q:100, price:19.50},
            {q:250, price:17.00},
            {q:500, price:14.50}
          ];

          const EMB_PRICE = 4.00;
          const MAX_FILE = 10*1024*1024;

          /* HTML-escape helper for user-supplied values interpolated into email templates */
          const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

          const P = JSON.parse($('#ldm-data').textContent || '{}');
          /* Display name for line items + emails. Strips a leading "Lift Down" and/or
             "Custom" from the real product title, then prepends "Custom " once — so it
             reads "Custom Classic Beanie" whether the backend product is named "Lift Down
             Classic Beanie", "Classic Beanie", or "Custom Classic Beanie" (rename-proof). */
          const PRODUCT_NAME = 'Custom ' + (P.title || 'Classic Beanie')
            .replace(/^\s*lift down\s+/i, '')
            .replace(/^\s*custom\s+/i, '')
            .trim();
          const rowSizesLabel = r => `One size: ${r.qty}`;
          const COLOR_IDX = Math.max(0, (P.options||[]).findIndex(o=>(o||'').toLowerCase().includes('color')));
          const VARIANTS = P.variants || [];
          /* Colors listed in the section's "Colors to hide" setting are removed from the
             configurator (e.g. while side images aren't ready). Case-insensitive; clear the
             setting to bring them back. */
          const HIDDEN_COLORS = [].concat(
            String(P.excluded_colors || '').split(',').map(x => x.trim().toLowerCase()).filter(Boolean)
          );
          const COLORS = [...new Set(VARIANTS.map(v=>(v[`option${COLOR_IDX+1}`]||'').trim()).filter(Boolean))]
            .filter(c => !HIDDEN_COLORS.includes(c.toLowerCase()));

          const LOOK = { Front: {} };
          for (const variant of VARIANTS) {
            const color = variant[`option${COLOR_IDX + 1}`];
            if (color && variant.image) LOOK.Front[slug(color)] = variant.image;
          }
          function imageFor(color, side, width = 800) {
            const source = LOOK[side]?.[slug(color)];
            if (!source) throw new Error(`Missing ${side.toLowerCase()} photo for ${color}`);
            const url = new URL(source, window.location.origin);
            url.searchParams.set('width', String(width));
            return { url: url.href, flip: false };
          }
          const SWATCH_MAP = JSON.parse($('#ldm-swatches-data').textContent || '{}');
          function swatchImage(color) {
            return SWATCH_MAP[color] || imageFor(color, 'Front', 80).url;
          }

          /* ========== STATE ========== */
          /* Default artwork drop position per side (x/y = % of stage, logo center).
             Tuned so uploads land where embroidery actually sits: Front = middle of the
             front panel above the brim, Back = just above the strap opening, Side = low
             on the side panel, nudged toward the brim. Adjust here to retune. */
          const PLACEMENT_DEFAULTS = { Front: { x: 50, y: 70.5, w: 100, r: 0 } };
          const DD = (side) => ({file:null, data:null, placement:{ ...(PLACEMENT_DEFAULTS[side] || PLACEMENT_DEFAULTS.Front) }, pdfPage:0, mode:'file', textConfig:{text:'', font:'DM Sans', color:'#FFFFFF', size:64, align:'center', curve:0}});
          const state = {
            color: COLORS[0] || '',
            side: 'Front',
            qty: 50,
            /* mix: null = single-color order (original behavior);
               else [{color, qty, s, xl}] rows — s/xl are Small/X-Large counts, Regular is the remainder.
               sizes: order-wide size split, used only when mix is null. */
            mix: null,
            sizes: { s: 0, xl: 0 },
            designs: {
              Front: DD('Front')
            }
          };
          /* Browsing a color in mix mode must not change the committed order or
             the color used by saved/email/checkout mockups. */
          let mixPreviewColor = null;
          function displayedColor() { return mixOn() && mixPreviewColor ? mixPreviewColor : state.color; }
          /* ========== DOM REFS ========== */
          const stageEl = $('#ldm-stage');
          const stageImg = $('#ldm-stage-img');

          /* Smallest a logo may be scaled, expressed as a share of the RENDERED CAP rather
             than in screen pixels. A fixed pixel floor meant the smallest achievable logo
             was different on every screen size, and on a phone you could not get as small
             as on desktop. Placement is already stored as wPctCap, so a cap-relative floor
             is the consistent unit. The absolute floor keeps the resize handle grabbable. */
          const MIN_LOGO_PCT_CAP = 0.04;
          const MIN_LOGO_PX = 14;
          const minLogoW = () =>
            Math.max(MIN_LOGO_PX, (stageImg.offsetWidth || stageEl.clientWidth * 0.85) * MIN_LOGO_PCT_CAP);
          const logo = $('#ldm-logo');
          const logoImg = $('#ldm-logo-img');
          const stageBtns = $('#ldm-stage-btns');
          const stageBtnUpload = $('#ldm-stage-btn-upload');
          const stageBtnText = $('#ldm-stage-btn-text');
          const inlineTextEl = $('#ldm-inline-text');
          const inlineTextInput = $('#ldm-inline-text-input');
          const inlineTextDone = $('#ldm-inline-text-done');
          const swatchesEl = $('#ldm-swatches');
          const tabsEl = $('#ldm-tabs');
          const uploadEl = $('#ldm-upload');
          const uploadInput = $('#ldm-upload-input');
          const fileEl = $('#ldm-file');
          const fileNameEl = $('#ldm-file-name');
          const fileRemoveEl = $('#ldm-file-remove');
          const pdfEl = $('#ldm-pdf');
          const pdfPageEl = $('#ldm-pdf-page');
          const qtyEl = $('#ldm-qty');
          const qtyMainEl = $('#ldm-qty-main');
          const specialRequestsEl = $('#ldm-special-requests');
          const specialRequestsWrap = $('#ldm-special-requests-wrap');
          const specialToggleEl = $('#ldm-special-toggle');
          const threadNoteEl = $('#ldm-thread-note');
          const threadNoteButton = $('#ldm-thread-note-button');
          const specialToggleLabel = $('#ldm-special-toggle-label');
          function setSpecialRequestsExpanded(expanded, focus = false) {
            if (!specialRequestsWrap || !specialToggleEl) return;
            specialRequestsWrap.classList.toggle('expanded', expanded);
            specialToggleEl.setAttribute('aria-expanded', String(expanded));
            if (threadNoteButton) threadNoteButton.setAttribute('aria-expanded', String(expanded));
            if (specialToggleLabel) specialToggleLabel.textContent = expanded ? 'Hide special requests' : 'Add special requests';
            if (expanded && focus && specialRequestsEl) specialRequestsEl.focus();
          }
          if (specialToggleEl && specialRequestsWrap) {
            specialToggleEl.onclick = () => setSpecialRequestsExpanded(!specialRequestsWrap.classList.contains('expanded'), true);
          }
          if (threadNoteButton) threadNoteButton.onclick = () => openTintPop(threadNoteButton);
          const pricePerEl = $('#ldm-price-per');
          const saveEl = $('#ldm-save');
          const filePanel = $('#ldm-file-panel');
          const textPanel = $('#ldm-text-panel');
          const textInput = $('#ldm-text-input');
          const textFontWrap = $('#ldm-text-font-wrap');
          const textFontBtn = $('#ldm-text-font-btn');
          const textFontLabel = $('#ldm-text-font-label');
          const textFontMenu = $('#ldm-text-font-menu');
          const textPreview = $('#ldm-text-preview');
          const textRemoveBtn = $('#ldm-text-remove');
          const textCurveSlider = $('#ldm-text-curve');
          const textCurveOpt = $('#ldm-text-curve-opt');
          const totalEl = $('#ldm-total');
          const ctaEl = $('#ldm-cta');
          const saveToggleBtn = $('#ldm-save-toggle');
          const orderToggleBtn = $('#ldm-order-toggle');
          const savePanel = $('#ldm-save-design');
          const orderPanel = $('#ldm-order-design');
          const orderEmailInput = $('#ldm-order-email');
          const orderErrorEl = $('#ldm-order-error');
          const errorEl = $('#ldm-error');
          const modal = $('#ldm-modal');
          const processing = $('#ldm-processing');

          const uploadSuccessEl = $('#ldm-upload-success');
          const shareToast = $('#ldm-share-toast');
          const breakdownEl = $('#ldm-breakdown');

          /* ========== IMAGE PRELOADER ========== */
          const _preloaded = new Set();
          function preloadColorImages(color) {
            [state.side].forEach(side => {
              const img = imageFor(color, side);
              if (img.url && !_preloaded.has(img.url)) {
                _preloaded.add(img.url);
                const p = new Image();
                p.fetchPriority = 'low';
                p.src = img.url;
              }
            });
          }
          /* ========== SWATCHES ========== */
          /* Lead time is the same for every color. Kept as a single function so the
             timeline can be driven from one place if that ever changes again. */
          function updateLeadTime() {
            const mainEl = document.getElementById('ldm-lead-main');
            const mobileEl = document.getElementById('ldm-lead-mobile');
            const prodEl = document.getElementById('ldm-lead-prod-val');
            if (mainEl) mainEl.textContent = '4 weeks after sample review';
            if (mobileEl) mobileEl.textContent = '4 weeks after sample review';
            if (prodEl) prodEl.textContent = '4 weeks';
          }

          /* URL restoration also uses this state-only path, without generating
             selection events or rendering before initialization has finished. */
          function setPreviewColor(color) {
            if (!COLORS.includes(color)) return false;
            if (mixOn() && !state.mix.some(row => row.color === color)) {
              mixPreviewColor = color;
            } else {
              state.color = color;
              mixPreviewColor = null;
            }
            return true;
          }

          function selectColor(color) {
            if (!setPreviewColor(color)) return;
            renderSwatches(); updateStage();
            if (mixOn()) renderMix();
            trackEvent('ColorSelected', { color });
          }

          function renderSwatches() {
            const twotoneGroup = $('#ldm-twotone-group');
            const twotoneEl = $('#ldm-swatches-twotone');
            swatchesEl.innerHTML = '';
            if (twotoneEl) twotoneEl.innerHTML = '';
            /* Two-tone colors are named "Color / Color" (a slash) — split them into their own
               section, mirroring the product page. Regular colors stay in the main grid. */
            const mkSwatch = (color, container) => {
              const btn = document.createElement('button');
              const included = mixOn() && state.mix.some(row => row.color === color);
              btn.type = 'button';
              btn.className = 'ldm-swatch' + (color===displayedColor()?' active':'') + (included?' in-mix':'');
              btn.dataset.color = color;
              btn.setAttribute('aria-pressed', String(color === displayedColor()));
              btn.setAttribute('aria-label', color);
              if (mixOn()) btn.setAttribute('aria-description', included ? 'In your order. Select to preview.' : 'Preview only. Use Add to mix to include this color.');
              const safeColorName = color.replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
              btn.title = color;
              btn.innerHTML = `<img src="${swatchImage(color)}" alt="${safeColorName}">`;
              btn.onclick = () => {
                selectColor(color);
                /* Rendering swatches replaces the clicked button. Keep keyboard
                   focus on its replacement so Tab can continue to Add to mix. */
                const replacement = [...swatchesEl.querySelectorAll('button'), ...(twotoneEl ? twotoneEl.querySelectorAll('button') : [])].find(button => button.dataset.color === color);
                if (replacement) replacement.focus({ preventScroll: true });
              };
              btn.onmouseenter = () => preloadColorImages(color);
              container.appendChild(btn);
            };
            let hasTwoTone = false;
            COLORS.forEach(color => {
              if (color.includes('/') && twotoneEl) { mkSwatch(color, twotoneEl); hasTwoTone = true; }
              else { mkSwatch(color, swatchesEl); }
            });
            if (twotoneGroup) twotoneGroup.style.display = hasTwoTone ? '' : 'none';
            const colorNameEl = $('#ldm-color-name');
            if (colorNameEl) colorNameEl.textContent = displayedColor();
            const colorLabelEl = $('#ldm-color-label');
            if (colorLabelEl) colorLabelEl.textContent = mixOn() ? 'Previewing:' : 'Color:';
            updateLeadTime();
          }

          /* ========== TABS ========== */
          function renderTabs() {
            $$('.ldm-tab', tabsEl).forEach(tab => {
              const side = tab.dataset.side;
              tab.classList.toggle('active', side===state.side);
              const icon = tab.querySelector('.ldm-tab-icon');
              const hasDesign = !!state.designs[side].data;
              icon.classList.toggle('done', hasDesign);
              tab.classList.toggle('has-design', hasDesign);
              icon.innerHTML = hasDesign
                ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>'
                : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg>';
            });
          }

          tabsEl.onclick = e => {
            const tab = e.target.closest('.ldm-tab');
            if(!tab) return;
            state.side = tab.dataset.side;
            trackEvent('SideSwitched', { side: state.side });
            syncInlineTextForSide();
            renderTabs(); updateStage(); updateUploadUI(); syncViewBtns();
          };

          function syncViewBtns() {
            $$('.ldm-view-btn').forEach(btn => btn.classList.toggle('active', btn.dataset.view===state.side));
          }

          function syncInlineTextForSide() {
            closeColorEditor();
            closeAllTextPopovers();
            inlineTextEl.classList.remove('active');
            inlineTextInput.value = '';
          }

          $$('.ldm-view-btn').forEach(btn => {
            btn.onclick = () => {
              state.side = btn.dataset.view;
              syncInlineTextForSide();
              syncViewBtns(); renderTabs(); updateStage(); updateUploadUI();
            };
          });

          /* ========== STAGE ========== */
          function updateStage() {
++ldCapThreadPreviewSeq;

            const color = displayedColor();
            const img = imageFor(color, state.side);
            if (stageImg.src !== img.url) {
              stageImg.style.opacity = '0';
              stageImg.onload = () => { requestAnimationFrame(() => { stageImg.style.opacity = '1'; }); };
              stageImg.onerror = () => { stageImg.style.opacity = '1'; };
            }
            if (stageImg.src !== img.url) {
              stageImg.srcset = [400, 800, 1200].map(width => `${imageFor(color, state.side, width).url} ${width}w`).join(', ');
              stageImg.src = img.url;
            }
            stageImg.alt = `Custom ${color || ''} beanie mockup — ${state.side} view`.trim();
            stageImg.classList.toggle('flip', img.flip);

            const d = state.designs[state.side];
            const inlineActive = inlineTextEl.classList.contains('active');

            if (d.mode === 'text' && inlineActive) {
              logo.classList.remove('active', 'selected');
              logoImg.src = '';
              stageBtns.classList.add('hidden');
            } else if(d.data) {
              void ldCapThreadPreview(d, color);
              logo.classList.add('active');
              logo.classList.toggle('ldm-mode-text', d.mode === 'text');
              stageBtns.classList.add('hidden');
              applyPlacement(d.placement);
              if (colorEditorDesign && (colorEditorDesign !== d || colorEditorMode !== d.mode || colorEditorSide !== state.side)) closeColorEditor();
              /* Pre-decode the crop-drag source so grabbing an edge handle sets up
                 synchronously, even on the first crop of a large upload. */
              const cropSrc = d._fullEdited || d.data;
              if (d.mode !== 'text' && (!d._fullEditedImg || d._fullEditedImg.src !== cropSrc)) {
                const warm = new Image();
                warm.src = cropSrc;
                d._fullEditedImg = warm;
              }
            } else {
              logoImg.src = '';
              logo.classList.remove('active', 'selected');
              if (d.mode !== 'text') closeColorEditor();
              if (!inlineActive) {
                stageBtns.classList.remove('hidden');
              }
            }
            updateInlineText();
          
syncThreadControls();
if (state.designs[state.side].mode === 'text') { applyInlineTextStyle(); updateTextPreview(); }
}

          function applyPlacement(p) {
            logo.style.left = p.x + '%';
            logo.style.top = p.y + '%';
            logo.style.transform = `translate(-50%, -50%) rotate(${p.r||0}deg)`;
            logoImg.style.width = p.w + 'px';
            logoImg.style.height = 'auto';
          }

          function savePlacement() {
            const stageRect = stageEl.getBoundingClientRect();
            const logoRect = logo.getBoundingClientRect();
            const p = state.designs[state.side].placement;
            const centerX = logoRect.left + logoRect.width/2 - stageRect.left;
            const centerY = logoRect.top + logoRect.height/2 - stageRect.top;
            p.x = (centerX / stageRect.width) * 100;
            p.y = (centerY / stageRect.height) * 100;
            p.w = logoImg.offsetWidth;
          }

          /* ========== UPLOAD UI ========== */
          function updateUploadUI() {
            const d = state.designs[state.side];
            const mode = d.mode || 'file';
            syncThreadControls(d);

            $$('.ldm-mode-btn').forEach(b => b.classList.toggle('active', b.dataset.mode === mode));

            filePanel.style.display = mode === 'file' ? 'block' : 'none';
            textPanel.classList.toggle('show', mode === 'text');

            const removeBgBtn = $('#ldm-remove-bg');
            if (mode === 'file') {
              if(d.file) {
                uploadEl.style.display = 'none';
                fileEl.classList.add('show');
                fileNameEl.textContent = d.file.name;
                uploadSuccessEl.classList.add('show');
                const noteEl = document.querySelector('.ldm-upload-note');
                if (noteEl) noteEl.style.display = 'none';
                /* Show remove-bg button for raster images only (not SVG/AI/EPS/PDF) */
                if (removeBgBtn) {
                  const isRaster = d.data && !d.data.startsWith('data:image/svg') && !/\.(ai|eps)$/i.test(d.file?.name || '');
                  removeBgBtn.style.display = isRaster ? 'inline-flex' : 'none';
                  removeBgBtn.classList.remove('done', 'processing');
                  $('#ldm-remove-bg-text').textContent = d._bgRemoved ? 'Background removed ✓' : 'Remove background';
                  if (d._bgRemoved) removeBgBtn.classList.add('done');
                }
              } else {
                uploadEl.style.display = 'block';
                fileEl.classList.remove('show');
                uploadSuccessEl.classList.remove('show');
                if (removeBgBtn) removeBgBtn.style.display = 'none';
                const noteEl = document.querySelector('.ldm-upload-note');
                if (noteEl) noteEl.style.display = '';
              }
              pdfEl.classList.toggle('show', d.file?.type==='application/pdf');
            } else {
              textInput.value = d.textConfig.text;
              if (textFontLabel) { textFontLabel.textContent = d.textConfig.font; textFontLabel.style.fontFamily = `'${d.textConfig.font}'`; }
              textCurveSlider.value = d.textConfig.curve || 0;
              textCurveOpt.style.display = state.side === 'Back' ? '' : 'none';
              textRemoveBtn.classList.toggle('show', !!d.textConfig.text.trim());
              updateTextPreview();
            }
          }

          let pendingFile = null;
          uploadEl.onclick = () => uploadInput.click();

          /* Drag & drop support */
          uploadEl.ondragover = e => { e.preventDefault(); e.stopPropagation(); uploadEl.style.borderColor = 'var(--green-dark)'; uploadEl.style.background = 'var(--green-light)'; };
          uploadEl.ondragleave = e => { e.preventDefault(); e.stopPropagation(); uploadEl.style.borderColor = ''; uploadEl.style.background = ''; };
          uploadEl.ondrop = async e => {
            e.preventDefault(); e.stopPropagation();
            uploadEl.style.borderColor = ''; uploadEl.style.background = '';
            const file = e.dataTransfer?.files?.[0];
            if (!file) return;
            if (file.size > MAX_FILE) { showError('File is too large — maximum size is 10 MB.'); return; }
            await processFile(file);
          };

          stageBtnUpload.onclick = () => {
            const d = state.designs[state.side];
            (ldCapThreadMode(d, 'file'), d.mode = 'file');
            updateUploadUI();
            uploadInput.click();
          };

          stageBtnText.onclick = () => {
            const d = state.designs[state.side];
            (ldCapThreadMode(d, 'text'), d.mode = 'text');
            trackEvent('TextModeSelected', { side: state.side });
            updateUploadUI();
            openTintPop(null, { focus: false, scroll: false });
            stageBtns.classList.add('hidden');
            inlineTextEl.classList.add('active');
            inlineTextInput.value = d.textConfig.text || '';
            applyInlineTextStyle();
            applyInlineTextPlacement(d.placement);
            setTimeout(() => inlineTextInput.focus(), 50);
          };

          function applyInlineTextStyle() {
            const d = state.designs[state.side];
            const tc = d.textConfig;
            if (!readyTextFonts.has(tc.font)) {
              loadTextFont(tc.font).then(() => {
                if (d === state.designs[state.side] && d.mode === 'text') resizeInlineTextInput();
              }).catch(() => {});
            }
            inlineTextInput.style.fontFamily = `'${tc.font}', sans-serif`;
            inlineTextInput.style.color = ldCapThreadChoice(d).hex || tc.color;
            /* Scale canvas size (64=default) to inline px (22=default) */
            const inlineSize = Math.round((tc.size || 64) * 22 / 64);
            inlineTextInput.style.fontSize = inlineSize + 'px';
            inlineTextInput.style.textAlign = tc.align || 'center';
            resizeInlineTextInput();
          }

          function resizeInlineTextInput() {
            if (!inlineTextEl.classList.contains('active')) return;
            inlineTextInput.style.height = 'auto';
            /* Reset inherited/reopened heights and include the two 1px borders. */
            inlineTextInput.style.height = (inlineTextInput.scrollHeight + 2) + 'px';
          }

          function applyInlineTextPlacement(p) {
            inlineTextEl.style.left = p.x + '%';
            inlineTextEl.style.top = p.y + '%';
            inlineTextEl.style.transform = `translate(-50%, -50%) rotate(${p.r || 0}deg)`;
          }

          function updateInlineText() {
            const d = state.designs[state.side];
            if (d.mode === 'text' && inlineTextEl.classList.contains('active')) {
              applyInlineTextStyle();
            }
          }

          /* Debounce helper for text rendering */
          let _textDebounce = null;
          function debouncedApplyTextDesign() {
            clearTimeout(_textDebounce);
            const d = state.designs[state.side];
            _textDebounce = setTimeout(() => { _textDebounce = null; applyTextDesign(d); }, 150);
          }

          const MAX_TEXT_LINES = 4;
          function enforceMaxLines(el) {
            const lines = el.value.split('\n');
            if (lines.length > MAX_TEXT_LINES) {
              el.value = lines.slice(0, MAX_TEXT_LINES).join('\n');
            }
          }

          inlineTextInput.oninput = () => {
            enforceMaxLines(inlineTextInput);
            const d = state.designs[state.side];
            d.textConfig.text = inlineTextInput.value;
            textInput.value = inlineTextInput.value;
            resizeInlineTextInput();
            debouncedApplyTextDesign();
          };

          function finishInlineText(restoreFocus = false) {
            if (!inlineTextEl.classList.contains('active')) return;
            /* Commit the current side before focus can move to another side. */
            if (_textDebounce !== null) {
              clearTimeout(_textDebounce);
              _textDebounce = null;
              applyTextDesign();
            }
            const d = state.designs[state.side];
            inlineTextEl.classList.remove('active');
            updateStage();
            if (restoreFocus) {
              (d.textConfig.text.trim() ? textInput : stageBtnText).focus({ preventScroll: true });
            }
          }

          inlineTextEl.addEventListener('focusout', e => {
            if (!inlineTextEl.contains(e.relatedTarget)) finishInlineText();
          });
          window.addEventListener('resize', resizeInlineTextInput, { passive: true });
          if (inlineTextDone) inlineTextDone.onclick = () => finishInlineText(true);
          inlineTextEl.addEventListener('keydown', e => {
            if (e.key !== 'Escape') return;
            e.preventDefault();
            e.stopPropagation();
            finishInlineText(true);
          });

          let inlineDrag = null;

          inlineTextEl.onpointerdown = e => {
            if (e.target === inlineTextInput || e.target.closest('button')) return;
            e.preventDefault(); e.stopPropagation();
            inlineTextEl.setPointerCapture(e.pointerId);
            const stageRect = stageEl.getBoundingClientRect();
            const elRect = inlineTextEl.getBoundingClientRect();
            inlineDrag = {
              sx: e.clientX, sy: e.clientY,
              startX: elRect.left + elRect.width / 2 - stageRect.left,
              startY: elRect.top + elRect.height / 2 - stageRect.top
            };
          };
          inlineTextEl.onpointermove = e => {
            if (!inlineDrag) return;
            const stageRect = stageEl.getBoundingClientRect();
            let newX = clamp(inlineDrag.startX + e.clientX - inlineDrag.sx, 30, stageRect.width - 30);
            let newY = clamp(inlineDrag.startY + e.clientY - inlineDrag.sy, 30, stageRect.height - 30);
            inlineTextEl.style.left = (newX / stageRect.width) * 100 + '%';
            inlineTextEl.style.top = (newY / stageRect.height) * 100 + '%';
          };
          inlineTextEl.onpointerup = () => {
            if (inlineDrag) {
              const stageRect = stageEl.getBoundingClientRect();
              const elRect = inlineTextEl.getBoundingClientRect();
              const d = state.designs[state.side];
              d.placement.x = ((elRect.left + elRect.width / 2 - stageRect.left) / stageRect.width) * 100;
              d.placement.y = ((elRect.top + elRect.height / 2 - stageRect.top) / stageRect.height) * 100;
              inlineDrag = null;
            }
          };

          stageEl.onclick = e => {
            if(!e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') && !e.target.closest('.ldm-logo') && !e.target.closest('.ldm-stage-btn') && !e.target.closest('.ldm-stage-btns') && !e.target.closest('.ldm-inline-text')) {
              logo.classList.remove('selected');
            }
          };

          uploadInput.onchange = async () => {
            const file = uploadInput.files[0];
            uploadInput.value = '';
            if(!file) return;
            if(file.size > MAX_FILE) { showError('File is too large — maximum size is 10 MB.'); return; }
            await processFile(file);
          };

          $('#ldm-modal-close').onclick = () => { modal.classList.remove('show'); pendingFile=null; };
          $('#ldm-modal-vector').onclick = () => { modal.classList.remove('show'); pendingFile=null; uploadInput.click(); };
          $('#ldm-modal-continue').onclick = async () => { modal.classList.remove('show'); if(pendingFile) { await processFile(pendingFile); pendingFile=null; } };
          
          modal.onclick = e => {
            if(e.target === modal) { modal.classList.remove('show'); pendingFile=null; }
          };

          /* ========== FILE PROCESSING ========== */
          async function processFile(file) {
            const side = state.side;
            const d = state.designs[side];
            const uploadSeq = d._uploadSeq = (d._uploadSeq || 0) + 1;
            try {
              let dataUrl;
              const isAiOrEps = /\.(ai|eps)$/i.test(file.name);
              const needsPdf = isAiOrEps || file.type === 'application/pdf';
              if (needsPdf) await ensurePdfJs();
              if(isAiOrEps) {
                try { dataUrl = await processPDF(file, 0); }
                catch(e) { dataUrl = generatePlaceholder(file.name); }
              } else if(file.type==='application/pdf') {
                const pdfBuf = await file.arrayBuffer();
                dataUrl = await processPDFFromBuffer(pdfBuf, 0);
                const count = await getPDFPageCountFromBuffer(pdfBuf);
                if(count>1) pdfPageEl.innerHTML = Array.from({length:count},(_,i)=>`<option value="${i}">Page ${i+1}</option>`).join('');
                d._pdfBuffer = pdfBuf;
              } else if(file.type==='image/svg+xml') {
                dataUrl = await processSVG(file);
              } else {
                dataUrl = await fileToDataURL(file);
              }
              if (d._uploadSeq !== uploadSeq) return;
              if (d.mode === 'text') {
                d._stashedFile = file; d._stashedData = dataUrl; d._stashedBgRemoved = false;
              } else { d.file = file; d.data = dataUrl; }
              d.pdfPage = 0;
              d._bgRemoved = false;
              d._fullBase = null;
              d._fullEdited = null;
              d._fullEditedImg = null;
              d._cropRect = null;
              (d._tint = null, ldCapThreadResetFile(d));
              if (state.side === side) {
                updateUploadUI();
                updateStage();
                if (d.mode !== 'text') openTintPop(null);
              }
              renderTabs();
              updatePricing();
              hideError();
              warmBgModel(); /* fetch AI weights in the background so "Remove background" is instant-ish */
              trackEvent('DesignUploaded', { side, fileType: file.type, fileName: file.name });
            } catch(e) {
              /* Log details for support; show a generic message so raw errors never reach the UI. */
              console.error('[processFile] failed:', e);
              showError('We couldn\'t process that file. Please try a PNG or JPG under 10 MB.');
            }
          }

          function generatePlaceholder(filename) {
            const ext = filename.split('.').pop().toUpperCase();
            const c = document.createElement('canvas');
            c.width = 240; c.height = 240;
            const ctx = c.getContext('2d');
            ctx.fillStyle = '#f3f4f6';
            ctx.beginPath();
            ctx.roundRect(0, 0, 240, 240, 12);
            ctx.fill();
            ctx.strokeStyle = '#d1d5db';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.roundRect(1, 1, 238, 238, 12);
            ctx.stroke();
            ctx.fillStyle = '#9ca3af';
            ctx.font = '600 14px -apple-system, BlinkMacSystemFont, sans-serif';
            ctx.textAlign = 'center';
            ctx.fillText('Design uploaded', 120, 105);
            ctx.fillStyle = '#6b7280';
            ctx.font = 'bold 28px -apple-system, BlinkMacSystemFont, sans-serif';
            ctx.fillText('.' + ext.toLowerCase(), 120, 145);
            return c.toDataURL('image/png');
          }

          /* ========== THEMED DESIGN CONFIRMATION ========== */
          let designActionDialog = null;
          let pendingDesignAction = null;

          function confirmDesignAction({ title, message, confirmLabel, cancelLabel }) {
            /* A repeated click must not replace the first action's side or resolver. */
            if (pendingDesignAction) return Promise.resolve(false);
            if (!designActionDialog) {
              designActionDialog = document.createElement('dialog');
              designActionDialog.className = 'ldm-design-dialog';
              designActionDialog.setAttribute('aria-labelledby', 'ldm-design-dialog-title');
              designActionDialog.setAttribute('aria-describedby', 'ldm-design-dialog-message');
              designActionDialog.setAttribute('aria-modal', 'true');
              designActionDialog.innerHTML = `
                <div class="ldm-design-dialog__content">
                  <p class="ldm-design-dialog__eyebrow">Your design</p>
                  <h2 class="ldm-design-dialog__title" id="ldm-design-dialog-title"></h2>
                  <p class="ldm-design-dialog__message" id="ldm-design-dialog-message"></p>
                  <div class="ldm-design-dialog__actions">
                    <button type="button" class="ldm-design-dialog__button ldm-design-dialog__button--cancel" autofocus></button>
                    <button type="button" class="ldm-design-dialog__button ldm-design-dialog__button--confirm"></button>
                  </div>
                </div>`;
              document.body.appendChild(designActionDialog);
              designActionDialog.querySelector('.ldm-design-dialog__button--cancel').onclick = () => designActionDialog.close('cancel');
              designActionDialog.querySelector('.ldm-design-dialog__button--confirm').onclick = () => designActionDialog.close('confirm');
              designActionDialog.addEventListener('cancel', event => {
                event.preventDefault();
                designActionDialog.close('cancel');
              });
              designActionDialog.addEventListener('click', event => {
                if (event.target !== designActionDialog) return;
                const bounds = designActionDialog.getBoundingClientRect();
                if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
                  designActionDialog.close('cancel');
                }
              });
              designActionDialog.addEventListener('close', () => {
                const pending = pendingDesignAction;
                pendingDesignAction = null;
                if (!pending) return;
                /* showModal supplies focus containment; restore the original control on
                   cancellation. Successful removal focuses the now-visible upload action. */
                if (pending.trigger?.isConnected && pending.trigger.getClientRects().length) {
                  pending.trigger.focus({ preventScroll: true });
                }
                pending.resolve(designActionDialog.returnValue === 'confirm');
              });
            }
            designActionDialog.querySelector('.ldm-design-dialog__title').textContent = title;
            designActionDialog.querySelector('.ldm-design-dialog__message').textContent = message;
            designActionDialog.querySelector('.ldm-design-dialog__button--cancel').textContent = cancelLabel;
            designActionDialog.querySelector('.ldm-design-dialog__button--confirm').textContent = confirmLabel;
            designActionDialog.returnValue = '';
            return new Promise(resolve => {
              pendingDesignAction = { resolve, trigger: document.activeElement };
              try {
                designActionDialog.showModal();
                designActionDialog.querySelector('.ldm-design-dialog__button--cancel').focus({ preventScroll: true });
              } catch (error) {
                pendingDesignAction = null;
                showError('We couldn’t open the confirmation. Please refresh the page and try again.');
                resolve(false);
              }
            });
          }

          async function removeDesign(skipConfirm) {
            const side = state.side;
            const d = state.designs[side];
            const original = { data: d.data, file: d.file, mode: d.mode, text: JSON.stringify(d.textConfig), stashedFile: d._stashedFile, stashedData: d._stashedData };
            if (!skipConfirm && d.data) {
              const isText = d.mode === 'text';
              const accepted = await confirmDesignAction({
                title: isText ? 'Remove this text?' : 'Remove this image?',
                message: `This clears the design on the front cuff of your beanie.`,
                confirmLabel: isText ? 'Remove text' : 'Remove image',
                cancelLabel: 'Keep design'
              });
              if (!accepted) return false;
              /* A file may finish processing while the dialog is open. Never clear a
                 replacement or a different side. Text can finish its existing render
                 debounce safely when its content and styling have not changed. */
              if (state.side !== side || state.designs[side] !== d || d.mode !== original.mode || d.file !== original.file || JSON.stringify(d.textConfig) !== original.text || d._stashedFile !== original.stashedFile || d._stashedData !== original.stashedData || (d.mode !== 'text' && d.data !== original.data)) return false;
            }
            Object.assign(d, {threadByColor: {}, threadSource: null, defaultTint: null, _fileThreadState: null, _textThreadByColor: null, file:null, data:null, placement:{ ...(PLACEMENT_DEFAULTS[side] || PLACEMENT_DEFAULTS.Front) }, mode:'file', textConfig:{text:'', font:'DM Sans', color:'#FFFFFF', size:64, align:'center', curve:0}, _bgRemoved:false, _stashedFile:null, _stashedData:null, _stashedBgRemoved:null, _fullBase:null, _fullEdited:null, _fullEditedImg:null, _cropRect:null, _tint:null, _editSeq:(d._editSeq || 0) + 1, _uploadSeq:(d._uploadSeq || 0) + 1});
            uploadInput.value = '';
            logoImg.src = '';
            logo.classList.remove('active', 'selected');
            inlineTextEl.classList.remove('active');
            inlineTextInput.value = '';
            stageBtns.classList.remove('hidden');
            uploadSuccessEl.classList.remove('show');
            const _tp = document.getElementById('ldm-tint-pop');
            if (_tp) _tp.hidden = true;
            updateUploadUI(); renderTabs(); updatePricing();
            if (!skipConfirm && original.data) stageBtnUpload.focus({ preventScroll: true });
            return true;
          }

          pdfPageEl.onchange = async () => {
            const d = state.designs[state.side];
            if(!d.file) return;
            d.pdfPage = parseInt(pdfPageEl.value);
            if (d._pdfBuffer) {
              d.data = await processPDFFromBuffer(d._pdfBuffer, d.pdfPage);
            } else {
              d.data = await processPDF(d.file, d.pdfPage);
            }
            (ldCapThreadResetFile(d), d._fullBase = null, d._fullEdited = null, d._fullEditedImg = null, d._cropRect = null, d._tint = null, updateStage());
          };

          /* ========== TEXT FONTS & RENDERING ========== */
          const TEXT_FONTS = [
            /* Modern sans workhorses — most popular for clean, modern logos */
            {value: 'DM Sans', label: 'DM Sans', weight: '700'},
            {value: 'Inter', label: 'Inter', weight: '700'},
            {value: 'Roboto', label: 'Roboto', weight: '700'},
            {value: 'Open Sans', label: 'Open Sans', weight: '700'},
            {value: 'Montserrat', label: 'Montserrat', weight: '800'},
            {value: 'Poppins', label: 'Poppins', weight: '700'},
            {value: 'Lato', label: 'Lato', weight: '900'},
            {value: 'Raleway', label: 'Raleway', weight: '800'},
            {value: 'Nunito', label: 'Nunito', weight: '800'},
            {value: 'Work Sans', label: 'Work Sans', weight: '800'},
            {value: 'Rubik', label: 'Rubik', weight: '700'},
            {value: 'Quicksand', label: 'Quicksand', weight: '700'},
            /* Heavy / condensed sans — bold statements */
            {value: 'Bebas Neue', label: 'Bebas Neue', weight: '400'},
            {value: 'Oswald', label: 'Oswald', weight: '700'},
            {value: 'Anton', label: 'Anton', weight: '400'},
            {value: 'Archivo Black', label: 'Archivo Black', weight: '400'},
            {value: 'Russo One', label: 'Russo One', weight: '400'},
            {value: 'Squada One', label: 'Squada One', weight: '400'},
            {value: 'Bowlby One', label: 'Bowlby One', weight: '400'},
            /* Bold display — chunky, playful */
            {value: 'Alfa Slab One', label: 'Alfa Slab One', weight: '400'},
            {value: 'Bungee', label: 'Bungee', weight: '400'},
            {value: 'Fugaz One', label: 'Fugaz One', weight: '400'},
            {value: 'Righteous', label: 'Righteous', weight: '400'},
            {value: 'Black Ops One', label: 'Black Ops One', weight: '400'},
            {value: 'Lilita One', label: 'Lilita One', weight: '400'},
            {value: 'Carter One', label: 'Carter One', weight: '400'},
            {value: 'Passion One', label: 'Passion One', weight: '700'},
            {value: 'Fredoka One', label: 'Fredoka One', weight: '400'},
            {value: 'Acme', label: 'Acme', weight: '400'},
            {value: 'Audiowide', label: 'Audiowide', weight: '400'},
            {value: 'Press Start 2P', label: 'Press Start 2P', weight: '400'},
            /* Serif — elegant, classic */
            {value: 'Playfair Display', label: 'Playfair Display', weight: '700'},
            {value: 'Merriweather', label: 'Merriweather', weight: '900'},
            {value: 'Lora', label: 'Lora', weight: '700'},
            {value: 'Roboto Slab', label: 'Roboto Slab', weight: '700'},
            {value: 'Abril Fatface', label: 'Abril Fatface', weight: '400'},
            {value: 'Yeseva One', label: 'Yeseva One', weight: '400'},
            {value: 'Cinzel', label: 'Cinzel', weight: '700'},
            /* Script — flowy */
            {value: 'Lobster', label: 'Lobster', weight: '400'},
            {value: 'Pacifico', label: 'Pacifico', weight: '400'},
            {value: 'Dancing Script', label: 'Dancing Script', weight: '700'},
            {value: 'Great Vibes', label: 'Great Vibes', weight: '400'},
            {value: 'Sacramento', label: 'Sacramento', weight: '400'},
            {value: 'Satisfy', label: 'Satisfy', weight: '400'},
            {value: 'Cookie', label: 'Cookie', weight: '400'},
            /* Handwriting / casual */
            {value: 'Permanent Marker', label: 'Permanent Marker', weight: '400'},
            {value: 'Caveat', label: 'Caveat', weight: '700'},
            {value: 'Shadows Into Light', label: 'Shadows Into Light', weight: '400'},
            {value: 'Indie Flower', label: 'Indie Flower', weight: '400'},
            {value: 'Amatic SC', label: 'Amatic SC', weight: '700'},
            {value: 'Kalam', label: 'Kalam', weight: '700'},
            {value: 'Special Elite', label: 'Special Elite', weight: '400'}
          ];

          const textFontLoads = new Map();
          const readyTextFonts = new Set();
          let fontMenuObserver;
          function loadTextFont(font) {
            const fd = TEXT_FONTS.find(f => f.value === font) || TEXT_FONTS[0];
            if (textFontLoads.has(fd.value)) return textFontLoads.get(fd.value);
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fd.value)}:wght@${fd.weight}&display=swap`;
            const promise = new Promise((resolve, reject) => {
              const timer = setTimeout(() => reject(new Error('Font loading timed out')), 15000);
              link.onload = () => {
                document.fonts.load(`${fd.weight} 64px "${fd.value}"`).then(faces => {
                  clearTimeout(timer);
                  if (!faces.length) { reject(new Error('Font unavailable')); return; }
                  readyTextFonts.add(fd.value);
                  resolve();
                }, error => { clearTimeout(timer); reject(error); });
              };
              link.onerror = () => { clearTimeout(timer); reject(new Error('Font unavailable')); };
              document.head.appendChild(link);
            }).catch(error => { link.remove(); textFontLoads.delete(fd.value); throw error; });
            textFontLoads.set(fd.value, promise);
            return promise;
          }
          function observeFontMenu() {
            fontMenuObserver?.disconnect();
            if (!textFontWrap.classList.contains('open') || !('IntersectionObserver' in window)) return;
            fontMenuObserver = new IntersectionObserver(entries => {
              for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                fontMenuObserver.unobserve(entry.target);
                loadTextFont(entry.target.dataset.font).catch(() => {});
              }
            }, { root: textFontMenu, rootMargin: '40px' });
            textFontMenu.querySelectorAll('[data-font]').forEach(option => fontMenuObserver.observe(option));
          }
          function renderFontMenu(active) {
            textFontMenu.innerHTML = TEXT_FONTS.map(f => `<button type="button" class="ldm-text-font-opt${f.value===active?' active':''}" data-font="${f.value}" style="font-family:'${f.value}';font-weight:${f.weight}">${f.label}</button>`).join('');
            observeFontMenu();
          }
          renderFontMenu('DM Sans');
          textFontBtn.onclick = e => {
            e.stopPropagation();
            const open = textFontWrap.classList.contains('open');
            closeAllTextPopovers();
            if (!open) {
              textFontWrap.classList.add('open');
              textFontBtn.setAttribute('aria-expanded', 'true');
              observeFontMenu();
            }
          };
          textFontMenu.addEventListener('click', e => {
            const opt = e.target.closest('.ldm-text-font-opt');
            if (!opt) return;
            e.stopPropagation();
            applyFont(opt.dataset.font);
            renderFontMenu(opt.dataset.font);
            closeAllTextPopovers();
          });
          function applyFont(font) {
            const d = state.designs[state.side];
            const fd = TEXT_FONTS.find(f => f.value === font) || TEXT_FONTS[0];
            d.textConfig.font = fd.value;
            if (textFontLabel) { textFontLabel.textContent = fd.value; textFontLabel.style.fontFamily = `'${fd.value}'`; }
            applyInlineTextStyle();
            applyTextDesign(d);
          }
          async function prepareTextDesigns() {
            clearTimeout(_textDebounce);
            _textDebounce = null;
            for (const d of Object.values(state.designs)) {
              if (d.mode !== 'text' || !d.textConfig.text.trim()) continue;
              await loadTextFont(d.textConfig.font);
              applyTextDesign(d);
            }
          }

          function applyTextColor(color) {
            if (!/^#[0-9A-F]{6}$/i.test(color)) return false;
            const d = state.designs[state.side];
            if (d.mode !== 'text') return false;
            d.textConfig.color = color.toUpperCase();
            syncThreadControls(d);
            applyInlineTextStyle();
            if (d.textConfig.text.trim()) applyTextDesign(d); else updateTextPreview();
            autoSave();
            return true;
          }

          function closeAllTextPopovers(){ fontMenuObserver?.disconnect(); if(textFontWrap){ textFontWrap.classList.remove('open'); textFontBtn.setAttribute('aria-expanded','false'); } }
          document.addEventListener('click',(e)=>{ if(!e.target.closest('#ldm-text-font-wrap')) closeAllTextPopovers(); });
          document.addEventListener('keydown',(e)=>{ if(e.key==='Escape') closeAllTextPopovers(); });

          function renderTextToDataURL(text, font, color, size, align, curve) {
            if (curve && curve !== 0) return renderCurvedTextToDataURL(text, font, color, size, curve);
            const fontDef = TEXT_FONTS.find(f => f.value === font) || TEXT_FONTS[0];
            const c = document.createElement('canvas');
            const ctx = c.getContext('2d');
            const dpr = Math.max(window.devicePixelRatio || 1, 2);
            const fontSize = (size || 64) * dpr;
            const textAlign = align || 'center';
            const lineHeight = fontSize * 1.4;
            const pad = 20 * dpr;
            const lines = text.split('\n');
            ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;
            let maxWidth = 0;
            for (const line of lines) {
              const w = ctx.measureText(line || ' ').width;
              if (w > maxWidth) maxWidth = w;
            }
            c.width = Math.ceil(maxWidth) + pad * 2;
            c.height = Math.ceil(lineHeight * lines.length) + pad * 2;
            ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;
            ctx.fillStyle = color;
            ctx.textAlign = textAlign;
            ctx.textBaseline = 'middle';
            const startY = pad + lineHeight / 2;
            const drawX = textAlign === 'left' ? pad : textAlign === 'right' ? c.width - pad : c.width / 2;
            for (let i = 0; i < lines.length; i++) {
              ctx.fillText(lines[i], drawX, startY + i * lineHeight);
            }
            return c.toDataURL('image/png');
          }

          function renderCurvedTextToDataURL(text, font, color, size, curve) {
            const fontDef = TEXT_FONTS.find(f => f.value === font) || TEXT_FONTS[0];
            const c = document.createElement('canvas');
            const ctx = c.getContext('2d');
            const dpr = Math.max(window.devicePixelRatio || 1, 2);
            const fontSize = (size || 64) * dpr;
            const pad = 40 * dpr;
            const lines = text.split('\n');
            const curveDir = curve > 0 ? 1 : -1;
            const curveAmt = Math.abs(curve) / 100;

            ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;

            /* Measure total text width for each line */
            const lineWidths = lines.map(l => ctx.measureText(l || ' ').width);
            const maxWidth = Math.max(...lineWidths);
            const lineHeight = fontSize * 1.5;

            /* Radius: smaller curve value = larger radius (gentler arc) */
            const minRadius = maxWidth * 0.6;
            const maxRadius = maxWidth * 4;
            const radius = maxRadius - (maxRadius - minRadius) * curveAmt;

            /* Canvas size needs to accommodate the arc */
            const arcHeight = radius - Math.sqrt(Math.max(0, radius * radius - (maxWidth / 2) * (maxWidth / 2)));
            const totalArcHeight = arcHeight + fontSize;
            const canvasW = Math.ceil(maxWidth + pad * 2);
            const canvasH = Math.ceil(totalArcHeight * lines.length + pad * 2 + fontSize);
            c.width = canvasW;
            c.height = canvasH;

            ctx.font = `${fontDef.weight} ${fontSize}px "${font}", sans-serif`;
            ctx.fillStyle = color;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            for (let li = 0; li < lines.length; li++) {
              const line = lines[li];
              if (!line) continue;
              const chars = [...line];
              const charWidths = chars.map(ch => ctx.measureText(ch).width);
              const totalW = charWidths.reduce((a, b) => a + b, 0);

              /* Arc angle spanned by the text */
              const totalAngle = totalW / radius;

              /* Center of the arc */
              const cx = canvasW / 2;
              const cy = curveDir > 0
                ? pad + radius + fontSize / 2 + li * (totalArcHeight + lineHeight * 0.2)
                : canvasH - pad - radius - fontSize / 2 - li * (totalArcHeight + lineHeight * 0.2);

              let currentAngle = -totalAngle / 2;

              for (let i = 0; i < chars.length; i++) {
                const halfChar = charWidths[i] / 2;
                currentAngle += halfChar / radius;

                const drawAngle = curveDir > 0
                  ? -Math.PI / 2 + currentAngle
                  : Math.PI / 2 - currentAngle;

                const x = cx + radius * Math.cos(drawAngle);
                const y = cy + radius * Math.sin(drawAngle);

                ctx.save();
                ctx.translate(x, y);
                ctx.rotate(drawAngle + (curveDir > 0 ? Math.PI / 2 : -Math.PI / 2));
                ctx.fillText(chars[i], 0, 0);
                ctx.restore();

                currentAngle += halfChar / radius;
              }
            }
            return c.toDataURL('image/png');
          }

          function applyTextDesign(d = state.designs[state.side]) {
            if (d.mode !== 'text') return;
            const tc = d.textConfig;
            tc.font = (TEXT_FONTS.find(f => f.value === tc.font) || TEXT_FONTS[0]).value;
            if (!tc.text.trim()) {
              if (d.mode === 'text') { d.data = null; d.file = null; }
              renderTabs(); updatePricing();
              if (d !== state.designs[state.side]) { autoSave(); return; }
              updateStage(); updateTextPreview();
              textRemoveBtn.classList.remove('show');
              return;
            }
            if (!readyTextFonts.has(tc.font)) {
              if (d._pendingTextFont === tc.font) return;
              d._pendingTextFont = tc.font;
              loadTextFont(tc.font).then(() => {
                d._pendingTextFont = null;
                applyTextDesign(d);
              }).catch(() => {
                d._pendingTextFont = null;
                if (d === state.designs[state.side] && d.mode === 'text') showError('The font could not load. Please select it again or choose another font.');
              });
              return;
            }
            d.data = renderTextToDataURL(tc.text, tc.font, tc.color, tc.size, tc.align, tc.curve);
            d.file = null;
            renderTabs(); updatePricing();
            if (d !== state.designs[state.side]) { autoSave(); return; }
            updateStage(); updateTextPreview();
            textRemoveBtn.classList.add('show');
          }

          function updateTextPreview() {
            const d = state.designs[state.side];
            const tc = d.textConfig;
            if (tc.text.trim()) {
              const safeText = tc.text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/\n/g,'<br>');
              /* Whitelist font against TEXT_FONTS to prevent CSS injection via unicode escapes. */
              const fontDef = TEXT_FONTS.find(f => f.value === tc.font);
              const safeFont = fontDef ? fontDef.value : TEXT_FONTS[0].value;
              const safeColor = ldCapThreadChoice(state.designs[state.side]).hex || '#FFFFFF';
              textPreview.innerHTML = `<span class="ldm-text-preview-text" style="font-family:'${safeFont}';color:${safeColor};font-size:22px;font-weight:700;text-shadow:0 0 1px rgba(0,0,0,0.15);">${safeText}</span>`;
            } else {
              textPreview.innerHTML = '<span class="ldm-text-preview-text" style="color:#999;">Type to preview</span>';
            }
          }

          /* ========== MODE TOGGLE & TEXT HANDLERS ========== */
          $$('.ldm-mode-btn').forEach(btn => {
            btn.onclick = () => {
              const mode = btn.dataset.mode;
              const d = state.designs[state.side];
              if (d.mode === mode) {
                /* Already in this mode — second click on "Upload file" opens the file picker
                   so users who mistake the tab for an upload button still get the dialog. */
                if (mode === 'file') uploadInput.click();
                return;
              }
              closeColorEditor();
              closeAllTextPopovers();
              (ldCapThreadMode(d, mode), d.mode = mode);
              $$('.ldm-mode-btn').forEach(b => b.classList.toggle('active', b.dataset.mode === mode));

              if (mode === 'text') {
                /* Stash the file data so we can restore it when switching back */
                if (d.file) { d._stashedFile = d.file; d._stashedData = d.data; d._stashedBgRemoved = d._bgRemoved; }
                if (d.textConfig.text.trim()) {
                  applyTextDesign(d);
                } else { d.data = null; }
                textCurveOpt.style.display = state.side === 'Back' ? '' : 'none';
                textCurveSlider.value = d.textConfig.curve || 0;
                stageBtns.classList.add('hidden');
                inlineTextEl.classList.add('active');
                inlineTextInput.value = d.textConfig.text || '';
                applyInlineTextStyle();
                applyInlineTextPlacement(d.placement);
                setTimeout(() => inlineTextInput.focus(), 50);
              } else {
                inlineTextEl.classList.remove('active');
                inlineTextInput.value = '';
                /* Restore stashed file data if we have it */
                if (d._stashedFile) {
                  d.file = d._stashedFile; d.data = d._stashedData; d._bgRemoved = d._stashedBgRemoved || false;
                  d._stashedFile = null; d._stashedData = null; d._stashedBgRemoved = null;
                } else if (!d.file) { d.data = null; }
              }
              updateUploadUI(); updateStage(); renderTabs(); updatePricing();
              if (mode === 'text' || d.data) openTintPop(null, { focus: false, scroll: false });
            };
          });

          textInput.oninput = () => {
            enforceMaxLines(textInput);
            const d = state.designs[state.side];
            d.textConfig.text = textInput.value;
            if (inlineTextEl.classList.contains('active')) {
              inlineTextInput.value = textInput.value;
              resizeInlineTextInput();
            }
            /* Auto-resize textarea height */
            textInput.style.height = 'auto';
            textInput.style.height = textInput.scrollHeight + 'px';
            debouncedApplyTextDesign();
          };

          /* Font + color handlers live with their popover setup above. */

          textCurveSlider.oninput = () => {
            const d = state.designs[state.side];
            d.textConfig.curve = parseInt(textCurveSlider.value) || 0;
            if (d.textConfig.text.trim()) debouncedApplyTextDesign();
          };

          textRemoveBtn.onclick = () => removeDesign();

          async function fileToDataURL(file) {
            const dataUrl = await new Promise((res,rej) => {
              const r = new FileReader();
              r.onload = () => res(r.result);
              r.onerror = rej;
              r.readAsDataURL(file);
            });
            /* Resize large raster images to save memory */
            const MAX_DIM = 2000;
            return new Promise(resolve => {
              const img = new Image();
              img.onload = () => {
                if (img.width <= MAX_DIM && img.height <= MAX_DIM) { resolve(dataUrl); return; }
                const c = document.createElement('canvas');
                const s = Math.min(MAX_DIM / img.width, MAX_DIM / img.height);
                c.width = Math.round(img.width * s);
                c.height = Math.round(img.height * s);
                c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
                resolve(c.toDataURL('image/png'));
              };
              img.onerror = () => resolve(dataUrl);
              img.src = dataUrl;
            });
          }

          async function processPDF(file, page=0) {
            const ab = await file.arrayBuffer();
            return processPDFFromBuffer(ab, page);
          }

          async function processPDFFromBuffer(ab, page=0) {
            if(typeof pdfjsLib==='undefined') throw new Error('PDF library not loaded');
            const pdf = await pdfjsLib.getDocument({data:ab.slice(0), isEvalSupported:false, enableScripting:false}).promise;
            const pg = await pdf.getPage(page+1);
            const vp = pg.getViewport({scale:2});
            const c = document.createElement('canvas');
            c.width = vp.width; c.height = vp.height;
            await pg.render({canvasContext:c.getContext('2d'), viewport:vp}).promise;
            return c.toDataURL('image/png');
          }

          async function getPDFPageCount(file) {
            if(typeof pdfjsLib==='undefined') return 1;
            const ab = await file.arrayBuffer();
            return getPDFPageCountFromBuffer(ab);
          }

          async function getPDFPageCountFromBuffer(ab) {
            if(typeof pdfjsLib==='undefined') return 1;
            const pdf = await pdfjsLib.getDocument({data:ab.slice(0), isEvalSupported:false, enableScripting:false}).promise;
            return pdf.numPages;
          }

          /* Strip scripts, handlers, and external refs from user-supplied SVGs. */
          function sanitizeSVG(raw) {
            let doc;
            try { doc = new DOMParser().parseFromString(raw, 'image/svg+xml'); }
            catch { return '<svg xmlns="http://www.w3.org/2000/svg"/>'; }
            if (doc.querySelector('parsererror')) return '<svg xmlns="http://www.w3.org/2000/svg"/>';
            doc.querySelectorAll('script,foreignObject,iframe,object,embed,audio,video,link,meta,style').forEach(el => el.remove());
            const walker = document.createTreeWalker(doc.documentElement, NodeFilter.SHOW_ELEMENT);
            const all = [];
            let node = walker.currentNode;
            while (node) { all.push(node); node = walker.nextNode(); }
            for (const el of all) {
              for (const attr of Array.from(el.attributes)) {
                const name = attr.name.toLowerCase();
                if (name.startsWith('on')) { el.removeAttribute(attr.name); continue; }
                if (name === 'href' || name === 'xlink:href') {
                  const v = (attr.value || '').trim().toLowerCase();
                  if (!(v.startsWith('#') || v.startsWith('data:image/'))) el.removeAttribute(attr.name);
                }
                if (/javascript:/i.test(attr.value) || /^https?:/i.test(attr.value)) el.removeAttribute(attr.name);
              }
            }
            return new XMLSerializer().serializeToString(doc);
          }

          async function processSVG(file) {
            const raw = await file.text();
            const txt = sanitizeSVG(raw);
            const blob = new Blob([txt], {type:'image/svg+xml'});
            const url = URL.createObjectURL(blob);
            return new Promise((res,rej) => {
              const img = new Image();
              img.onload = () => {
                const c = document.createElement('canvas');
                c.width = img.width||800; c.height = img.height||800;
                c.getContext('2d').drawImage(img,0,0);
                URL.revokeObjectURL(url);
                res(c.toDataURL('image/png'));
              };
              img.onerror = () => { URL.revokeObjectURL(url); rej(new Error('SVG error')); };
              img.src = url;
            });
          }

          /* ========== DRAG / RESIZE / ROTATE ========== */
          let drag = null;
          
          const resizeHandle = $('#ldm-logo-resize');
          resizeHandle.onpointerdown = e => {
            e.stopPropagation();
            e.preventDefault();
            resizeHandle.setPointerCapture(e.pointerId);
            drag = {type: 'resize', sx: e.clientX, sy: e.clientY, sw: logoImg.offsetWidth};
          };
          
          resizeHandle.onpointermove = e => {
            if(!drag || drag.type !== 'resize') return;
            e.stopPropagation();
            const delta = (e.clientX - drag.sx + e.clientY - drag.sy) / 2;
            logoImg.style.width = Math.min(stageEl.clientWidth * 0.9, Math.max(minLogoW(), drag.sw + delta)) + 'px';
          };
          
          resizeHandle.onpointerup = () => { if(drag?.type === 'resize') { savePlacement(); drag = null; } };
          
          const rotateHandle = $('#ldm-logo-rotate');
          rotateHandle.onpointerdown = e => {
            e.stopPropagation();
            e.preventDefault();
            rotateHandle.setPointerCapture(e.pointerId);
            const logoRect = logo.getBoundingClientRect();
            const cx = logoRect.left + logoRect.width / 2;
            const cy = logoRect.top + logoRect.height / 2;
            drag = {
              type: 'rotate', 
              startAngle: Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI,
              startRotation: state.designs[state.side].placement.r || 0
            };
          };
          
          rotateHandle.onpointermove = e => {
            if(!drag || drag.type !== 'rotate') return;
            e.stopPropagation();
            const logoRect = logo.getBoundingClientRect();
            const cx = logoRect.left + logoRect.width / 2;
            const cy = logoRect.top + logoRect.height / 2;
            const currentAngle = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
            const newRotation = drag.startRotation + (currentAngle - drag.startAngle);
            state.designs[state.side].placement.r = newRotation;
            logo.style.transform = `translate(-50%, -50%) rotate(${newRotation}deg)`;
          };
          
          rotateHandle.onpointerup = () => { if(drag?.type === 'rotate') { savePlacement(); drag = null; } };

          function finishArtworkTransform() {
            if (drag?.type !== 'rotate' && drag?.type !== 'resize') return;
            savePlacement();
            drag = null;
          }
          [rotateHandle, resizeHandle].forEach(handle => {
            handle.addEventListener('pointercancel', finishArtworkTransform);
            handle.addEventListener('lostpointercapture', finishArtworkTransform);
          });
          rotateHandle.addEventListener('keydown', e => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home'].includes(e.key)) return;
            e.preventDefault();
            const p = state.designs[state.side].placement;
            const step = e.shiftKey ? 15 : 1;
            p.r = e.key === 'Home' ? 0 : (p.r || 0) + (['ArrowLeft', 'ArrowDown'].includes(e.key) ? -step : step);
            logo.style.transform = `translate(-50%, -50%) rotate(${p.r}deg)`;
            savePlacement();
          });
          resizeHandle.addEventListener('keydown', e => {
            if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
            e.preventDefault();
            const delta = (e.shiftKey ? 10 : 2) * (['ArrowLeft', 'ArrowDown'].includes(e.key) ? -1 : 1);
            logoImg.style.width = Math.min(stageEl.clientWidth * 0.9, Math.max(minLogoW(), logoImg.offsetWidth + delta)) + 'px';
            savePlacement();
          });

          /* ========== EDGE CROP (reversible) ==========
             The full image is kept in d._fullBase; the visible region is d._cropRect
             (natural px). d.data is always rebuilt as tint(crop(fullBase)) and BAKED,
             so every downstream consumer (mockups, saves, checkout) needs no changes —
             but because the full image survives, edge handles drag back OUT to reveal
             previously cropped areas. "Remove background" or a new upload resets the
             baseline. */
          function loadImg(src) {
            return new Promise((res, rej) => {
              const i = new Image();
              i.onload = () => res(i);
              i.onerror = rej;
              i.src = src;
            });
          }
          /* Rebuild d.data from the edit state. Serialized per-design so rapid
             spectrum drags can't interleave and land a stale result. */
          async function rebuildLogoData(d) {
            if (!d._fullBase) return;
            const base = d._fullBase;
            const seq = (d._editSeq = (d._editSeq || 0) + 1);
            try {
              const full = await loadImg(base);
              if (seq !== d._editSeq || d._fullBase !== base) return;
              let fullEdited = base;
              if (d._tint) {
                const c = document.createElement('canvas');
                c.width = full.naturalWidth; c.height = full.naturalHeight;
                const ctx = c.getContext('2d');
                ctx.drawImage(full, 0, 0);
                ctx.globalCompositeOperation = 'source-in';
                ctx.fillStyle = d._tint;
                ctx.fillRect(0, 0, c.width, c.height);
                fullEdited = c.toDataURL('image/png');
              }
              const r = d._cropRect;
              let out = fullEdited;
              if (r && (r.x > 0 || r.y > 0 || r.w < full.naturalWidth || r.h < full.naturalHeight)) {
                const src = d._tint ? await loadImg(fullEdited) : full;
                const c2 = document.createElement('canvas');
                c2.width = r.w; c2.height = r.h;
                c2.getContext('2d').drawImage(src, r.x, r.y, r.w, r.h, 0, 0, r.w, r.h);
                out = c2.toDataURL('image/png');
              } else {
                d._cropRect = null;
              }
              if (seq !== d._editSeq || d._fullBase !== base) return; /* superseded by a newer edit */
              d._fullEdited = fullEdited;
              if (fullEdited === d._fullBase) {
                d._fullEditedImg = full;
              } else {
                const warm = new Image();
                warm.src = fullEdited;
                d._fullEditedImg = warm;
              }
              if (d.mode === 'text') d._stashedData = out;
              else d.data = out;
              _lastSavedHash = null;
            } catch (e) { console.error('[logo-edit] rebuild failed:', e); }
          }
          /* One move-step of a crop drag. Rotates the pointer delta into the logo's
             local axes (so edges track on rotated logos), clamps the insets, then keeps
             the container hugging the visible region and centered on it. */
          function applyCropMove(g, clientX, clientY) {
            const dx = clientX - g.sx, dy = clientY - g.sy;
            const lx = dx * Math.cos(g.th) + dy * Math.sin(g.th);
            const ly = -dx * Math.sin(g.th) + dy * Math.cos(g.th);
            const KEEP = 24; /* px of image that must stay visible */
            const i = g.ins, i0 = g.ins0;
            if (g.edge === 'left') i.left = clamp(i0.left + lx, 0, g.fullW - i.right - KEEP);
            else if (g.edge === 'right') i.right = clamp(i0.right - lx, 0, g.fullW - i.left - KEEP);
            else if (g.edge === 'top') i.top = clamp(i0.top + ly, 0, g.fullH - i.bottom - KEEP);
            else if (g.edge === 'bottom') i.bottom = clamp(i0.bottom - ly, 0, g.fullH - i.top - KEEP);
            const vx = i.left + (g.fullW - i.left - i.right) / 2 - g.fullW / 2;
            const vy = i.top + (g.fullH - i.top - i.bottom) / 2 - g.fullH / 2;
            const ncx = g.fullCx + vx * Math.cos(g.th) - vy * Math.sin(g.th);
            const ncy = g.fullCy + vx * Math.sin(g.th) + vy * Math.cos(g.th);
            logo.style.left = (ncx / g.stageRect.width) * 100 + '%';
            logo.style.top = (ncy / g.stageRect.height) * 100 + '%';
            logo.style.width = (g.fullW - i.left - i.right) + 'px';
            logo.style.height = (g.fullH - i.top - i.bottom) + 'px';
            logoImg.style.left = -i.left + 'px';
            logoImg.style.top = -i.top + 'px';
            logoImg.style.clipPath = `inset(${i.top}px ${i.right}px ${i.bottom}px ${i.left}px)`;
          }
          $$('.ldm-logo-crop').forEach(h => {
            h.onpointerdown = async e => {
              e.stopPropagation();
              e.preventDefault();
              const d = state.designs[state.side];
              if (!d.data || d.mode === 'text') return;
              try { h.setPointerCapture(e.pointerId); } catch (_) {}
              if (!d._fullBase) { d._fullBase = d.data; d._fullEdited = d.data; d._cropRect = null; }
              if (!d._fullEdited) d._fullEdited = d._fullBase;
              const myDrag = { type: 'crop-pending', edge: h.dataset.edge, sx: e.clientX, sy: e.clientY };
              drag = myDrag;
if (d._threadBaselineReady) { await d._threadBaselineReady; if (drag !== myDrag) return; }

              /* Synchronous when the pre-decoded image is ready — the drag tracks
                 from the very first pixel of movement. */
              let full = (d._fullEditedImg && d._fullEditedImg.src === d._fullEdited &&
                          d._fullEditedImg.complete && d._fullEditedImg.naturalWidth) ? d._fullEditedImg : null;
              if (!full) {
                try { full = await loadImg(d._fullEdited); } catch (err) { if (drag === myDrag) drag = null; return; }
                if (drag !== myDrag) return; /* released before the image was ready */
                d._fullEditedImg = full;
              }
              const natW = full.naturalWidth, natH = full.naturalHeight;
              const rect = d._cropRect || { x: 0, y: 0, w: natW, h: natH };
              const dispW = logoImg.offsetWidth;
              if (!dispW) { drag = null; return; }
              const sc = dispW / rect.w;
              const fullW = natW * sc, fullH = natH * sc;
              const p = d.placement;
              const th = ((p.r || 0) * Math.PI) / 180;
              const stageRect = stageEl.getBoundingClientRect();
              /* Stage center of the crop region (what's on screen now) → derive where
                 the FULL image's center sits, so we can swap in the full image without
                 anything appearing to move. */
              const cx = (p.x / 100) * stageRect.width, cy = (p.y / 100) * stageRect.height;
              const offX = (rect.x + rect.w / 2 - natW / 2) * sc;
              const offY = (rect.y + rect.h / 2 - natH / 2) * sc;
              const fullCx = cx - (offX * Math.cos(th) - offY * Math.sin(th));
              const fullCy = cy - (offX * Math.sin(th) + offY * Math.cos(th));
              const ins = {
                top: rect.y * sc,
                left: rect.x * sc,
                right: (natW - rect.x - rect.w) * sc,
                bottom: (natH - rect.y - rect.h) * sc
              };
              /* The container keeps hugging the VISIBLE region (so the selection box
                 and handles don't jump); the full image hangs inside it absolutely,
                 shifted by the insets, clipped to the container bounds. Outward drags
                 shrink the insets and the box grows to reveal the hidden margins. */
              logo.style.width = (fullW - ins.left - ins.right) + 'px';
              logo.style.height = (fullH - ins.top - ins.bottom) + 'px';
              logoImg.src = d._fullEdited;
              logoImg.style.position = 'absolute';
              logoImg.style.left = -ins.left + 'px';
              logoImg.style.top = -ins.top + 'px';
              logoImg.style.width = fullW + 'px';
              logoImg.style.clipPath = `inset(${ins.top}px ${ins.right}px ${ins.bottom}px ${ins.left}px)`;
              Object.assign(myDrag, { type: 'crop', ins, ins0: { ...ins }, fullW, fullH, natW, natH, sc, fullCx, fullCy, th, d, stageRect });
              /* If moves arrived while the image was decoding, apply the latest now. */
              if (myDrag.lastX !== undefined) applyCropMove(myDrag, myDrag.lastX, myDrag.lastY);
            };
            h.onpointermove = e => {
              if (!drag) return;
              if (drag.type === 'crop-pending') { drag.lastX = e.clientX; drag.lastY = e.clientY; return; }
              if (drag.type !== 'crop') return;
              e.stopPropagation();
              applyCropMove(drag, e.clientX, e.clientY);
            };
            h.onpointerup = () => {
              if (drag?.type === 'crop-pending') { drag = null; return; }
              if (drag?.type !== 'crop') return;
              const g = drag; drag = null;
              (async () => {
                const d = g.d, i = g.ins, p = d.placement;
                let rect = {
                  x: Math.round(i.left / g.sc),
                  y: Math.round(i.top / g.sc),
                  w: Math.round((g.fullW - i.left - i.right) / g.sc),
                  h: Math.round((g.fullH - i.top - i.bottom) / g.sc)
                };
                rect.x = clamp(rect.x, 0, g.natW - 1);
                rect.y = clamp(rect.y, 0, g.natH - 1);
                rect.w = clamp(rect.w, 1, g.natW - rect.x);
                rect.h = clamp(rect.h, 1, g.natH - rect.y);
                d._cropRect = (rect.x === 0 && rect.y === 0 && rect.w === g.natW && rect.h === g.natH) ? null : rect;
                /* New stage center of the visible region, rotated out of local space */
                const vx = i.left + (g.fullW - i.left - i.right) / 2 - g.fullW / 2;
                const vy = i.top + (g.fullH - i.top - i.bottom) / 2 - g.fullH / 2;
                const stageRect = stageEl.getBoundingClientRect();
                p.x = ((g.fullCx + vx * Math.cos(g.th) - vy * Math.sin(g.th)) / stageRect.width) * 100;
                p.y = ((g.fullCy + vx * Math.sin(g.th) + vy * Math.cos(g.th)) / stageRect.height) * 100;
                p.w = Math.max(minLogoW(), g.fullW - i.left - i.right);
                await rebuildLogoData(d);
                logoImg.style.clipPath = '';
                logoImg.style.position = '';
                logoImg.style.left = '';
                logoImg.style.top = '';
                logo.style.width = '';
                logo.style.height = '';
                updateStage();
                autoSave();
              })();
            };
          });

          /* ========== LOGO RECOLOR (TINT) ==========
             source-in fill recolors every visible pixel while preserving the alpha
             channel — the logo's exact silhouette in one solid color, which is also
             what a single embroidery thread color produces. */
          const tintPop = $('#ldm-tint-pop');
          const tintHex = $('#ldm-tint-hex');
          const tintHint = $('#ldm-tint-hint');
          const brushEl = $('#ldm-stage-color-button');
          const colorControls = $('#ldm-color-controls');
          const threadTitle = $('#ldm-thread-title');
          const threadFeedback = $('#ldm-thread-feedback');
          const tintInput = $('#ldm-tint-input');
          const tintSwatch = $('#ldm-tint-swatch');
          let colorEditorDesign = null;
          let colorEditorMode = null;
          let colorEditorSide = null;

          let colorEditorCapColor = null;
let ldCapThreadPreviewSeq = 0;
function ldCapThreadSelected() {
  return [...new Set(mixOn() ? state.mix.filter(row => row.qty > 0).map(row => row.color) : [state.color])];
}
function ldCapThreadChoice(d, color = displayedColor()) {
  return window.LiftDownThreadColors.describe(d, color);
}
function ldCapThreadMode(d, nextMode) {
  if (d.mode === nextMode) return;
  if (d.mode === 'text') {
    d._textThreadByColor = d.threadByColor;
    const saved = d._fileThreadState || {};
    d.threadByColor = saved.map || {};
    d.threadSource = saved.source || null;
    d.defaultTint = saved.defaultTint === undefined ? d._tint || null : saved.defaultTint;
  } else {
    d._fileThreadState = { map: d.threadByColor || {}, source: d.threadSource || null, defaultTint: d.defaultTint === undefined ? d._tint || null : d.defaultTint };
    d.threadByColor = d._textThreadByColor || {};
    d.threadSource = null;
    d.defaultTint = null;
  }
  window.LiftDownThreadColors.clear(d);
}
function ldCapThreadResetFile(d) {
  if (d.mode === 'text') d._fileThreadState = { map: {}, source: null, defaultTint: null };
  else { d.threadByColor = {}; d.threadSource = null; d.defaultTint = null; }
  window.LiftDownThreadColors.clear(d);
}
async function ldCapThreadPreview(d, color) {
  const sequence = ++ldCapThreadPreviewSeq;
  const side = state.side;
  const mode = d.mode;
  const data = d.data;
  const choice = ldCapThreadChoice(d, color).value;
  if (choice === undefined) { logoImg.src = data || ''; return; }
  try {
    const rendered = await window.LiftDownThreadColors.render(d, color);
    if (sequence !== ldCapThreadPreviewSeq || d !== state.designs[state.side] || state.side !== side || displayedColor() !== color || d.mode !== mode || d.data !== data || ldCapThreadChoice(d, color).value !== choice) return;
    if (mode === 'text' && inlineTextEl.classList.contains('active')) return;
    logoImg.src = rendered || '';
  } catch (error) {
    if (sequence !== ldCapThreadPreviewSeq || d !== state.designs[state.side] || displayedColor() !== color) return;
    console.error('[thread-preview] failed', error);
    showError(tintPop.dataset.previewError);
  }
}
function ldCapThreadSet(value, { all = false } = {}) {
  const d = colorEditorDesign;
  const color = colorEditorCapColor;
  if (!d || d !== state.designs[state.side] || d.mode !== colorEditorMode || state.side !== colorEditorSide || color !== displayedColor()) { closeColorEditor(); return; }
  const api = window.LiftDownThreadColors;
  if (value !== null && !api.normalizeHex(value)) return;
  if (d.mode === 'text' && value === null) return;
  if (d.mode !== 'text' && !d._fullBase) {
    d._fullBase = d.threadSource || d.data;
    d._fullEdited = d.data;
    d._cropRect = null;
  }
  if (d.defaultTint === undefined) d.defaultTint = d._tint || null;
  const options = { mode: d.mode };
  d.threadByColor = all ? api.applyToSelected(d.threadByColor, ldCapThreadSelected(), value, options) : api.withOverride(d.threadByColor, color, value, options);
  _lastSavedHash = null;
  setTintUI(value);
  syncThreadControls(d);
  updateStage();
  if (d.mode === 'text') { applyInlineTextStyle(); updateTextPreview(); }
  autoSave();
  if (all) threadFeedback.textContent = tintPop.dataset.appliedAll;
  if (d.mode !== 'text' && value) {
    const base = d._fullBase;
    void loadImg(base).then(image => {
      if (colorEditorDesign === d && colorEditorCapColor === color && ldCapThreadChoice(d, color).hex === value) tintHint.hidden = hasTransparency(image);
    }).catch(() => {});
  } else tintHint.hidden = true;
}
function colorName(hex) {
            return hex?.toUpperCase() || tintPop.dataset.original;
          }
          function closeColorEditor() {
  tintPop.hidden = true;
  colorEditorDesign = null;
  colorEditorMode = null;
  colorEditorSide = null;
  colorEditorCapColor = null;
}
          function syncThreadControls(d = state.designs[state.side]) {
  const isText = d.mode === 'text';
  const available = isText || !!d.data;
  colorControls.hidden = !available;
  brushEl.hidden = !available;
  stageEl.classList.toggle('ldm-stage--has-color', available);
  if (!available) { closeColorEditor(); return; }
  const color = displayedColor();
  const hex = ldCapThreadChoice(d, color).hex;
  const swatch = $('#ldm-stage-color-swatch');
  swatch.style.background = hex || '';
  swatch.classList.toggle('ldm-thread-trigger__swatch--original', !hex);
  const placement = tintPop.dataset[state.side.toLowerCase()];
  const context = tintPop.dataset.forColor.replace('__COLOR__', color);
  brushEl.setAttribute('aria-label', `${placement} · ${context}: ${colorName(hex)}`);
  $('#ldm-thread-apply-all').hidden = ldCapThreadSelected().length < 2;
  const changed = colorEditorDesign !== d || colorEditorMode !== d.mode || colorEditorSide !== state.side || colorEditorCapColor !== color;
  colorEditorDesign = d;
  colorEditorMode = d.mode;
  colorEditorSide = state.side;
  colorEditorCapColor = color;
  $('#ldm-thread-help').hidden = isText;
  threadTitle.textContent = `${placement} · ${context}`;
  if (changed) {
    setTintUI(hex);
    tintHint.hidden = true;
  }
  tintPop.hidden = false;
}
          function hasTransparency(img) {
            try {
              const c = document.createElement('canvas');
              const s = Math.min(1, 256 / Math.max(img.naturalWidth, img.naturalHeight));
              c.width = Math.max(1, Math.round(img.naturalWidth * s));
              c.height = Math.max(1, Math.round(img.naturalHeight * s));
              const ctx = c.getContext('2d');
              ctx.drawImage(img, 0, 0, c.width, c.height);
              const px = ctx.getImageData(0, 0, c.width, c.height).data;
              for (let i = 3; i < px.length; i += 4) { if (px[i] < 250) return true; }
              return false;
            } catch (e) { return true; }
          }
          async function applyTint(hex, d) {
            if (!d?.data || d.mode === 'text') return;
            try {
              if (!d._fullBase) { d._fullBase = d.data; d._fullEdited = d.data; d._cropRect = null; }
              const base = d._fullBase;
              d._tint = hex;
              await rebuildLogoData(d);
              if (d._fullBase !== base || d._tint !== hex) return;
              if (d === state.designs[state.side] && d.mode !== 'text') {
                logoImg.src = d.data;
                syncThreadControls(d);
              }
              autoSave();
              const transparent = hasTransparency(await loadImg(base));
              if (colorEditorDesign === d && colorEditorMode !== 'text' && d._tint === hex) tintHint.hidden = !hex || transparent;
            } catch (e) { console.error('[tint] failed:', e); }
          }
          function setTintUI(hex) {
            tintHex.value = hex || '';
            tintHex.removeAttribute('aria-invalid');
            threadFeedback.textContent = '';
            $('#ldm-tint-reset').hidden = colorEditorMode === 'text' || !hex;
            tintInput.value = hex || '#FFFFFF';
            tintSwatch.style.background = hex || '';
            tintSwatch.classList.toggle('ldm-thread-trigger__swatch--original', !hex);
          }
          function openTintPop(trigger = null, { focus = true, scroll = true } = {}) {
  closeAllTextPopovers();
  syncThreadControls();
  if (tintPop.hidden) return;
  if (focus) threadTitle.focus({ preventScroll: true });
  if (scroll) tintPop.scrollIntoView({ block: 'nearest' });
}
          function chooseThreadColor(hex) {
  if (!window.LiftDownThreadColors.normalizeHex(hex)) {
    tintHex.setAttribute('aria-invalid', 'true');
    threadFeedback.textContent = threadFeedback.dataset.invalid;
    return;
  }
  ldCapThreadSet(hex.toUpperCase());
}
function openThreadPicker() {
  closeAllTextPopovers();
  syncThreadControls();
  if (tintPop.hidden) return;
  tintPop.scrollIntoView({ behavior: 'instant', block: 'center', inline: 'nearest' });
  if (typeof tintInput.showPicker === 'function') {
    try { tintInput.showPicker(); return; } catch (_) {}
  }
  tintInput.click();
}

function applyCustomColor({ validate = false } = {}) {
  const value = tintHex.value.trim();
  if (!value && colorEditorDesign && !ldCapThreadChoice(colorEditorDesign).hex) {
    tintHex.removeAttribute('aria-invalid');
    threadFeedback.textContent = '';
    return;
  }
  const hex = value.startsWith('#') ? value : '#' + value;
  if (window.LiftDownThreadColors.normalizeHex(hex)) {
    chooseThreadColor(hex);
  } else if (validate) {
    tintHex.setAttribute('aria-invalid', 'true');
    threadFeedback.textContent = threadFeedback.dataset.invalid;
  } else {
    tintHex.removeAttribute('aria-invalid');
    threadFeedback.textContent = '';
  }
}

function installThreadPickerControls() {
  brushEl.onclick = event => {
    event.stopPropagation();
    openThreadPicker();
  };
  brushEl.onpointerdown = event => { event.stopPropagation(); event.preventDefault(); };
  tintInput.oninput = () => chooseThreadColor(tintInput.value);
  tintInput.onchange = () => chooseThreadColor(tintInput.value);
  tintHex.oninput = () => applyCustomColor();
  tintHex.onchange = () => applyCustomColor({ validate: true });
  tintHex.onblur = () => applyCustomColor({ validate: true });
  tintHex.onkeydown = event => {
    if (event.key === 'Enter') { event.preventDefault(); applyCustomColor({ validate: true }); }
  };
  tintHex.onfocus = () => tintHex.select();
  $('#ldm-tint-reset').onclick = () => ldCapThreadSet(null);
  $('#ldm-thread-apply-all').onclick = () => {
    const d = colorEditorDesign;
    if (d) ldCapThreadSet(ldCapThreadChoice(d).hex, { all: true });
  };
}
installThreadPickerControls();

logo.onpointerdown = e => {
            if(e.target.closest('.ldm-logo-resize') || e.target.closest('.ldm-logo-rotate') || e.target.closest('.ldm-logo-remove') || e.target.closest('.ldm-logo-crop') || e.target.closest('.ldm-logo-brush')) return;
            logo.classList.add('selected');
            e.preventDefault();
            e.stopPropagation();
            try { logo.setPointerCapture(e.pointerId); } catch(_) {}
            const logoRect = logo.getBoundingClientRect();
            const stageRect = stageEl.getBoundingClientRect();
            drag = {
              type: 'drag',
              sx: e.clientX,
              sy: e.clientY,
              startX: logoRect.left + logoRect.width/2 - stageRect.left,
              startY: logoRect.top + logoRect.height/2 - stageRect.top
            };
          };

          function handleDragMove(e) {
            if(!drag || drag.type !== 'drag') return;
            const stageRect = stageEl.getBoundingClientRect();
            let newX = clamp(drag.startX + e.clientX - drag.sx, 30, stageRect.width - 30);
            let newY = clamp(drag.startY + e.clientY - drag.sy, 30, stageRect.height - 30);
            logo.style.left = (newX / stageRect.width) * 100 + '%';
            logo.style.top = (newY / stageRect.height) * 100 + '%';
          }
          function handleDragUp(e) {
            if(drag?.type === 'drag') {
              savePlacement();
              drag = null;
            }
          }
          logo.onpointermove = handleDragMove;
          logo.onpointerup = handleDragUp;
          /* Double-click to re-open inline text editor (single click just moves) */
          logo.ondblclick = () => {
            const d = state.designs[state.side];
            if (d.mode === 'text' && d.textConfig.text.trim()) {
              logo.classList.remove('active', 'selected');
              logoImg.src = '';
              stageBtns.classList.add('hidden');
              inlineTextEl.classList.add('active');
              inlineTextInput.value = d.textConfig.text;
              applyInlineTextStyle();
              applyInlineTextPlacement(d.placement);
              setTimeout(() => inlineTextInput.focus(), 50);
            }
          };
          /* Document-level fallback ensures drag works even if pointer capture is lost */
          document.addEventListener('pointermove', handleDragMove);
          document.addEventListener('pointerup', handleDragUp);
          
          $('#ldm-logo-remove').onclick = e => { e.stopPropagation(); removeDesign(); };
          fileRemoveEl.onclick = () => removeDesign();

          /* ========== PRICING ========== */
          function getBase(qty) { 
            for(let i = TIERS.length - 1; i >= 0; i--) {
              if(qty >= TIERS[i].q) return TIERS[i].price;
            }
            return TIERS[0].price;
          }
          
          function getSavings(qty) { 
            const max = TIERS[0].price;
            const cur = getBase(qty);
            return cur >= max ? 0 : Math.round((1 - cur / max) * 100);
          }
          
          function countDesigns() { 
            return Object.values(state.designs).filter(d => d.data).length;
          }
          
          function getDesignSides() {
            return ['Front'].filter(s => state.designs[s].data);
          }

          function updatePricing() {
            const qty = state.qty;
            const base = getBase(qty);
            const sides = getDesignSides();
            const locs = sides.length;
            /* Default to 1 embroidery location (Front assumed) so the displayed price
               always reflects an embroidered cap. Actual location is captured from
               uploads — if only Back or Side is uploaded, that's what's billed. */
            const embLocs = Math.max(1, locs);
            const emb = embLocs * EMB_PRICE;
            const per = base + emb;
            const subtotal = per * qty;
            const savings = getSavings(qty);

            pricePerEl.textContent = `${formatMoney(per)}/beanie`;
            saveEl.style.display = 'none';
            totalEl.textContent = formatMoney(subtotal);

            const incLabel = sides.length
              ? `incl. Front cuff embroidery`
              : `incl. Front cuff embroidery`;

            const mixCols = state.mix ? state.mix.length : 0;
            document.querySelectorAll('.ldm-qty-tier').forEach(tier => {
              const tierQty = parseInt(tier.dataset.qty);
              const tierBase = getBase(tierQty);
              const tierPer = tierBase + (embLocs * EMB_PRICE);
              const tierTotal = tierPer * tierQty;
              const tierSavings = getSavings(tierQty);

              tier.querySelector('.ldm-tier-price').textContent = `${formatMoney(tierPer)}/beanie`;
              tier.querySelector('.ldm-tier-total').textContent = formatMoney(tierTotal);

              const incSpan = tier.querySelector('.ldm-tier-includes');
              if (incSpan) incSpan.textContent = incLabel;

              tier.classList.toggle('active', tierQty === qty);
              tier.setAttribute('aria-pressed', String(tierQty === qty));
              tier.classList.toggle('ldm-tier-locked', mixCols > 0 && tierQty < mixCols * 50);
            });

            const customIncEl = $('#ldm-custom-includes');
            if (customIncEl) customIncEl.textContent = incLabel;
            const customRow = $('#ldm-qty-custom');
            if (customRow) customRow.classList.toggle('active', !TIERS.some(t => t.q === qty));

            let breakdownHTML = '';

            breakdownHTML += `<div class="ldm-tooltip-row">
              <span>Base price:</span>
              <span>${qty} x ${formatMoney(base)} = ${formatMoney(base * qty)}</span>
            </div>`;

            const breakdownSides = sides.length ? sides : ['Front'];
            breakdownSides.forEach(side => {
              breakdownHTML += `<div class="ldm-tooltip-row">
                <span>${side} embroidery:</span>
                <span>${qty} x ${formatMoney(EMB_PRICE)} = ${formatMoney(EMB_PRICE * qty)}</span>
              </div>`;
            });

            $('#ldm-bd-rows').innerHTML = breakdownHTML;
            $('#ldm-bd-total').textContent = formatMoney(subtotal);

            /* Embroidery note under tiers */
            const embNoteEl = $('#ldm-emb-note');
            if (embNoteEl) {
              /* "Includes X (+$3.00)" read as a surcharge on top of the price shown,
                 when the embroidery is already baked into it. Say so plainly. */
              if (locs === 0) {
                embNoteEl.innerHTML = `Price includes <strong>front cuff embroidery</strong>. Add your logo or text above.`;
              } else if (locs === 1) {
                embNoteEl.innerHTML = `Price includes <strong>front cuff embroidery</strong>.`;
              } else {
                embNoteEl.innerHTML = `Price includes <strong>${locs} embroidery locations</strong> (${sides.join(', ')}) at ${formatMoney(EMB_PRICE)}/beanie each.`;
              }
            }

          }

          /* Render every tier in TIERS up front — no folding, all six visible. */
          function renderTierRows() {
            const container = $('#ldm-qty-tiers');
            container.innerHTML = TIERS.map((t) => {
              const per = t.price + EMB_PRICE;
              return `
              <button type="button" class="ldm-qty-tier${t.q === state.qty ? ' active' : ''}" data-qty="${t.q}" aria-pressed="${String(t.q === state.qty)}">
                <span class="ldm-tier-qty">${t.q.toLocaleString()} beanies</span>
                <span class="ldm-tier-includes"></span>
                <span class="ldm-tier-price">${formatMoney(per)}/beanie</span>
                <span class="ldm-tier-total">${formatMoney(per * t.q)}</span>
              </button>
            `;}).join('');
            container.querySelectorAll('.ldm-qty-tier').forEach(tier => {
              tier.onclick = () => {
                const target = parseInt(tier.dataset.qty);
                if (mixOn()) {
                  if (!applyMixTarget(target)) {
                    const n = state.mix.length;
                    showMixQtyNote(`A ${n}-color mix has a ${n * 50} beanie minimum (50 per color). Remove a color to order fewer.`);
                  }
                  return;
                }
                state.qty = target;
                qtyEl.value = state.qty;
                updatePricing();
              };
            });
          }
          renderTierRows();

          const underMinLink = $('#ldm-under-min-link');
          if (underMinLink) underMinLink.addEventListener('click', () => {
            try { trackEvent('UnderMinimumClicked', { qty: state.qty }); } catch (e) {}
          });
          const underMinEl = $('#ldm-under-min');
          const underMinLead = $('#ldm-under-min-lead');
          let _underMinTracked = false;
          /* Asking for fewer than 50 used to clamp silently, so the visitor learned
             nothing and left. Promote the low-minimum alternative at exactly that
             moment instead. Only fires when they explicitly type a smaller number. */
          function flagUnderMin(raw) {
            if (!underMinEl) return;
            const wants = parseInt(raw, 10);
            const under = Number.isFinite(wants) && wants > 0 && wants < 50;
            underMinEl.classList.toggle('prompted', under);
            if (underMinLead) {
              underMinLead.textContent = under
                ? 'Our minimum here is 50 beanies. Only need ' + wants + '?'
                : 'Need fewer than 50?';
            }
            if (under && !_underMinTracked) {
              _underMinTracked = true;
              trackEvent('UnderMinimumPrompted', { requested: wants });
            }
          }
          qtyEl.oninput = () => {
            if (mixOn()) return; /* qty is derived from the color mix */
            flagUnderMin(qtyEl.value);
            state.qty = Math.min(99999, Math.max(50, parseInt(qtyEl.value)||50));
            updatePricing();
          };
          qtyEl.onblur = () => {
            qtyEl.value = state.qty;
          };

          /* ========== COLOR MIX & SIZES ========== */
          const mixToggleEl = $('#ldm-mix-toggle');
          const mixPanelEl = $('#ldm-mix');
          const mixRowsEl = $('#ldm-mix-rows');
          const mixTotalQtyEl = $('#ldm-mix-total-qty');
          const mixAddEl = $('#ldm-mix-add');
          const mixAddLabelEl = $('#ldm-mix-add-label');
          const mixPreviewNameEl = $('#ldm-mix-preview-name');
          const mixPreviewNoteEl = $('#ldm-mix-preview-note');
          const mixCountEl = $('#ldm-mix-count');
          const mixStatusEl = $('#ldm-mix-status');
          const sizesWrapEl = $('#ldm-sizes-wrap');
          const sizesToggleEl = $('#ldm-sizes-toggle');
          const sizeSEl = $('#ldm-size-s');
          const sizeREl = $('#ldm-size-r');
          const sizeXlEl = $('#ldm-size-xl');

          function mixOn() { return Array.isArray(state.mix) && state.mix.length > 0; }
          function mixTotal() { return state.mix.reduce((a, r) => a + (r.qty || 0), 0); }
          function mixAdd(color) {
            if (!mixOn() || !COLORS.includes(color) || state.mix.some(r => r.color === color)) return false;
            state.mix.push({ color: color, qty: 50, s: 0, xl: 0 });
            return true;
          }
          function addPreviewToMix() {
            const color = displayedColor();
            if (!mixAdd(color)) return;
            state.color = color;
            mixPreviewColor = null;
            renderSwatches(); renderMix(); updateStage();
            if (mixStatusEl) mixStatusEl.textContent = `${color} added. 50 beanies. ${mixTotal().toLocaleString()} beanies in your order.`;
            /* Land on the new quantity so it is easy to adjust without hunting. */
            const quantity = mixRowsEl && mixRowsEl.querySelector('.ldm-mix-row-wrap:last-child .ldm-mix-qty');
            if (quantity) quantity.focus({ preventScroll: true });
          }
          function clampRowSizes(r) { r.s = 0; r.xl = 0; }
          function rowSizesSuffix(r) { return ` (R ${r.qty})`; }
          function hasAnySizes() {
            return mixOn() ? state.mix.some(r => r.s || r.xl) : !!(state.sizes.s || state.sizes.xl);
          }
          function sizesLabel() { return `One size: ${state.qty}`; }
          function orderColorLabel() {
            return mixOn() ? state.mix.map(r => `${r.color} ${r.qty}`).join(', ') : state.color;
          }
          function orderMixDetail() {
            return state.mix.map(r => `- ${r.color}: ${r.qty}${rowSizesSuffix(r)}`).join('\n');
          }

          function syncFromMix() {
            if (threadNoteEl) {
              const colors = new Set((state.mix || []).filter(row => row.qty > 0).map(row => row.color));
              threadNoteEl.hidden = colors.size < 2;
            }
            if (mixOn()) {
              flagUnderMin(50);
              state.qty = Math.max(50, mixTotal());
              qtyEl.value = state.qty;
              qtyEl.disabled = true;
            } else {
              qtyEl.disabled = false;
            }
            if (sizesWrapEl) sizesWrapEl.style.display = mixOn() ? 'none' : '';
            updatePricing();
          }

          function renderMix() {
            if (!mixPanelEl) return;
            mixPanelEl.style.display = mixOn() ? '' : 'none';
            if (mixToggleEl) {
              const mixLbl = document.getElementById('ldm-mix-toggle-label');
              if (mixLbl) mixLbl.textContent = mixOn() ? 'Order a single color instead' : 'Add multiple colors to your order';
              const mixBadge = document.querySelector('#ldm-mix-toggle .ldm-new-badge');
              if (mixBadge) mixBadge.style.display = mixOn() ? 'none' : '';
              mixToggleEl.setAttribute('aria-expanded', String(mixOn()));
            }
            if (!mixOn()) { syncFromMix(); return; }
            const preview = displayedColor();
            const included = state.mix.find(row => row.color === preview);
            if (mixPreviewNameEl) mixPreviewNameEl.textContent = preview;
            if (mixPreviewNoteEl) mixPreviewNoteEl.textContent = included ? `${included.qty.toLocaleString()} beanies in your order` : 'Adds 50 beanies · adjust below';
            if (mixAddEl) {
              mixAddEl.disabled = !!included;
              mixAddEl.setAttribute('aria-label', included ? `${preview} is in your order` : `Add ${preview} to mix`);
            }
            if (mixAddLabelEl) mixAddLabelEl.textContent = included ? 'In your order' : 'Add to mix';
            if (mixCountEl) mixCountEl.textContent = `${state.mix.length} ${state.mix.length === 1 ? 'color' : 'colors'}`;
            mixRowsEl.innerHTML = '';
            state.mix.forEach((row, i) => {
              clampRowSizes(row);
              const wrap = document.createElement('div');
              wrap.className = 'ldm-mix-row-wrap' + (row._sizesOpen ? ' sizes-open' : '');
              wrap.dataset.idx = i;
              const reg = Math.max(0, row.qty - row.s - row.xl);
              wrap.innerHTML = `
                <div class="ldm-mix-row${row.color === preview ? ' preview' : ''}">
                  <button type="button" class="ldm-mix-swatch" data-act="preview" title="Preview ${esc(row.color)}"><img src="${swatchImage(row.color)}" alt=""></button>
                  <button type="button" class="ldm-mix-name" data-act="preview" aria-label="Preview ${esc(row.color)} beanie">${esc(row.color)}</button>
                  <label class="ldm-mix-qty-field"><span>Qty</span><input type="number" class="ldm-mix-qty" data-act="qty" min="50" max="99999" value="${row.qty}" inputmode="numeric" aria-label="Quantity for ${esc(row.color)}"></label>
                  <button type="button" class="ldm-mix-remove" data-act="remove" aria-label="Remove ${esc(row.color)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v5M14 11v5"/></svg></button>
                </div>
                `;
              mixRowsEl.appendChild(wrap);
            });
            if (mixTotalQtyEl) mixTotalQtyEl.textContent = `${mixTotal().toLocaleString()} beanies`;
            syncFromMix();
          }

          /* Clicking a quantity tier during a mix used to be a silent no-op. Scale every
             row proportionally to the new total instead, holding the 50-per-color floor
             and fixing rounding drift so the total lands exactly on the tier. */
          function applyMixTarget(target) {
            if (!mixOn()) return false;
            const rows = state.mix, n = rows.length;
            const minTotal = n * 50;
            target = Math.max(50, Math.min(99999, parseInt(target, 10) || 0));
            if (target < minTotal) return false;
            const cur = mixTotal() || minTotal;
            const alloc = rows.map(r => Math.max(50, Math.round(((r.qty || 50) / cur) * target)));
            let diff = target - alloc.reduce((a, b) => a + b, 0);
            for (let i = 0, guard = 0; diff !== 0 && guard < 20000; i++, guard++) {
              const k = i % n;
              if (diff > 0) { alloc[k]++; diff--; }
              else if (alloc[k] > 50) { alloc[k]--; diff++; }
            }
            rows.forEach((r, k) => { r.qty = alloc[k]; clampRowSizes(r); });
            renderMix();
            return true;
          }
          function showMixQtyNote(msg) {
            const el = $('#ldm-qty-mix-note');
            if (!el) return;
            el.textContent = msg;
            el.classList.add('show');
            clearTimeout(el._noteTimer);
            el._noteTimer = setTimeout(() => el.classList.remove('show'), 6000);
          }

          function enterMix() {
            mixPreviewColor = null;
            state.mix = [{ color: state.color, qty: state.qty, s: state.sizes.s | 0, xl: state.sizes.xl | 0 }];
            renderSwatches(); renderMix();
            trackEvent('ColorMixEnabled', { color: state.color });
          }
          function exitMix() {
            const color = mixPreviewColor || state.color;
            if (mixOn()) {
              flagUnderMin(50);
              state.qty = Math.max(50, mixTotal());
              qtyEl.value = state.qty;
              const t = state.mix.reduce((a, r) => ({ s: a.s + (r.s | 0), xl: a.xl + (r.xl | 0) }), { s: 0, xl: 0 });
              state.sizes = t; /* stale global sizes must not resurface after a mix session */
            }
            state.mix = null;
            state.color = color;
            mixPreviewColor = null;
            renderSwatches(); renderMix(); updateStage();
            renderGlobalSizes();
          }
          if (mixToggleEl) mixToggleEl.onclick = () => { if (mixOn()) exitMix(); else enterMix(); };
          if (mixAddEl) mixAddEl.onclick = addPreviewToMix;

          if (mixRowsEl) {
            mixRowsEl.addEventListener('click', e => {
              const actEl = e.target.closest('[data-act]');
              const wrap = e.target.closest('.ldm-mix-row-wrap');
              if (!actEl || !wrap) return;
              const row = state.mix && state.mix[+wrap.dataset.idx];
              if (!row) return;
              const act = actEl.dataset.act;
              if (act === 'preview') {
                selectColor(row.color);
              } else if (act === 'sizes') {
                row._sizesOpen = !row._sizesOpen;
                renderMix();
              } else if (act === 'remove') {
                if (state.mix.length === 1) {
                  exitMix();
                  if (mixStatusEl) mixStatusEl.textContent = 'Switched to a single-color order.';
                } else {
                  state.mix.splice(+wrap.dataset.idx, 1);
                  if (!state.mix.some(item => item.color === state.color)) state.color = state.mix[0].color;
                  renderSwatches(); renderMix(); updateStage();
                  if (mixStatusEl) mixStatusEl.textContent = `${row.color} removed from your mix.`;
                }
              }
              if (act === 'preview' || act === 'sizes' || act === 'remove') {
                const index = mixOn() ? Math.min(+wrap.dataset.idx, state.mix.length - 1) : -1;
                const nextFocus = index < 0 ? mixToggleEl : mixRowsEl.querySelector(`.ldm-mix-row-wrap[data-idx="${index}"] [data-act="${act}"]`);
                if (nextFocus) nextFocus.focus({ preventScroll: true });
              }
            });
            mixRowsEl.addEventListener('change', e => {
              const wrap = e.target.closest('.ldm-mix-row-wrap');
              if (!wrap || !e.target.dataset.act) return;
              const row = state.mix && state.mix[+wrap.dataset.idx];
              if (!row) return;
              const act = e.target.dataset.act;
              if (act === 'qty') row.qty = Math.min(99999, Math.max(50, parseInt(e.target.value) || 50));
              else if (act === 's') row.s = Math.max(0, parseInt(e.target.value) || 0);
              else if (act === 'xl') row.xl = Math.max(0, parseInt(e.target.value) || 0);
              clampRowSizes(row);
              /* patch this row in place — a full renderMix() here rebuilds the DOM between
                 blur and tap on iOS, swallowing the next tap and collapsing the keyboard */
              const reg = Math.max(0, row.qty - row.s - row.xl);
              const qEl = wrap.querySelector('[data-act="qty"]');
              const sEl2 = wrap.querySelector('[data-act="s"]');
              const xlEl2 = wrap.querySelector('[data-act="xl"]');
              const regEl2 = wrap.querySelector('input[readonly]');
              if (qEl) qEl.value = row.qty;
              if (sEl2) sEl2.value = row.s;
              if (xlEl2) xlEl2.value = row.xl;
              if (regEl2) regEl2.value = reg;
              if (mixTotalQtyEl) mixTotalQtyEl.textContent = `${mixTotal().toLocaleString()} beanies`;
              if (mixPreviewNoteEl && row.color === displayedColor()) mixPreviewNoteEl.textContent = `${row.qty.toLocaleString()} beanies in your order`;
              syncFromMix();
            });
          }

          function clampGlobalSizes() { state.sizes = { s: 0, xl: 0 }; }
          function renderGlobalSizes() {
            if (!sizeREl || !sizeXlEl) return;
            clampGlobalSizes();
            if (sizeSEl) sizeSEl.value = state.sizes.s;
            sizeXlEl.value = state.sizes.xl;
            sizeREl.value = Math.max(0, state.qty - state.sizes.s - state.sizes.xl);
          }
          function openGlobalSizes() {
            if (!sizesWrapEl || sizesWrapEl.classList.contains('expanded')) return;
            sizesWrapEl.classList.add('expanded');
            if (sizesToggleEl) sizesToggleEl.setAttribute('aria-expanded', 'true');
            const lbl = $('#ldm-sizes-toggle-label');
            if (lbl) lbl.textContent = 'Choose sizes';
          }
          if (sizesToggleEl) sizesToggleEl.onclick = () => {
            const expanding = !sizesWrapEl.classList.contains('expanded');
            sizesWrapEl.classList.toggle('expanded', expanding);
            sizesToggleEl.setAttribute('aria-expanded', String(expanding));
            const lbl = $('#ldm-sizes-toggle-label');
            if (lbl) lbl.textContent = 'Choose sizes';
            if (expanding) renderGlobalSizes();
          };
          if (sizeSEl) sizeSEl.onchange = () => { state.sizes.s = Math.max(0, parseInt(sizeSEl.value) || 0); renderGlobalSizes(); updatePricing(); };
          if (sizeXlEl) sizeXlEl.onchange = () => { state.sizes.xl = Math.max(0, parseInt(sizeXlEl.value) || 0); renderGlobalSizes(); updatePricing(); };

          /* Regular recalculates whenever quantity changes */
          const _mixPrevUpdatePricing = updatePricing;
          updatePricing = function() { _mixPrevUpdatePricing(); renderGlobalSizes(); updateLeadTime(); };

          /* ========== LEAD FORM (inline) ==========
             Same design + backend contract as Lead Form/design.liquid:
             Attio via Zapier (urlencoded), upload-lead-assets (base64 JSON),
             send-wholesale-email (business awaited + customer fire-and-forget),
             honeypot + 3s timing gate + spam heuristic (all silent success).
             Adds: shares the visitor's configurator design via saveDesignToCloud. */
          (function leadForm() {
            const panel = $('#ldm-lead-inline');
            const openBtn = $('#ldm-lead-open');
            if (!panel || !openBtn) return;

            const ATTIO_WEBHOOK_URL = 'https://hooks.zapier.com/hooks/catch/7650002/upe8j3n/';
            const UPLOAD_URL = EMAIL_URL.replace('send-wholesale-email', 'upload-lead-assets');
            const BUSINESS_EMAIL = 'wholesale@liftdown.com';
            const LEAD_MIME = { pdf:'application/pdf', jpg:'image/jpeg', jpeg:'image/jpeg', png:'image/png', webp:'image/webp', svg:'image/svg+xml', ai:'application/illustrator', eps:'application/postscript' };
            const LEAD_MAX_FILES = 6;
            const LEAD_MAX_FILE_BYTES = 4 * 1024 * 1024;
            const LEAD_MAX_TOTAL_BYTES = 4 * 1024 * 1024;

            const form = $('#ldm-lead-form');
            const successEl = $('#ldm-lead-success');
            const errorEl = $('#ldm-lead-error');
            const submitBtn = $('#ldm-lead-submit');
            const noteEl = $('#ldm-lead-note');
            const includeEl = $('#ldm-lead-include');
            const dropzone = $('#ldm-lead-dropzone');
            const fileInput = $('#ldm-lead-files');
            const fileList = $('#ldm-lead-file-list');

            let leadFiles = [];
            let modalOpenedAt = 0;
            let leadFired = false;

            function leadShowError(msg) {
              errorEl.textContent = msg;
              errorEl.classList.add('show');
              errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            function leadHideError() { errorEl.classList.remove('show'); }

            function qtyRange(q) {
              if (q >= 1000) return '1,000+';
              if (q >= 500) return '500-1,000';
              if (q >= 250) return '250-500';
              if (q >= 100) return '100-250';
              return '50-100';
            }

            function openLead() {
              if (!modalOpenedAt) modalOpenedAt = Date.now(); /* first open only — reopen+quick submit must not trip the spam gate */
              form.classList.remove('hidden');
              successEl.classList.remove('show');
              leadHideError();
              const sides = getDesignSides();
              if (sides.length) {
                noteEl.style.display = '';
              } else {
                noteEl.style.display = 'none';
              }
              const knownEmail = (($('#ldm-order-email') || {}).value || ($('#ldm-save-email') || {}).value || '').trim();
              const emailField = $('#ldm-lead-email');
              if (knownEmail && !emailField.value) emailField.value = knownEmail;
              const qtySel = $('#ldm-lead-quantity');
              if (!qtySel.value) qtySel.value = qtyRange(state.qty);
              panel.hidden = false;
              openBtn.setAttribute('aria-expanded', 'true');
              panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (!window.matchMedia('(pointer: coarse)').matches) {
                setTimeout(() => $('#ldm-lead-name').focus({ preventScroll: true }), 350);
              }
              trackEvent('LeadFormOpened', { has_design: sides.length > 0 });
            }
            function closeLead() {
              panel.hidden = true;
              openBtn.setAttribute('aria-expanded', 'false');
            }

            openBtn.addEventListener('click', e => { e.preventDefault(); if (panel.hidden) openLead(); else closeLead(); });
            $('#ldm-lead-close').addEventListener('click', closeLead);

            /* ---- attachments ---- */
            function leadTotalBytes() { return leadFiles.reduce((a, f) => a + f.size, 0); }
            function fmtSize(b) { return b < 1024 * 1024 ? Math.round(b / 1024) + ' KB' : (b / 1024 / 1024).toFixed(1) + ' MB'; }
            function renderLeadFiles() {
              fileList.innerHTML = '';
              leadFiles.forEach((f, i) => {
                const li = document.createElement('li');
                li.className = 'ldm-lead-file-item';
                li.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/><polyline points="13 2 13 9 20 9"/></svg>` +
                  `<span class="ldm-lead-file-name">${esc(f.name)}</span><span class="ldm-lead-file-size">${fmtSize(f.size)}</span>` +
                  `<button type="button" class="ldm-lead-file-remove" data-i="${i}" aria-label="Remove ${esc(f.name)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>`;
                fileList.appendChild(li);
              });
            }
            fileList.addEventListener('click', e => {
              const btn = e.target.closest('.ldm-lead-file-remove');
              if (!btn) return;
              leadFiles.splice(+btn.dataset.i, 1);
              renderLeadFiles();
            });
            function addLeadFiles(list) {
              leadHideError();
              for (const file of list) {
                const ext = (file.name.split('.').pop() || '').toLowerCase();
                if (!LEAD_MIME[ext]) { leadShowError(`"${file.name}" isn't a supported type. Use PDF, JPG, PNG, SVG, AI, or EPS.`); continue; }
                if (file.size > LEAD_MAX_FILE_BYTES) { leadShowError(`"${file.name}" is over the ${fmtSize(LEAD_MAX_FILE_BYTES)} per-file limit. Email it to ${BUSINESS_EMAIL}.`); continue; }
                if (leadFiles.some(f => f.name === file.name && f.size === file.size)) continue;
                if (leadFiles.length >= LEAD_MAX_FILES) { leadShowError(`You can attach up to ${LEAD_MAX_FILES} files.`); break; }
                if (leadTotalBytes() + file.size > LEAD_MAX_TOTAL_BYTES) { leadShowError('Attachments exceed the 4.0 MB total limit.'); break; }
                leadFiles.push(file);
              }
              renderLeadFiles();
            }
            dropzone.addEventListener('click', () => fileInput.click());
            dropzone.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
            ['dragenter', 'dragover'].forEach(ev => dropzone.addEventListener(ev, e => { e.preventDefault(); dropzone.classList.add('dragover'); }));
            ['dragleave', 'drop'].forEach(ev => dropzone.addEventListener(ev, e => { e.preventDefault(); dropzone.classList.remove('dragover'); }));
            dropzone.addEventListener('drop', e => addLeadFiles(e.dataTransfer.files));
            fileInput.addEventListener('change', () => { addLeadFiles(fileInput.files); fileInput.value = ''; });

            function readFileAsAttachment(file) {
              return new Promise((resolve, reject) => {
                const fr = new FileReader();
                fr.onerror = reject;
                fr.onload = () => {
                  const ext = (file.name.split('.').pop() || '').toLowerCase();
                  resolve({ filename: file.name, content: String(fr.result).split(',')[1] || '', contentType: LEAD_MIME[ext] || 'application/octet-stream' });
                };
                fr.readAsDataURL(file);
              });
            }
            async function uploadLeadAssets(fileObjs) {
              try {
                const encoded = await ldRunPreparation(async (ldCheckPreparation) => { const value = await Promise.all(fileObjs.map(f => readFileAsAttachment(f).catch(() => null))); ldCheckPreparation(); return value; });
                const payload = encoded.filter(Boolean);
                if (!payload.length) return [];
                const { resp, data } = await ldFetchWithDeadline(UPLOAD_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ files: payload }) }, LD_INQUIRY_UPLOAD_TIMEOUT_MS, 'success-json');
                if (!resp.ok) return [];
                
                return Array.isArray(data.files) ? data.files : [];
              } catch (e) { return []; }
            }

            /* ---- anti-spam (same gates as the lead page) ---- */
            function leadIsSpam(txt) {
              return String(txt || '').split(/\s+/).some(w => {
                if (w.length < 14) return false;
                let t = 0;
                for (let i = 1; i < w.length; i++) { if (/[a-z]/.test(w[i - 1]) && /[A-Z]/.test(w[i])) t++; }
                return t >= 4;
              });
            }
            function fakeSuccess() { form.classList.add('hidden'); successEl.classList.add('show'); }

            function sendToAttio(lead, design) {
              if (!ATTIO_WEBHOOK_URL) return;
              const nameParts = (lead.fullname || '').trim().split(/\s+/);
              const params = new URLSearchParams();
              params.append('name', lead.fullname);
              params.append('first_name', nameParts.shift() || '');
              params.append('last_name', nameParts.join(' '));
              params.append('email', lead.email);
              params.append('company', lead.company);
              params.append('quantity', lead.quantity);
              params.append('message', lead.message || '');
              params.append('source', 'Custom Beanie Configurator');
              params.append('page', window.location.pathname);
              params.append('submitted_at', new Date().toISOString());
              params.append('page_url', window.location.href);
              params.append('attachment_count', String(leadFiles.length));
              params.append('attachment_names', leadFiles.map(f => f.name).join(', '));
              if (design) {
                params.append('design_id', design.id || '');
                params.append('design_url', design.url || '');
                params.append('design_summary', design.summary || '');
              }
              fetch(ATTIO_WEBHOOK_URL, { method: 'POST', body: params }).catch(() => {});
            }

            form.addEventListener('submit', async e => {
              e.preventDefault();
              leadHideError();

              /* silent gates: honeypot, timing, spam heuristic */
              if ($('#ldm-lead-website').value || Date.now() - modalOpenedAt < 3000) { fakeSuccess(); return; }

              const data = {
                fullname: $('#ldm-lead-name').value.trim(),
                email: $('#ldm-lead-email').value.trim(),
                company: $('#ldm-lead-company').value.trim(),
                quantity: $('#ldm-lead-quantity').value,
                message: $('#ldm-lead-message').value.trim()
              };
              if (!data.fullname) { leadShowError('Please enter your name.'); return; }
              if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) { leadShowError('Please enter a valid email address.'); return; }
              if (!data.company) { leadShowError('Please enter your company name.'); return; }
              if (!data.quantity) { leadShowError('Please select a quantity range.'); return; }
              if (leadIsSpam(data.fullname + ' ' + data.company + ' ' + data.message)) { fakeSuccess(); return; }

              submitBtn.classList.add('loading');
              submitBtn.disabled = true;

              try {
                /* 1 · save + share their configurator design, if any and opted in */
                let design = null;
                const sides = getDesignSides();
                if (sides.length && includeEl.checked) {
                  try {
                    const saved = await saveDesignToCloud(data.email.toLowerCase(), null);
                    design = {
                      id: saved.id, url: saved.url,
                      summary: `${orderColorLabel()} | ${state.qty} beanies (${sizesLabel()}) | ${sides.join(' + ')} | ${formatMoney(getBase(state.qty) + Math.max(1, sides.length) * EMB_PRICE)}/beanie`
                    };
                  } catch (err) { console.warn('[lead] design share skipped:', err); 
if (ldThreadHasOverrides()) throw new Error('Your thread-color choices could not be saved. Your design is still here; please try again.');
}
                }

                /* 2 · CRM + pixel before the email round-trip so attribution survives failures */
                const metaEventId = (crypto.randomUUID && crypto.randomUUID()) || genEventId('lead');
                sendToAttio(data, design);
                if (!leadFired && typeof fbq === 'function') {
                  leadFired = true;
                  try { fbq('track', 'Lead', { content_name: 'Design Inquiry', content_category: 'B2B' }, { eventID: metaEventId }); } catch (err) {}
                }

                /* 3 · artwork upload (links, not attachments) */
                const uploaded = leadFiles.length ? await uploadLeadAssets(leadFiles) : [];

                /* 4 · business email (awaited) + customer auto-reply */
                const firstName = data.fullname.trim().split(/\s+/)[0] || '';
                const _r = (l, v) => `<tr><td style="padding:8px 0;color:#6b7280;font-size:14px;vertical-align:top;">${l}</td><td style="padding:8px 0;font-weight:600;font-size:14px;">${v}</td></tr>`;
                const artworkHtml = uploaded.length
                  ? _r('Artwork:', uploaded.map(f => `<a href="${f.url}" style="color:#30413B;">${esc(f.filename)}</a>`).join('<br>'))
                  : (leadFiles.length ? _r('Artwork:', esc(leadFiles.map(f => f.name).join(', ')) + ' (upload failed, ask customer to resend)') : '');
                const designHtml = design
                  ? _r('Design:', `<a href="${design.url}" style="color:#30413B;font-weight:700;">${esc(design.id)}</a><br><span style="font-weight:400;color:#374151;">${esc(design.summary)}</span>`)
                  : '';
                const businessEmailHtml = `<div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;max-width:560px;margin:0 auto;color:#1a1a1a;"><h1 style="font-size:20px;font-weight:600;margin:16px 0 4px;">New design inquiry (configurator)</h1><p style="color:#6b7280;font-size:13px;margin:0 0 20px;">Submitted from the custom beanie configurator.</p><table style="width:100%;border-collapse:collapse;">${_r('Name:', esc(data.fullname))}${_r('Email:', `<a href="mailto:${esc(data.email)}" style="color:#30413B;">${esc(data.email)}</a>`)}${_r('Company:', esc(data.company))}${_r('Quantity range:', esc(data.quantity))}${_r('Configured qty:', `${state.qty} beanies (${esc(sizesLabel())})`)}${data.message ? _r('Message:', esc(data.message).replace(/\n/g, '<br>')) : ''}${designHtml}${artworkHtml}</table><p style="color:#9ca3af;font-size:12px;margin-top:24px;">${new Date().toLocaleString()} &middot; ${esc(window.location.pathname)}</p></div>`;

                const businessResp = await ldFetchWithDeadline(EMAIL_URL, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    to: BUSINESS_EMAIL,
                    replyTo: data.email,
                    subject: 'Design Inquiry - ' + data.company + ' (' + data.quantity + ')',
                    html: businessEmailHtml,
                    attachments: [],
                    _hp: $('#ldm-lead-website').value,
                    _loadedAt: modalOpenedAt,
                    meta: {
                      event_id: metaEventId,
                      event_source_url: window.location.href,
                      fbp: getFbp(),
                      fbc: getFbc(),
                      email: data.email,
                      first_name: firstName,
                      last_name: data.fullname.trim().split(/\s+/).slice(1).join(' ')
                    }
                  })
                }, LD_INQUIRY_REQUEST_TIMEOUT_MS, 'response').then(({ resp }) => resp);
                if (!businessResp.ok) throw new Error('Failed to submit');

                const customerEmailHtml = `<div style="font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;max-width:560px;margin:0 auto;color:#1a1a1a;"><h1 style="font-size:20px;font-weight:600;margin:16px 0 8px;">We received your inquiry</h1><p style="color:#374151;font-size:14px;line-height:1.6;margin:0 0 16px;">Thanks ${esc(firstName)} &mdash; a team member will reply shortly, usually within 30 minutes.</p>${design ? `<p style="margin:0 0 16px;"><a href="${design.url}" style="display:inline-block;background:#f3f4f6;color:#1a1a1a;padding:10px 20px;text-decoration:none;border-radius:4px;font-weight:500;font-size:14px;border:1px solid #e5e7eb;">View your design</a></p>` : ''}<p style="color:#6b7280;font-size:13px;text-align:center;margin-top:24px;">Lift Down | Premium Headwear<br><a href="https://liftdown.com" style="color:#304130;text-decoration:none;">liftdown.com</a></p></div>`;
                fetch(EMAIL_URL, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    to: data.email,
                    replyTo: BUSINESS_EMAIL,
                    subject: 'We received your inquiry - Lift Down',
                    html: customerEmailHtml,
                    attachments: [],
                    _hp: $('#ldm-lead-website').value,
                    _loadedAt: modalOpenedAt
                  })
                }).catch(() => {});

                if (typeof gtag === 'function') {
                  try { gtag('event', 'conversion', { 'send_to': 'AW-726239329/cw38CM2gk98bEOGQptoC', 'value': 50.0, 'currency': 'USD' }); } catch (err) {}
                }
                form.classList.add('hidden');
                successEl.classList.add('show');
              } catch (err) {
                console.error('[lead] submit failed:', err);
                leadShowError('Something went wrong. Please try again or email us directly.');
              } finally {
                submitBtn.classList.remove('loading');
                submitBtn.disabled = false;
              }
            });
          })();

          /* Escape closes the color-preview bubble. */
          document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeColorPreview();
          });

          /* ========== COLOR PREVIEW BUBBLE ========== */
          const colorPreviewEl = $('#ldm-color-preview');
          const colorPreviewImg = $('#ldm-color-preview-img');
          const colorPreviewLoading = $('#ldm-color-preview-loading');
          const cpLabelEl = $('#ldm-cp-label');
          const cpPrevBtn = $('#ldm-cp-prev');
          const cpNextBtn = $('#ldm-cp-next');

          /* Token lets us ignore slow mockup generations if the user opens another color
             or closes the bubble before the first render finishes. */
          let _colorPreviewToken = 0;
          /* Tracks which sides are flippable for the current bubble + which one is showing */
          let _previewState = { color: '', sides: [], idx: 0 };

          async function openColorPreview(color, triggerEl) {
            if (!colorPreviewEl || !color) return;

            /* Move to <body> once so position:absolute escapes any ancestor
               with `transform` (Shopify themes often apply one to sections,
               which would otherwise anchor the bubble to the wrong origin). */
            if (colorPreviewEl.parentNode !== document.body) {
              document.body.appendChild(colorPreviewEl);
            }

            /* Position the bubble just below the trigger link, clamped to the viewport */
            if (triggerEl) {
              const rect = triggerEl.getBoundingClientRect();
              const sx = window.pageXOffset || 0;
              const sy = window.pageYOffset || 0;
              const vw = document.documentElement.clientWidth;
              const popW = Math.min(340, vw - 24);
              let left = rect.left + sx;
              const maxLeft = sx + vw - popW - 12;
              if (left > maxLeft) left = maxLeft;
              if (left < sx + 12) left = sx + 12;
              const top = rect.bottom + sy + 8;
              /* Transform origin anchors the "grow" animation back to the link */
              const originX = Math.max(8, Math.min(popW - 8, (rect.left + sx - left) + rect.width / 2));
              colorPreviewEl.style.left = left + 'px';
              colorPreviewEl.style.top = top + 'px';
              colorPreviewEl.style.transformOrigin = originX + 'px -8px';
            }

            /* Sides with designs drive the flippable list. If none, fall back to the
               currently active side so the bubble still has something to render. Front
               is preferred as the initial view when it's in the set. */
            const designSides = getDesignSides();
            const sides = designSides.length ? designSides : [state.side || 'Front'];
            let idx = sides.indexOf('Front');
            if (idx < 0) idx = 0;
            _previewState = { color, sides, idx };
            /* .has-multi gates the visibility of the arrows + label */
            colorPreviewEl.classList.toggle('has-multi', sides.length > 1);

            colorPreviewEl.classList.add('show');
            await renderPreviewSide();
          }

          async function renderPreviewSide(silent) {
            const { color, sides, idx } = _previewState;
            if (!color || !sides.length) return;
            const side = sides[idx];
            const myToken = ++_colorPreviewToken;

            if (cpLabelEl) cpLabelEl.textContent = side;
            /* For arrow flips we keep the previous image visible while the next one
               generates+decodes — eliminates the blank/loading flash between sides. */
            if (!silent) {
              if (colorPreviewImg) { colorPreviewImg.style.display = 'none'; }
              if (colorPreviewLoading) { colorPreviewLoading.style.display = 'block'; colorPreviewLoading.textContent = 'Generating preview…'; }
            }

            let src = null;
            let isRaw = false;
            try {
              const hasDesign = state.designs[side] && state.designs[side].data;
              if (hasDesign) {
                /* pad > 1 crops out the source image's built-in whitespace so the cap fills the bubble */
                src = await captureMockup(side, color, { width: 800, mimeType: 'image/png', pad: 1.2, caption: false });
              }
              if (!src) {
                const capData = imageFor(color, side);
                src = capData && capData.url ? capData.url : null;
                isRaw = !!src;
              }
            } catch (err) {
              console.error('[color preview] generation failed:', err);
            }

            /* Another open/close/flip happened while we awaited — abandon this render */
            if (myToken !== _colorPreviewToken) return;

            if (!src) {
              if (colorPreviewLoading) { colorPreviewLoading.style.display = ''; colorPreviewLoading.textContent = 'No preview available.'; }
              return;
            }

            /* Preload the new src off-DOM, then atomically swap into the visible img.
               This lets the browser fully decode the bitmap before any pixel changes,
               so there's no flash of blank or partially-rendered frame on flip. */
            const probe = new Image();
            probe.onload = () => {
              if (myToken !== _colorPreviewToken) return;
              colorPreviewImg.classList.toggle('is-raw', isRaw);
              colorPreviewImg.src = src;
              colorPreviewImg.style.display = '';
              if (colorPreviewLoading) colorPreviewLoading.style.display = 'none';
            };
            probe.onerror = () => {
              if (myToken !== _colorPreviewToken) return;
              if (colorPreviewLoading) { colorPreviewLoading.style.display = ''; colorPreviewLoading.textContent = 'Couldn\'t load preview.'; }
            };
            probe.src = src;
          }

          if (cpPrevBtn) cpPrevBtn.onclick = (e) => {
            e.stopPropagation();
            const s = _previewState;
            if (!s.sides.length) return;
            s.idx = (s.idx - 1 + s.sides.length) % s.sides.length;
            renderPreviewSide(true);
          };
          if (cpNextBtn) cpNextBtn.onclick = (e) => {
            e.stopPropagation();
            const s = _previewState;
            if (!s.sides.length) return;
            s.idx = (s.idx + 1) % s.sides.length;
            renderPreviewSide(true);
          };

          function closeColorPreview() {
            if (!colorPreviewEl) return;
            _colorPreviewToken++; /* invalidate any in-flight render */
            colorPreviewEl.classList.remove('show');
            if (colorPreviewImg) { colorPreviewImg.src = ''; colorPreviewImg.style.display = 'none'; }
          }

          /* Click anywhere outside the bubble closes it. With multi-color split removed
             the bubble has no remaining trigger surface in the configurator (it was only
             reached via the per-row "See this color" link), but the rest of the bubble
             machinery is left in place for any future reuse. */
          document.addEventListener('click', (e) => {
            if (!colorPreviewEl || !colorPreviewEl.classList.contains('show')) return;
            if (colorPreviewEl.contains(e.target)) return;
            closeColorPreview();
          });
          /* Keep the bubble anchored to the link if the user scrolls/resizes while it's open */
          const _reanchorPreview = () => { if (colorPreviewEl && colorPreviewEl.classList.contains('show')) closeColorPreview(); };
          window.addEventListener('scroll', _reanchorPreview, { passive: true });
          window.addEventListener('resize', _reanchorPreview);
          if (colorPreviewEl) {
            /* Clicks inside the bubble shouldn't bubble up and close it */
            colorPreviewEl.addEventListener('click', (e) => e.stopPropagation());
          }

          document.addEventListener('keydown', e => {
            if (e.key === 'Escape') modal.classList.remove('show');
          });

          const breakdownLink = $('#ldm-breakdown-link');
          const shippingLink = $('#ldm-shipping-link');
          const shippingTooltipEl = $('#ldm-shipping-tooltip');
          function setSummaryDisclosure(trigger, panel, open) {
            panel.classList.toggle('show', open);
            trigger.setAttribute('aria-expanded', String(open));
          }
          breakdownLink.onclick = e => {
            e.preventDefault();
            setSummaryDisclosure(breakdownLink, breakdownEl, !breakdownEl.classList.contains('show'));
          };
          shippingLink.onclick = e => {
            e.preventDefault();
            setSummaryDisclosure(shippingLink, shippingTooltipEl, !shippingTooltipEl.classList.contains('show'));
          };
          document.onclick = e => {
            if(!e.target.closest('#ldm-breakdown-link') && !e.target.closest('#ldm-breakdown')) setSummaryDisclosure(breakdownLink, breakdownEl, false);
            if(!e.target.closest('#ldm-shipping-link') && !e.target.closest('#ldm-shipping-tooltip')) setSummaryDisclosure(shippingLink, shippingTooltipEl, false);
          };
          document.addEventListener('keydown', e => {
            if (e.key !== 'Escape') return;
            setSummaryDisclosure(breakdownLink, breakdownEl, false);
            setSummaryDisclosure(shippingLink, shippingTooltipEl, false);
          });

          function showError(msg) { errorEl.textContent=msg; errorEl.classList.add('show'); }
          function hideError() { errorEl.classList.remove('show'); }

          /* ========== BACKGROUND REMOVAL (Hybrid: color-key + AI) ========== */
          let _bgModel = null;
          let _bgProcessor = null;
          let _bgModelPromise = null;
          let _bgDevice = 'wasm';

          /* Load RMBG-1.4 once, preferring WebGPU (fp16, ~10-20x faster inference) and
             falling back to quantized q8 WASM (~11MB download vs 44MB fp32, ~2x faster CPU).
             Kicked off in the background right after a raster upload so the weights are
             usually cached by the time the user clicks "Remove background". */
          function ensureBgModel() {
            if (_bgModelPromise) return _bgModelPromise;
            _bgModelPromise = (async () => {
              const { AutoModel, AutoProcessor, env, RawImage } = await import('https://cdn.jsdelivr.net/npm/@huggingface/transformers@3.4.1/+esm');
              env.allowLocalModels = false;
              let webgpu = false;
              try { webgpu = !!(navigator.gpu && await navigator.gpu.requestAdapter()); } catch (e) {}
              const attempts = webgpu
                ? [{ device: 'webgpu', dtype: 'fp16' }, { dtype: 'q8' }]
                : [{ dtype: 'q8' }, {}];
              let lastErr = null;
              for (const opts of attempts) {
                try {
                  const [model, processor] = await Promise.all([
                    AutoModel.from_pretrained('briaai/RMBG-1.4', Object.assign({ config: { model_type: 'custom' } }, opts)),
                    AutoProcessor.from_pretrained('briaai/RMBG-1.4')
                  ]);
                  _bgModel = model;
                  _bgProcessor = processor;
                  _bgModel._RawImage = RawImage;
                  _bgDevice = opts.device || 'wasm';
                  return;
                } catch (e) { lastErr = e; console.warn('[bg] load attempt failed', opts, e); }
              }
              _bgModelPromise = null; /* allow a retry on the next click */
              throw lastErr;
            })();
            return _bgModelPromise;
          }
          function warmBgModel() {
            /* never burn ~12MB of AI weights on cellular data for users who may not use the feature */
            const c = navigator.connection;
            if (c && (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || ''))) return;
            const kick = () => { ensureBgModel().catch(() => {}); };
            if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 4000 });
            else setTimeout(kick, 1500);
          }

          /* RMBG-1.4 works at 1024px internally — feeding it anything bigger just wastes
             decode + resize time. Returns a downscaled copy for inference only. */
          async function bgInferenceSource(dataUrl) {
            const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = dataUrl; });
            const maxDim = Math.max(img.naturalWidth, img.naturalHeight);
            if (maxDim <= 1024) return dataUrl;
            const scale = 1024 / maxDim;
            const c = document.createElement('canvas');
            c.width = Math.round(img.naturalWidth * scale);
            c.height = Math.round(img.naturalHeight * scale);
            c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
            return c.toDataURL('image/png');
          }
          const removeBgBtn = $('#ldm-remove-bg');
          const removeBgText = $('#ldm-remove-bg-text');

          /**
           * Color-key removal: detects dominant edge color and removes it.
           * Works great for logos with solid-color backgrounds (black, white, etc.)
           * Returns a data URL with the background made transparent.
           */
          function colorKeyRemove(dataUrl, tolerance) {
            tolerance = tolerance || 60;
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => {
                const c = document.createElement('canvas');
                c.width = img.width; c.height = img.height;
                const ctx = c.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const px = ctx.getImageData(0, 0, c.width, c.height);
                const d = px.data;
                const w = c.width, h = c.height;

                /* Sample edge pixels (top, bottom, left, right rows) to find dominant bg color */
                const edgeSamples = [];
                for (let x = 0; x < w; x++) {
                  edgeSamples.push((0 * w + x) * 4);         /* top row */
                  edgeSamples.push(((h - 1) * w + x) * 4);   /* bottom row */
                }
                for (let y = 0; y < h; y++) {
                  edgeSamples.push((y * w + 0) * 4);          /* left col */
                  edgeSamples.push((y * w + (w - 1)) * 4);    /* right col */
                }

                /* Find most common edge color by bucketing into 16-step bins */
                const buckets = {};
                for (const idx of edgeSamples) {
                  const br = d[idx] >> 4, bg = d[idx+1] >> 4, bb = d[idx+2] >> 4;
                  const key = `${br},${bg},${bb}`;
                  buckets[key] = (buckets[key] || 0) + 1;
                }
                let bestKey = null, bestCount = 0;
                for (const [k, v] of Object.entries(buckets)) {
                  if (v > bestCount) { bestCount = v; bestKey = k; }
                }
                const [br, bg2, bb] = bestKey.split(',').map(n => (parseInt(n) << 4) + 8);

                /* Remove pixels close to the detected bg color */
                for (let i = 0; i < d.length; i += 4) {
                  const dr = d[i] - br, dg = d[i+1] - bg2, db = d[i+2] - bb;
                  const dist = Math.sqrt(dr*dr + dg*dg + db*db);
                  if (dist < tolerance) {
                    /* Fully transparent */
                    d[i+3] = 0;
                  } else if (dist < tolerance * 1.5) {
                    /* Soft edge: partial transparency for anti-aliasing */
                    const fade = (dist - tolerance) / (tolerance * 0.5);
                    d[i+3] = Math.round(d[i+3] * Math.min(1, fade));
                  }
                }

                ctx.putImageData(px, 0, 0);
                resolve(c.toDataURL('image/png'));
              };
              img.onerror = reject;
              img.src = dataUrl;
            });
          }

          /* metered users start the download on first touch of the button instead */
          if (removeBgBtn) removeBgBtn.addEventListener('pointerdown', () => { ensureBgModel().catch(() => {}); }, { once: true });
          if (removeBgBtn) {
            removeBgBtn.onclick = async () => {
              const d = state.designs[state.side];
              if (!d.data || d._bgRemoved) return;

              removeBgBtn.classList.add('processing');
              removeBgText.textContent = 'Removing background...';

              try {
                /* PASS 1: Color-key removal (instant, handles solid-color logo backgrounds) */
                let resultUrl = await colorKeyRemove(d.data, 60);

                /* PASS 2: AI removal for complex/photo backgrounds */
                if (!_bgModel) removeBgText.textContent = 'Loading AI model...';
                await ensureBgModel();
                removeBgText.textContent = 'Refining with AI...';

                const RawImage = _bgModel._RawImage;

                /* Run AI on the ORIGINAL image (not color-keyed) for the best mask,
                   downscaled to the model's native 1024px so huge uploads don't stall. */
                const aiImg = await RawImage.fromURL(await bgInferenceSource(d.data));
                const { pixel_values } = await _bgProcessor(aiImg);
                const { output } = await _bgModel({ input: pixel_values });

                /* PASS 3: Combine both at full resolution — the mask is upscaled to the
                   color-keyed canvas size, then we take the lower alpha of the two. */
                const combImg = await new Promise((resolve, reject) => {
                  const i = new Image();
                  i.onload = () => resolve(i);
                  i.onerror = reject;
                  i.src = resultUrl;
                });
                const finalCanvas = document.createElement('canvas');
                finalCanvas.width = combImg.naturalWidth;
                finalCanvas.height = combImg.naturalHeight;
                const fCtx = finalCanvas.getContext('2d', { willReadFrequently: true });
                const aiMask = await RawImage.fromTensor(output[0].mul(255).to('uint8')).resize(finalCanvas.width, finalCanvas.height);
                /* Draw color-keyed result (already has transparency from pass 1) */
                fCtx.drawImage(combImg, 0, 0);
                const pxData = fCtx.getImageData(0, 0, finalCanvas.width, finalCanvas.height);
                const px = pxData.data;
                for (let i = 0; i < aiMask.data.length; i++) {
                  px[4 * i + 3] = Math.min(px[4 * i + 3], aiMask.data[i]);
                }
                fCtx.putImageData(pxData, 0, 0);
                const newDataUrl = finalCanvas.toDataURL('image/png');

                /* Update state */
                d.data = newDataUrl;
                (d._bgRemoved = true, d.threadSource = newDataUrl, d.defaultTint = null, window.LiftDownThreadColors.clear(d));
                d._fullBase = null; d._fullEdited = null; d._fullEditedImg = null; d._cropRect = null; d._tint = null; /* new edit baseline */
                _lastSavedHash = null;

                /* Swap the logo src directly (avoid full updateStage which can cause flicker) */
                void ldCapThreadPreview(d, displayedColor());
                logo.classList.add('active', 'selected');
                updateUploadUI();
                removeBgBtn.classList.remove('processing');
                removeBgBtn.classList.add('done');
                removeBgText.textContent = 'Background removed ✓';
                trackEvent('BackgroundRemoved', { side: state.side });

              } catch (e) {
                console.error('Background removal failed:', e);
                removeBgBtn.classList.remove('processing');
                removeBgText.textContent = 'Remove background';
                showError('Background removal failed — please try again.');
              }
            };
          }

          /* ========== SHARE DESIGN ========== */
          function showShareToast(msg) {
            shareToast.textContent = msg || 'Link copied to clipboard!';
            shareToast.classList.add('show');
            setTimeout(() => shareToast.classList.remove('show'), 2500);
          }

          /* ========== MOBILE SWIPE FOR PREVIEW ========== */
          let previewSwipeStart = null;
          const VIEWS = ['Front'];
          stageEl.addEventListener('touchstart', e => {
            if (e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') || e.target.closest('.ldm-logo') || e.target.closest('.ldm-inline-text') || e.target.closest('.ldm-stage-btns')) return;
            previewSwipeStart = { x: e.changedTouches[0].screenX, y: e.changedTouches[0].screenY };
          }, { passive: true });
          stageEl.addEventListener('touchend', e => {
            if (e.target.closest('.ldm-artwork-controls, .ldm-thread-trigger--stage') || e.target.closest('.ldm-logo') || e.target.closest('.ldm-inline-text') || e.target.closest('.ldm-stage-btns')) return;
            if (!previewSwipeStart) return;
            const t = e.changedTouches[0];
            const diff = previewSwipeStart.x - t.screenX;
            const dy = Math.abs(previewSwipeStart.y - t.screenY);
            previewSwipeStart = null;
            /* require horizontal dominance so vertical page scrolls never flip the view */
            if (Math.abs(diff) < 50 || Math.abs(diff) < dy * 1.5) return;
            const currentIdx = VIEWS.indexOf(state.side);
            if (diff > 0) {
              state.side = VIEWS[(currentIdx + 1) % VIEWS.length];
            } else {
              state.side = VIEWS[(currentIdx - 1 + VIEWS.length) % VIEWS.length];
            }
            syncInlineTextForSide();
            syncViewBtns(); renderTabs(); updateStage(); updateUploadUI();
          }, { passive: true });

          /* ========== SAVE DESIGN ========== */
          const saveForm = $('#ldm-save-form');
          const saveEmailInput = $('#ldm-save-email');
          const saveSubmit = $('#ldm-save-submit');
          const saveSuccess = $('#ldm-save-success');
          const saveError = $('#ldm-save-error');
          const saveLinkResult = $('#ldm-save-link-result');
          const saveLinkUrl = $('#ldm-save-link-url');
          const copyLinkBtn = $('#ldm-copy-link-btn');

          /* Copy link button (shown after save) */
          if (copyLinkBtn) {
            copyLinkBtn.onclick = () => {
              const url = saveLinkUrl?.value;
              if (!url) return;
              navigator.clipboard.writeText(url).then(() => {
                copyLinkBtn.textContent = 'Copied!';
                showShareToast('Design link copied — share it with your team!');
                setTimeout(() => { copyLinkBtn.textContent = 'Copy link'; }, 2500);
              });
            };
          }

          /* Compress a data URL for cloud save (keeps payload under Netlify 1MB limit) */
          function compressForSave(dataUrl, maxDim = 700) {
            return new Promise(resolve => {
              if (!dataUrl) { resolve(null); return; }
              const img = new Image();
              img.onload = () => {
                if (img.width <= maxDim && img.height <= maxDim && dataUrl.length < 150000) {
                  resolve(dataUrl); return;
                }
                const c = document.createElement('canvas');
                const s = Math.min(maxDim / img.width, maxDim / img.height, 1);
                c.width = Math.round(img.width * s);
                c.height = Math.round(img.height * s);
                const ctx = c.getContext('2d');
                ctx.drawImage(img, 0, 0, c.width, c.height);
                /* PNG preserves transparency for logos with removed backgrounds, but is
                   5-10× larger than JPEG for opaque imagery. Sample the alpha channel and
                   pick the smaller-on-disk format. CORS-tainted canvas throws on getImageData;
                   fall back to PNG in that case to be safe. */
                let hasAlpha = false;
                try {
                  const px = ctx.getImageData(0, 0, c.width, c.height).data;
                  for (let i = 3; i < px.length; i += 4) {
                    if (px[i] < 255) { hasAlpha = true; break; }
                  }
                } catch (e) { hasAlpha = true; }
                resolve(hasAlpha ? c.toDataURL('image/png') : c.toDataURL('image/jpeg', 0.85));
              };
              img.onerror = () => resolve(dataUrl);
              img.src = dataUrl;
            });
          }

          function buildDesignUrl(designId, sig) {
            const base = window.location.origin + window.location.pathname.replace(/\/pages\/[^/]+\/?$/, '/pages/custom-beanie');
            /* Signature is required by load-design to prevent ID enumeration.
               Fallback to ID-only for legacy saves made before signing was live. */
            return base + '?design=' + encodeURIComponent(designId) + (sig ? '&sig=' + encodeURIComponent(sig) : '');
          }

          let _lastSavedId = null;
          let _lastSavedSig = null;
          let _lastSavedHash = null;
          let _lastSavedEmail = null; /* remembered across session for CAPI advanced matching at checkout */

          /* Internal-ops display copy: 1600px-long-edge JPEG (q0.82) sibling of a mockup
             capture. Best-effort only — the ops app string-transforms mockup URLs to find
             these and silently falls back to the original when absent. Never used in
             anything customer-facing. */
          function makeDispJpeg(dataUrl) {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.onload = () => {
                const long = Math.max(img.width, img.height);
                const s = Math.min(1, 1600 / long);
                const c = document.createElement('canvas');
                c.width = Math.max(1, Math.round(img.width * s));
                c.height = Math.max(1, Math.round(img.height * s));
                c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
                resolve(c.toDataURL('image/jpeg', 0.82));
              };
              img.onerror = reject;
              img.src = dataUrl;
            });
          }

          let _lastCloudMockups = null;

          /* Insert inside the configurator closure, immediately before stateHash. */
/* Insert inside the configurator closure, immediately before stateHash. */
/* Insert inside the configurator closure, immediately before stateHash. */
const ldThreadBitmapRecords = new WeakMap();
let ldThreadBitmapVersion = 0;
let ldThreadAutoSaveSequence = 0;

function ldThreadSelectedColors() {
  const colors = mixOn() ? state.mix.filter(row => row.qty > 0).map(row => row.color) : [state.color];
  return [...new Set(colors.filter(color => COLORS.includes(color)))];
}

function ldThreadHasOverrides() {
  return getDesignSides().some(side => {
    const d = state.designs[side];
    return Object.keys(window.LiftDownThreadColors.sanitizeMap(d.threadByColor, { colors: COLORS, mode: d.mode })).length > 0;
  });
}

function ldThreadBitmapKey(d) {
  const next = [d.data || '', d.threadSource || '', d._fullBase || '', JSON.stringify(d._cropRect || null), d.mode || 'file'];
  const prior = ldThreadBitmapRecords.get(d);
  if (prior && next.every((value, index) => value === prior.values[index])) return prior.version;
  const version = ++ldThreadBitmapVersion;
  ldThreadBitmapRecords.set(d, { values: next, version });
  return version;
}

function ldThreadFingerprint() {
  return JSON.stringify(getDesignSides().map(side => {
    const d = state.designs[side];
    const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
    return [side, ldThreadBitmapKey(d), metadata.threadByColor, metadata.defaultTint];
  }));
}

function ldThreadRestoreMetadata(d, saved, localSource, localData) {
  if (!saved || !Object.prototype.hasOwnProperty.call(saved, 'threadByColor')) return;
  const mode = saved.mode || d.mode || 'file';
  d.threadByColor = window.LiftDownThreadColors.sanitizeMap(saved.threadByColor, { colors: COLORS, mode });
  d.defaultTint = mode === 'text' ? null : window.LiftDownThreadColors.normalizeHex(saved.defaultTint);
  d.threadSource = mode === 'text' ? null : (typeof localSource === 'string' ? localSource : typeof saved.threadSource === 'string' ? saved.threadSource : null);
  if (mode !== 'text' && d.threadSource) {
    d._fullBase = d.threadSource;
    d._cropRect = null;
    d._tint = d.defaultTint;
    // Source and legacy display data may have different export resolutions. Crop
    // coordinates must always use source geometry, never the larger saved preview.
    d._fullEdited = d.threadSource;
    d._fullEditedImg = null;
    d._editSeq = (d._editSeq || 0) + 1;
    const source = d.threadSource;
    const editSequence = d._editSeq;
    const tint = d._tint;
    d._threadBaselineReady = (async () => {
      const baseline = tint ? await window.LiftDownThreadColors.render({ mode: 'file', data: source, threadSource: source, threadByColor: { baseline: tint } }, 'baseline') : source;
      if (d._fullBase === source && d._editSeq === editSequence) {
        d._fullEdited = baseline;
        d._fullEditedImg = null;
      }
      return baseline;
    })().catch(() => source);
  }
  window.LiftDownThreadColors.clear(d);
}

function ldThreadProps(color) {
  if (!ldThreadHasOverrides()) return {};
  const properties = {};
  for (const side of getDesignSides()) {
    const descriptor = window.LiftDownThreadColors.describe(state.designs[side], color);
    properties[side + ' Thread Color'] = descriptor.hex || 'Original colors';
  }
  return properties;
}

async function ldThreadFitRaster(source, maxWidth = 700) {
  if (typeof source !== 'string' || !source) throw new Error('Your thread-color preview could not be prepared. Please try again.');
  let result = await compressForSave(source, maxWidth);
  const bytes = value => Math.ceil(((value.split(',')[1] || '').length * 3) / 4);
  for (const width of [600, 480, 360]) {
    if (bytes(result) <= 1500000) break;
    result = await compressForSave(source, Math.min(maxWidth, width));
  }
  if (!/^data:image\/(png|jpeg|webp);base64,/i.test(result) || bytes(result) > 1500000) throw new Error('Your thread-color preview could not be saved. Please try a smaller artwork file.');
  return result;
}

async function ldThreadSavedMetadata(d) {
  const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
  if (d.mode !== 'text' && Object.keys(metadata.threadByColor).length) {
    metadata.threadSource = await ldThreadFitRaster(await window.LiftDownThreadColors.originalSource(d));
  } else {
    delete metadata.threadSource;
  }
  return metadata;
}

function ldThreadLocalMetadata(d) {
  const metadata = window.LiftDownThreadColors.metadata(d, { colors: COLORS });
  delete metadata.threadSource;
  return metadata;
}

async function ldThreadBuildAssets(sides) {
  const colors = ldThreadSelectedColors();
  if (!colors.length || !sides.length) throw new Error('Choose a cap color and add your design before saving.');
  const colorDesigns = {};
  // Sequential colors bound peak canvas/base64 memory on mobile.
  for (const color of colors) {
    colorDesigns[color] = {};
    for (const side of sides) colorDesigns[color][side] = await ldThreadFitRaster(await window.LiftDownThreadColors.render(state.designs[side], color));
  }
  return colorDesigns;
}

async function ldThreadSaveBody(payload, featureEnabled) {
  let body = JSON.stringify(payload);
  if (!featureEnabled) return body;
  const bytes = text => new TextEncoder().encode(text).byteLength;
  const rowBytes = () => bytes(JSON.stringify({ ...payload, assets: undefined }));
  // Keep original artwork and legacy design data; reduce only new preview
  // derivatives (and duplicate display mockups) when a large color mix needs it.
  for (const width of [600, 480, 360, 280, 220, 160]) {
    if (bytes(body) <= 5000000 && rowBytes() <= 3800000) break;
    for (const sides of Object.values(payload.assets.colorDesigns || {})) {
      for (const side of Object.keys(sides)) sides[side] = await compressForSave(sides[side], width);
    }
    for (const group of [payload.assets.mockups, payload.assets.mockupsDisp]) {
      for (const side of Object.keys(group || {})) group[side] = await compressForSave(group[side], Math.max(480, width));
    }
    for (const design of Object.values(payload.designs || {})) {
      if (design.threadSource) design.threadSource = await compressForSave(design.threadSource, width);
    }
    body = JSON.stringify(payload);
  }
  if (bytes(body) > 5000000 || rowBytes() > 3800000) throw new Error('This design is too large to save with all thread-color previews. Your design is still here; please use a smaller artwork file and try again.');
  return body;
}

function stateHash() {
            const sides = getDesignSides();
            const splitKey = state.mix
              ? JSON.stringify(state.mix.map(r => [r.color, r.qty, r.s, r.xl]))
              : (state.sizes.s || state.sizes.xl ? `S${state.sizes.s}XL${state.sizes.xl}` : '');
            /* Note is part of the fingerprint: editing it must trigger a real re-save,
               not a cache hit that silently drops it from the shared link. */
            const noteKey = (specialRequestsEl && specialRequestsEl.value || '').trim().slice(0, 500);
            return (state.color + '|' + state.qty + '|' + splitKey + '|' + noteKey + '|' + sides.join(',') + '|' +
              sides.map(s => {
                const d = state.designs[s];
                const p = d.placement || {};
                const t = d.textConfig || {};
                return (d.data || '').length + '@' +
                  [Math.round(p.x || 0), Math.round(p.y || 0), Math.round(p.w || 0), Math.round(p.r || 0)].join(',') +
                  '|' + (t.text || '') + (t.font || '') + (t.color || '') + (t.size || '') + (t.curve || '');
              }).join('|')) + (ldThreadHasOverrides() ? '|thread:' + ldThreadFingerprint() : '');
          }

          
  const LD_SAVE_REQUEST_TIMEOUT_MS = 100000;
  const LD_CHECKOUT_REQUEST_TIMEOUT_MS = 70000;
  const LD_PREPARATION_TIMEOUT_MS = 30000;
  const LD_LOAD_REQUEST_TIMEOUT_MS = 70000;
  const LD_INQUIRY_UPLOAD_TIMEOUT_MS = 100000;
  const LD_INQUIRY_REQUEST_TIMEOUT_MS = 70000;
  async function ldRunPreparation(work) {
    let expired = false;
    let timer;
    const check = () => {
      if (expired) throw new Error('Save timed out — please try again.');
    };
    try {
      return await Promise.race([
        Promise.resolve().then(() => work(check)),
        new Promise((resolve, reject) => {
          timer = setTimeout(() => {
            expired = true;
            reject(new Error('Save timed out — please try again.'));
          }, LD_PREPARATION_TIMEOUT_MS);
        })
      ]);
    } finally {
      clearTimeout(timer);
    }
  }
  async function ldFetchWithDeadline(url, options, timeoutMs, mode = 'json') {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    let bodyConsumed = false;
    try {
      const resp = await fetch(url, { ...options, signal: controller.signal });
      let data = null;
      if (mode === 'json' || (mode === 'success-json' && resp.ok)) {
        data = await resp.json();
        bodyConsumed = true;
      }
      return { resp, data };
    } finally {
      if (!bodyConsumed) controller.abort();
      clearTimeout(timer);
    }
  }
  async function ldFetchCheckout(options, timeoutMs = LD_CHECKOUT_REQUEST_TIMEOUT_MS, successOnly = false) {
    return ldFetchWithDeadline(NETLIFY_URL, options, timeoutMs, successOnly ? 'success-json' : 'json');
  }
async function saveDesignToCloud(email, fbContext) {
    const prepared = await ldRunPreparation(async (ldCheckPreparation) => {
            await prepareTextDesigns();
ldCheckPreparation();
const threadFeature = ldThreadHasOverrides();
            const hash = stateHash();
            if (_lastSavedId && _lastSavedHash === hash && !email) return { cached: { id: _lastSavedId, sig: _lastSavedSig, url: buildDesignUrl(_lastSavedId, _lastSavedSig) }, hash, threadFeature };

            const designPayload = {};
            const capW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85;
            for (const side of ['Front']) {
              const d = state.designs[side];
              if (d.data || (d.textConfig && d.textConfig.text.trim())) {
                designPayload[side] = ({ ...{
                  data: await compressForSave(d.data),
                  fileName: d.file?.name || null,
                  placement: { ...d.placement, wPctCap: (d.placement.w / capW) * 100 },
                  textConfig: d.textConfig,
                  mode: d.mode || 'file'
                }, ...(threadFeature ? await ldThreadSavedMetadata(d) : {}) });
              }
            }

            /* Generate mockup + original logo assets in parallel so the ops dashboard can show them.
             * Fire-and-forget semantics: if any side fails, we still save the design. */
            const sidesForAssets = getDesignSides();
            const cloudPreset = mockupPreset(sidesForAssets.length, 'cloud');
            const mockups = {};
            const originals = {};
            const mockupsDisp = {};
            const assetJobs = [];
            for (const side of sidesForAssets) {
              assetJobs.push((async () => {
                try {
                  const mk = await captureMockup(side, state.color, cloudPreset);
                  if (mk) {
                    mockups[side] = mk;
                    /* best-effort ops display sibling — never blocks the save, and skipped
                       entirely on slow/metered connections to keep save payloads lean
                       (the ops app falls back to the full mockup by design) */
                    const _c = navigator.connection;
                    if (!_c || (!_c.saveData && !/(^|-)2g|3g/.test(_c.effectiveType || ''))) {
                      try { mockupsDisp[side] = await makeDispJpeg(mk); } catch (e2) {}
                    }
                  }
                } catch (e) { console.error(`[save] mockup ${state.color}/${side} failed:`, e); }
              })());
            }
            /* Compress originals before saving — full-size base64 logos can easily exceed
               Netlify's 6MB body limit when multiple sides are uploaded. 1200px is plenty
               for the production team's reference (embroidery is far smaller anyway). */
            for (const side of sidesForAssets) {
              const d = state.designs[side];
              if (d?.data) assetJobs.push((async () => {
                originals[side] = await compressForSave(d.data, 1200);
              })());
            }
            await Promise.all(assetJobs);
ldCheckPreparation();
            _lastCloudMockups = { color: state.color, bySide: mockups };

            /* Serialize once; retry re-uses the exact same body. One automatic retry on
               timeout, network drop, or gateway hiccup rescues slow international uplinks
               (UK/AU) without the customer ever seeing an error. Definitive server answers
               (4xx and most 5xx) are NOT retried. */
            const colorDesigns = threadFeature ? await ldThreadBuildAssets(sidesForAssets) : null;
const saveBody = await ldThreadSaveBody({
              product_key: 'beanie',
              color: state.color,
              qty: state.qty,
              /* colorSplits is the key save-design.js already whitelists, persists to the
                 ops record, and forwards to Klaviyo — mix/sizes ride along for the day
                 the server whitelist learns about them (server change = Netlify deploy) */
              colorSplits: state.mix ? state.mix.map(r => ({ color: r.color, qty: r.qty })) : undefined,
              mix: state.mix ? state.mix.map(r => ({ color: r.color, qty: r.qty, s: r.s, xl: r.xl })) : undefined,
              sizes: state.sizes,
              specialRequests: (specialRequestsEl && specialRequestsEl.value || '').trim().slice(0, 500) || undefined,
              designs: designPayload,
              email: email || undefined,
              fb: fbContext || undefined,
              assets: { mockups, originals, mockupsDisp, ...(colorDesigns ? { colorDesigns } : {}) }
            }, threadFeature);
            
ldCheckPreparation();
return { saveBody, hash, threadFeature };
    });
    if (prepared.cached) return prepared.cached;
    const { saveBody, hash, threadFeature } = prepared;

    let resp = null;
    let result;
    let failureBody = '';
    for (let attempt = 1; attempt <= 2; attempt++) {
      if (threadFeature && stateHash() !== hash) throw new Error('Your design changed while its thread-color previews were being prepared. Please try saving again.');
      const saveController = new AbortController();
      const saveTimeout = setTimeout(() => saveController.abort(), LD_SAVE_REQUEST_TIMEOUT_MS);
      let responseReceived = false;
      let bodyConsumed = false;
      try {
        resp = await fetch(SAVE_DESIGN_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: saveController.signal, body: saveBody });
        responseReceived = true;
        if (resp.ok) {
          result = await resp.json();
          bodyConsumed = true;
          break;
        }
        if ([502, 503, 504].includes(resp.status) && attempt < 2) {
          console.warn(`[save-design] gateway ${resp.status}, retrying once`);
          continue;
        }
        try {
          failureBody = await resp.text();
          bodyConsumed = true;
        } catch (err) {
          if (err.name === 'AbortError') throw err;
          failureBody = '';
        }
        break;
      } catch (err) {
        const timedOut = err.name === 'AbortError';
        if (responseReceived && (!timedOut || !resp.ok)) {
          throw timedOut ? new Error('Save timed out — please try again.') : err;
        }
        resp = null;
        if (attempt === 2) throw timedOut ? new Error('Save timed out — please try again.') : err;
        console.warn('[save-design] attempt 1 failed, retrying once:', timedOut ? 'timeout' : err.message);
      } finally {
        if (!bodyConsumed) saveController.abort();
        clearTimeout(saveTimeout);
      }
    }
    if (!resp.ok) {
      const raw = failureBody;
      let serverMsg = '';
      try { serverMsg = JSON.parse(raw).error || raw; } catch { serverMsg = raw; }
      console.error('[save-design] failed:', resp.status, raw);
      throw new Error(`Save failed (${resp.status}): ${serverMsg || 'unknown error'}`);
    }

if (threadFeature && (!result.id || !result.sig)) throw new Error('Your thread-color choices could not be saved. Please try again.');
            _lastSavedId = result.id;
            _lastSavedSig = result.sig || null;
            _lastSavedHash = hash;
            return { id: result.id, sig: result.sig || null, url: buildDesignUrl(result.id, result.sig) };
          }

          async function sendSavedDesignEmail(payload) {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 15000);
            try {
              const response = await fetch(EMAIL_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                signal: controller.signal,
                body: JSON.stringify(payload)
              });
              const result = await response.json().catch(() => null);
              if (!response.ok || result?.success !== true) {
                throw new Error(`Saved-design email was not confirmed (${response.status})`);
              }
            } finally {
              clearTimeout(timeout);
            }
          }

          if (saveSubmit) {
            saveSubmit.onclick = async () => {
              if (!getDesignSides().length) {
                saveError.textContent = 'Please upload a design before saving.';
                saveError.classList.add('show');
                return;
              }
              const email = saveEmailInput.value.trim();
              /* Email is optional: blank saves the design and shows the shareable link, nothing is emailed. */
              if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                saveError.textContent = 'Please enter a valid email address.';
                saveError.classList.add('show');
                return;
              }

              saveError.classList.remove('show');
              saveSubmit.disabled = true;
              saveSubmit.textContent = 'Saving...';

              const procText = processing.querySelector('.ldm-processing-text');
              if (procText) procText.textContent = 'Saving your design';
              processing.classList.add('show');

              try {
                const sides = getDesignSides();
                const base = getBase(state.qty);
                const embLocs = sides.length;
                const emb = embLocs * EMB_PRICE;
                const per = base + emb;

                /* Prepare Meta Pixel + CAPI context up front so client events and server CAPI events share event_ids */
                const _saveEmail = email ? email.toLowerCase() : '';
                const fbEventId = genEventId('lead_save_design');
                const fbDesignSavedEventId = genEventId('ds_save_design');
                if (_saveEmail) {
                  _lastSavedEmail = _saveEmail;
                  /* Attach email to pixel BEFORE the track call so advanced matching includes it */
                  fbAdvancedInit(_saveEmail);
                }

                const fbContext = {
                  eventId: fbEventId,                    /* for Lead */
                  customEventId: fbDesignSavedEventId,   /* for DesignSaved custom event */
                  eventSourceUrl: location.href,
                  fbp: getFbp(),
                  fbc: getFbc(),
                  value: +(base * state.qty).toFixed(2),
                  currency: 'USD'
                };

                /* Save design to cloud first to get unique URL — server fires CAPI Lead with same event_id */
                const { url: link, id: designId, sig: designSig } = await saveDesignToCloud(email || null, fbContext);

                let savedEmailSent = false;
                if (_saveEmail) {
                const attachments = [];

                /* Email mockups: just the primary color × all designed sides (max 3 mockups).
                   Originals not attached — they live in Supabase via saveDesignToCloud above. */
                const emailPreset = mockupPreset(sides.length, 'email');
                const emailExt = extForMime(emailPreset.mimeType);
                await ldRunPreparation(async (ldCheckPreparation) => { for (const side of sides) {
                  try {
                    const mockupData = await captureMockup(side, state.color, emailPreset);
                    if (mockupData) {
                      attachments.push({
                        filename: `mockup-${side.toLowerCase()}-${state.color.replace(/\s+/g, '-').toLowerCase()}.${emailExt}`,
                        content: mockupData.split(',')[1],
                        contentType: emailPreset.mimeType
                      });
                    }
                  } catch (err) {
                    console.error(`Mockup failed for ${state.color}/${side}:`, err);
                  }
                } ldCheckPreparation(); });

                /* One line item per color (mirrors the checkout path so ops sees the same
                   structure whether the customer saves first or checks out directly). */
                const savedSpecialRequests = (specialRequestsEl && specialRequestsEl.value || '').trim();
                const savedBaseProps = {
                  'Turnaround': '4–6 weeks',
                  'Sample timing': '1–2 weeks',
                  'Production timing': '4 weeks after sample review',
                  'Embroidery Locations': sides.length ? sides.join(', ') : 'Front',
                  'Base Price': formatMoney(base),
                  'Embroidery Cost': formatMoney(emb),
                  'Source': 'Saved Design'
                };
                if (designId) savedBaseProps['Design #'] = designId;
                let savedLineItems;
                if (mixOn()) {
                  savedLineItems = state.mix.map((r, i) => ({
                    title: `${PRODUCT_NAME} - ${r.color}`,
                    quantity: r.qty,
                    price: per.toFixed(2),
                    taxable: false,
                    properties: Object.assign({ 'Color': r.color, 'Sizes': rowSizesLabel(r) }, savedBaseProps, ldThreadProps(r.color),
                      (i === 0 && savedSpecialRequests) ? { 'Special Requests': savedSpecialRequests.slice(0, 500) } : {})
                  }));
                } else {
                  const sp = Object.assign({ 'Color': state.color, 'Sizes': sizesLabel() }, savedBaseProps, ldThreadProps(state.color));
                  if (savedSpecialRequests) sp['Special Requests'] = savedSpecialRequests.slice(0, 500);
                  savedLineItems = [{
                    title: `${PRODUCT_NAME} - ${state.color}`,
                    quantity: state.qty,
                    price: per.toFixed(2),
                    taxable: false,
                    properties: sp
                  }];
                }
                const savedTags = designId ? [`design-${designId}`, 'custom-cap-saved'] : ['custom-cap-saved'];
                savedTags.push('custom-beanie');
                if (mixOn()) savedTags.push('color-mix');
                if (savedSpecialRequests) savedTags.push('has-special-requests');

                /* Save-design path fires InitiateCheckout only — CustomCapCheckout is reserved for the Place-Order path. */
                const sV = +(per * state.qty).toFixed(2);
                const sCN = `${P.title} - ${state.color}`;
                const sPC = [{ id: slug(P.title)+'-'+slug(state.color), quantity: state.qty, item_price: per.toFixed(2) }];
                const sIc = genEventId('ic_save_design');
                const fbSavedCheckoutContext = { eventId: sIc, eventSourceUrl: location.href, fbp: getFbp(), fbc: getFbc(), email: _saveEmail || undefined, value: sV, currency: 'USD', contentName: sCN, contents: sPC };
                if (typeof fbq === 'function') {
                  fbq('track', 'InitiateCheckout', { content_name: sCN, content_category: 'Custom Caps', content_ids: sPC.map(c=>c.id), contents: sPC, num_items: state.qty, value: sV, currency: 'USD' }, { eventID: sIc });
                }

                let checkoutUrl = '';
                try {
const { resp: draftResp, data: draftData } = await ldFetchCheckout({ method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({
                      line_items: savedLineItems,
                      customer_note: `Saved design: ${state.qty} units, ${sides.length ? sides.join(', ') : 'Front'} embroidery${designId ? ` — Design ${designId}` : ''}${mixOn() ? `\n\nColor mix:\n${orderMixDetail()}` : `\nSizes: ${sizesLabel()}`}${savedSpecialRequests ? `\n\nSpecial requests:\n${savedSpecialRequests.slice(0, 500)}` : ''}`,
                      /* tax handling is now decided by the server from customer address */
                      email: _saveEmail || undefined,
                      tags: savedTags,
                      fb: fbSavedCheckoutContext,
                      product_key: 'beanie', sides_count: sides.length /* server re-derives per-hat price; 0 = blank cap */
                    }) }, 8000, true);
if (draftResp.ok) checkoutUrl = draftData.invoice_url || '';
} catch (draftErr) {
                  console.error('Draft order for save email skipped:', draftErr.name === 'AbortError' ? 'timeout' : draftErr);
                }

                if (procText) procText.textContent = 'Sending your email';
                try {
                  await sendSavedDesignEmail({
                    to: email,
                    bcc: 'wholesale@liftdown.com',
                    replyTo: 'wholesale@liftdown.com',
                    subject: `Your saved design${designId ? ` - ${designId}` : ''}`,
                    html: window.LiftDownConfiguratorEmails.saved({
                      product: PRODUCT_NAME, color: state.color,
                      mix: mixOn() ? state.mix.map(row => `${row.color}: ${row.qty}${rowSizesSuffix(row)}`) : [],
                      sizes: sizesLabel(), quantity: state.qty,
                      placements: sides.join(', '), reference: designId,
                      unitPrice: formatMoney(per), subtotal: formatMoney(per * state.qty),
                      instructions: savedSpecialRequests.slice(0, 500),
                      designURL: link, checkoutURL: checkoutUrl, attachmentCount: attachments.length
                    }),
                    attachments: attachments
                  });
                  savedEmailSent = true;
                } catch (emailErr) {
                  console.error('[email] saved-design email failed:', emailErr);
                }
                } /* end email-only branch */

                processing.classList.remove('show');
                if (procText) procText.textContent = 'Preparing your order';

                const successTextEl = saveSuccess.querySelector('.ldm-save-success-text');
                if (successTextEl) successTextEl.textContent = savedEmailSent
                  ? 'Link sent! Check your inbox.'
                  : _saveEmail
                    ? 'Design saved, but we could not confirm the email was sent. Copy your link below.'
                    : 'Design saved! Copy your link below.';
                saveSuccess.classList.add('show');
                saveForm.style.display = 'none';
                saveSubmit.disabled = false;
                saveSubmit.textContent = 'Save & Get Link';

                /* Keep the local copy when email fails or no email was requested.
                   The saved cloud link remains available in either case. */
                if (savedEmailSent) { try { localStorage.removeItem(LS_KEY); } catch (e) {} }

                if (typeof gtag === 'function') {
                  gtag('event', 'generate_lead', {
                    event_category: 'Save Design',
                    event_label: state.color + ' - qty ' + state.qty,
                    value: base * state.qty,
                    currency: 'USD'
                  });
                }
                /* No PII in custom event params — Meta strips custom events containing raw email. */
                /* eventId is passed so server CAPI can dedupe the DesignSaved custom event. */
                trackEvent('DesignSaved', { color: state.color, qty: state.qty, sides: getDesignSides().length, design_id: designId }, fbDesignSavedEventId);

                /* Show the unique link on the page */
                if (saveLinkResult && saveLinkUrl) {
                  saveLinkUrl.value = link;
                  saveLinkResult.style.display = 'block';
                }

              } catch(err) {
                console.error('[save-design] failed:', err);
                try { trackEvent('DesignSaveFailed', { message: String((err && err.message) || err).slice(0, 120) }); } catch (e2) {}
                processing.classList.remove('show');
                if (procText) procText.textContent = 'Preparing your order';
                const _saveMsg = String((err && err.message) || '');
                saveError.textContent = /timed out|too large|Too many/i.test(_saveMsg)
                  ? _saveMsg + ' You can also email your design to wholesale@liftdown.com and we will set it up for you.'
                  : 'Something went wrong. Please try again, or email your design to wholesale@liftdown.com and we will set it up for you.';
                saveError.classList.add('show');
                saveSubmit.disabled = false;
                saveSubmit.textContent = 'Save & Get Link';
              }
            };
          }

          /* ========== RESTORE FROM URL ========== */
          async function restoreFromURL() {
            const params = new URLSearchParams(window.location.search);
            const designId = params.get('design');
            const sig = params.get('sig');

            /* If we have a saved design ID, load the full design from cloud */
            if (designId) {
              const procText = processing.querySelector('.ldm-processing-text');
try {
                
                if (procText) procText.textContent = 'Loading your design';
                processing.classList.add('show');
                /* sig is required by load-design; legacy links without a sig will 403 — surface a clean error. */
                const loadUrl = `${LOAD_DESIGN_URL}?id=${encodeURIComponent(designId)}${sig ? '&sig=' + encodeURIComponent(sig) : ''}`;
                const { resp, data: result } = await ldFetchWithDeadline(loadUrl, {}, LD_LOAD_REQUEST_TIMEOUT_MS, 'success-json');
                if (!resp.ok) throw new Error('Design not found');
                
                /* Remember the signature so subsequent re-saves / shares carry it forward. */
                if (sig) { _lastSavedId = designId; _lastSavedSig = sig; }
                const saved = result.data;
                if (saved.product_key && saved.product_key !== 'beanie') throw new Error('This design belongs to another product style.');

                /* Restore color */
                if (saved.color && COLORS.includes(saved.color)) {
                  state.color = saved.color;
                }

                /* Restore quantity */
                if (saved.qty && saved.qty >= 50 && saved.qty <= 99999) {
                  state.qty = saved.qty;
                  qtyEl.value = saved.qty;
                }

                /* Restore color mix + sizes */
                if (Array.isArray(saved.mix) && saved.mix.length) {
                  const rows = saved.mix
                    .filter(r => r && COLORS.includes(r.color))
                    .map(r => ({ color: r.color, qty: Math.min(99999, Math.max(50, r.qty | 0)), s: 0, xl: 0 }));
                  state.mix = rows.length ? rows : null;
                } else if (Array.isArray(saved.colorSplits) && saved.colorSplits.length > 1) {
                  /* server whitelist drops 'mix' but persists colorSplits — rebuild the mix
                     from it (per-row sizes aren't persisted server-side yet) */
                  const rows = saved.colorSplits
                    .filter(r => r && COLORS.includes(r.color))
                    .map(r => ({ color: r.color, qty: Math.min(99999, Math.max(50, r.qty | 0)), s: 0, xl: 0 }));
                  state.mix = rows.length > 1 ? rows : null;
                }
                mixPreviewColor = null;
                if (mixOn() && !state.mix.some(row => row.color === state.color)) state.color = state.mix[0].color;
                if (saved.sizes) {
                  state.sizes = { s: 0, xl: 0 };
                  if (state.sizes.s || state.sizes.xl) openGlobalSizes();
                }
                if (typeof saved.specialRequests === 'string' && specialRequestsEl) {
                  specialRequestsEl.value = saved.specialRequests;
                  if (saved.specialRequests.trim() && specialRequestsWrap) {
                    setSpecialRequestsExpanded(true);
                  }
                }

                /* Restore designs on each side */
                if (saved.designs) {
                  const capW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85;
                  for (const side of ['Front']) {
                    const sd = saved.designs[side];
                    if (sd) {
                      const d = state.designs[side];
ldThreadRestoreMetadata(d, sd);
                      if (sd.data) d.data = sd.data;
                      if (sd.placement) {
                        d.placement = { ...d.placement, ...sd.placement };
                        /* Convert saved width relative to cap back to pixels for this screen */
                        if (sd.placement.wPctCap) {
                          d.placement.w = Math.round(sd.placement.wPctCap * capW / 100);
                        } else if (sd.placement.wPct) {
                          /* Legacy fallback for old saves */
                          d.placement.w = Math.round(sd.placement.wPct * stageEl.offsetWidth / 100);
                        }
                      }
                      if (sd.textConfig) d.textConfig = { ...d.textConfig, ...sd.textConfig };
                      if (sd.mode) d.mode = sd.mode;
                      /* Create a minimal file-like object so the UI shows the file name */
                      if (sd.fileName) d.file = { name: sd.fileName, type: '' };
                      else if (sd.data) d.file = { name: 'Saved design', type: '' };
                    }
                  }
                }

                /* Cache this design ID so re-sharing doesn't duplicate */
                _lastSavedId = designId;
                _lastSavedHash = stateHash();

                /* Refresh all UI */
                renderSwatches();
                renderTabs();
                updateStage();
                updateUploadUI();
                renderMix();
                updatePricing();
                syncInlineTextForSide();
                processing.classList.remove('show');
                if (procText) procText.textContent = 'Preparing your order';
                return;
              } catch (e) {
                console.error('Failed to load saved design:', e);
                processing.classList.remove('show');
                if (procText) procText.textContent = 'Preparing your order';
                /* Fall through to legacy param restore */
              }
            }

            /* Legacy fallback: restore from simple query params */
            const colorParam = params.get('color');
            const qtyParam = params.get('qty');

            if (colorParam && setPreviewColor(colorParam)) {
              renderSwatches();
              updateStage();
            }

            if (qtyParam) {
              const q = parseInt(qtyParam);
              if (q >= 50 && q <= 99999) {
                state.qty = q;
                qtyEl.value = q;
                updatePricing();
              }
            }
          }

          /* ========== MOCKUP SCREENSHOT CAPTURE ========== */
          /* Sizes mockups so (color × side) batches fit within Netlify's 6 MB function ceiling. */
          function mockupPreset(count, target) {
            if (target === 'cloud') {
              if (count <= 4)  return { width: 1200, mimeType: 'image/jpeg', quality: 0.85 };
              if (count <= 16) return { width: 900,  mimeType: 'image/jpeg', quality: 0.8  };
              return              { width: 700,  mimeType: 'image/jpeg', quality: 0.75 };
            }
            /* Email preset: always JPEG, capped sizes — keeps total email payload under
               Netlify's 6MB platform-level body limit even with multi-color × multi-side
               + compressed originals attached. Mockups are visual reference only; the real
               production source is the attached original logo file. */
            if (count <= 4)  return { width: 1200, mimeType: 'image/jpeg', quality: 0.88 };
            if (count <= 16) return { width: 1000, mimeType: 'image/jpeg', quality: 0.82 };
            return              { width: 800,  mimeType: 'image/jpeg', quality: 0.75 };
          }
          const extForMime = (m) => m === 'image/jpeg' ? 'jpg' : 'png';

          async function captureMockup(side, color, options = {}) {
const ldThreadCaptureColor = color || state.color;
let ldThreadCaptureData;

            (await prepareTextDesigns(), ldThreadCaptureData = await window.LiftDownThreadColors.render(state.designs[side], ldThreadCaptureColor));
            return new Promise((resolve, reject) => {
              const d = state.designs[side];
              if (!ldThreadCaptureData) { resolve(null); return; }
              const mockupColor = ldThreadCaptureColor;
              const width = options.width || 1600;
              /* Mirror the live stage's aspect ratio so canvas-relative percentages from
                 savePlacement (which divide by stageRect dimensions) reproduce the exact
                 same on-cap position. A fixed 4:3 canvas drifted edge-positioned logos
                 (e.g. back-strap curved text) toward the cap center on saved mockups. */
              const stageRect = stageEl.getBoundingClientRect();
              const stageAR = (stageRect.width > 0 && stageRect.height > 0)
                ? (stageRect.height / stageRect.width)
                : 0.75;
              const height = Math.round(width * stageAR);
              const mimeType = options.mimeType || 'image/png';
              const quality = options.quality !== undefined ? options.quality : 1;
              /* pad = fraction of canvas the cap fills. <1 leaves whitespace margins;
                 >1 intentionally overflows canvas edges to crop the source image's own
                 whitespace — useful for the tight zoom in the color-preview bubble. */
              const pad = options.pad !== undefined ? options.pad : 0.85;
              const showCaption = options.caption !== false;

              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = width;
              canvas.height = height;

              ctx.fillStyle = '#e7e2df';
              ctx.fillRect(0, 0, canvas.width, canvas.height);

              const capData = imageFor(mockupColor, side, Math.max(1200, width));

              const capImg = new Image();
              capImg.crossOrigin = 'anonymous';

              capImg.onload = () => {
                const maxW = canvas.width * pad;
                const maxH = canvas.height * pad;
                const scale = Math.min(maxW / capImg.naturalWidth, maxH / capImg.naturalHeight);
                const capW = capImg.naturalWidth * scale;
                const capH = capImg.naturalHeight * scale;
                const capX = (canvas.width - capW) / 2;
                const capY = (canvas.height - capH) / 2;

                if (capData.flip) {
                  ctx.save();
                  ctx.translate(canvas.width, 0);
                  ctx.scale(-1, 1);
                  ctx.drawImage(capImg, canvas.width - capX - capW, capY, capW, capH);
                  ctx.restore();
                } else {
                  ctx.drawImage(capImg, capX, capY, capW, capH);
                }

                const captionSize = Math.max(12, Math.round(canvas.height * 0.02));
                const captionY = canvas.height - Math.round(canvas.height * 0.025);

                const drawCaption = () => {
                  if (!showCaption) return;
                  ctx.fillStyle = '#1a1a1a';
                  ctx.font = `bold ${captionSize}px -apple-system, BlinkMacSystemFont, sans-serif`;
                  ctx.textAlign = 'center';
                  ctx.fillText(`${mockupColor} - ${side} View`, canvas.width / 2, captionY);
                };

                const logoImgEl = new Image();
                logoImgEl.onload = () => {
                  const p = d.placement;
                  /* Position logo as canvas-relative percentages — savePlacement stores
                     p.x/p.y as fractions of stageRect, and the canvas now matches stage
                     AR with the same 85% cap-fit, so the same percentages land on the
                     same point on the cap. */
                  const logoCenterX = (p.x / 100) * canvas.width;
                  const logoCenterY = (p.y / 100) * canvas.height;
                  /* Scale logo width relative to cap width */
                  const stageCapW = stageImg.offsetWidth || stageEl.offsetWidth * 0.85;
                  const logoW = (p.w / stageCapW) * capW;
                  const logoH = (logoImgEl.naturalHeight / logoImgEl.naturalWidth) * logoW;

                  ctx.save();
                  ctx.translate(logoCenterX, logoCenterY);
                  ctx.rotate((p.r || 0) * Math.PI / 180);
                  ctx.drawImage(logoImgEl, -logoW / 2, -logoH / 2, logoW, logoH);
                  ctx.restore();

                  drawCaption();
                  resolve(canvas.toDataURL(mimeType, quality));
                };

                logoImgEl.onerror = () => {
                  drawCaption();
                  resolve(canvas.toDataURL(mimeType, quality));
                };

                logoImgEl.src = ldThreadCaptureData;
              };

              capImg.onerror = () => {
                console.error('Failed to load cap image for mockup');
                resolve(ldThreadCaptureData);
              };

              capImg.src = capData.url;
            });
          }

          /* ========== CTA HANDLER ========== */
          /* ctaEl is the "Place Your Order" submit button inside the order panel. */
          /* Validation and email capture happen inside the panel (see panel handler below). */

          /* Checkout-specific error display — lives directly under the CTA, not in the upload area. */
          const showOrderError = (html) => { orderErrorEl.innerHTML = html; orderErrorEl.classList.add('show'); };
          const hideOrderError = () => { orderErrorEl.textContent = ''; orderErrorEl.classList.remove('show'); };
          /* Pre-checkout validation errors — sit below the Proceed to Checkout / Save Design row
             so the user sees them at the point of click, not way up in the upload area. */
          const actionsErrorEl = $('#ldm-actions-error');
          /* innerHTML so the minimum-quantity message can carry its rescue link.
             Every caller passes an internal string, never user input. */
          const showActionsError = (msg) => { if (actionsErrorEl) { actionsErrorEl.innerHTML = msg; actionsErrorEl.classList.add('show'); } };
          const hideActionsError = () => { if (actionsErrorEl) actionsErrorEl.classList.remove('show'); };

          let checkoutNavigationPending = false;
          window.addEventListener('pageshow', () => {
            if (!checkoutNavigationPending) return;
            checkoutNavigationPending = false;
            processing.classList.remove('show');
            ctaEl.disabled = false;
          });

          async function runCheckoutFlow() {
            try { await ldRunPreparation(async (ldCheckPreparation) => { await prepareTextDesigns(); ldCheckPreparation(); }); }
            catch { showOrderError('The font could not load. Please choose another font and try again.'); return; }
            hideError();
            hideOrderError();
            const locs = countDesigns();
            if(!locs) { showOrderError('Add a logo or text before checking out. Just want blank beanies, no embroidery? <a href="/pages/b2b-order-form" style="color:inherit;text-decoration:underline;">Order blanks here</a>.'); trackEvent('BlankCapPrompted', { where: 'order-panel' }); return; }
            if(state.qty<50) { showOrderError('Minimum order quantity is 50 beanies. Only need a few? <a href="/pages/custom-hats-inquiry#d715-inquiry" style="color:inherit;text-decoration:underline;">Contact us about your project</a>.'); return; }

            const procText = processing.querySelector('.ldm-processing-text');
            if (procText) procText.textContent = 'Saving your design';
            processing.classList.add('show');
            ctaEl.disabled = true;

            try {
              const base = getBase(state.qty);
              const embLocs = locs;
              const emb = embLocs * EMB_PRICE;
              const per = base + emb;
              const sides = getDesignSides();

              /* Meta Pixel — fire both InitiateCheckout (Meta standard, for ad optimization) */
              /* and CustomCapCheckout (your custom event). Both are deduped with server CAPI. */
              const checkoutValue = +(per * state.qty).toFixed(2);
              const checkoutContentName = `${P.title} - ${state.color}`;
              const pixelContents = [{
                id: slug(P.title) + '-' + slug(state.color),
                quantity: state.qty,
                item_price: per.toFixed(2)
              }];
              const pixelContentIds = pixelContents.map(c => c.id);
              const fbIcEventId = genEventId('ic_custom_cap');
              const fbCustomEventId = genEventId('ccc_custom_cap');
              if (_lastSavedEmail) fbAdvancedInit(_lastSavedEmail);

              const fbCheckoutContext = {
                eventId: fbIcEventId,              /* for InitiateCheckout */
                customEventId: fbCustomEventId,    /* for CustomCapCheckout */
                eventSourceUrl: location.href,
                fbp: getFbp(),
                fbc: getFbc(),
                email: _lastSavedEmail || undefined,
                value: checkoutValue,
                currency: 'USD',
                contentName: checkoutContentName,
                contents: pixelContents
              };

              if (typeof fbq === 'function') {
                fbq('track', 'InitiateCheckout', {
                  content_name: checkoutContentName,
                  content_category: 'Custom Caps',
                  content_ids: pixelContentIds,
                  contents: pixelContents,
                  num_items: state.qty,
                  value: checkoutValue,
                  currency: 'USD'
                }, { eventID: fbIcEventId });

                fbq('trackCustom', 'CustomCapCheckout', {
                  content_name: checkoutContentName,
                  content_category: 'Custom Caps',
                  num_items: state.qty,
                  value: checkoutValue,
                  currency: 'USD'
                }, { eventID: fbCustomEventId });
              }

              /* Save design FIRST so we have a Design ID to stamp across the order, tags, and email. */
              /* Pass email so Supabase row gets the customer email, and Lead CAPI can match on it. */
              let designId = null;
              let designLink = '';
              try {
                const saved = await saveDesignToCloud(_lastSavedEmail, null);
                designId = saved.id;
                designLink = saved.url;
              } catch (saveErr) {
                console.error('Pre-checkout save failed:', saveErr);
              
if (ldThreadHasOverrides()) throw new Error('Your thread-color choices could not be saved. Your design is still here; please try again.');
}

              if (procText) procText.textContent = 'Preparing your order';

              const attachments = [];

              /* Email mockups: just the primary color × all designed sides (max 3 mockups).
                 Keeps email payload tiny regardless of order size. Customer sees one color
                 rendered with their design across each embroidery location; full multi-color
                 visuals are accessible via the design link in the email body. Originals are
                 NOT attached — they're persisted in Supabase via saveDesignToCloud and
                 accessible to the production team there. */
              const orderEmailPreset = mockupPreset(sides.length, 'email');
              const orderEmailExt = extForMime(orderEmailPreset.mimeType);
              /* Reuse the mockups saveDesignToCloud just rendered instead of re-rendering
                 every side, and capture any misses in parallel — this path used to draw
                 each side twice, serially, right before the checkout redirect. */
              await ldRunPreparation(async (ldCheckPreparation) => { await Promise.all(sides.map(async side => {
                try {
                  const cached = (_lastCloudMockups && _lastCloudMockups.color === state.color) ? _lastCloudMockups.bySide[side] : null;
                  const mockupData = (cached && cached.startsWith('data:' + orderEmailPreset.mimeType))
                    ? cached
                    : await captureMockup(side, state.color, orderEmailPreset);
                  if (mockupData) {
                    attachments.push({
                      filename: `mockup-${side.toLowerCase()}-${state.color.replace(/\s+/g, '-').toLowerCase()}.${orderEmailExt}`,
                      content: mockupData.split(',')[1],
                      contentType: orderEmailPreset.mimeType
                    });
                  }
                } catch (mockupErr) {
                  console.error(`Failed to generate mockup for ${state.color}/${side}:`, mockupErr);
                }
              })); ldCheckPreparation(); });

              /* One line item per color so each color + its sizes lands as its own row in
                 Shopify and the ops app. The server prices every line at the TOTAL-quantity
                 tier (validateLineItemsAgainstCart sums all quantities), so splitting never
                 changes the price. Each mix row is >= 50, which the server also requires. */
              const specialRequestsValue = (specialRequestsEl && specialRequestsEl.value || '').trim();
              const baseProps = {
                  'Turnaround': '4–6 weeks',
                  'Sample timing': '1–2 weeks',
                  'Production timing': '4 weeks after sample review',
                'Embroidery Locations': sides.join(', '),
                'Base Price': formatMoney(base),
                'Embroidery Cost': formatMoney(emb)
              };
              if (designId) baseProps['Design #'] = designId;
              let line_items;
              if (mixOn()) {
                line_items = state.mix.map((r, i) => ({
                  title: `${PRODUCT_NAME} - ${r.color}`,
                  quantity: r.qty,
                  price: per.toFixed(2),
                  taxable: false,
                  properties: Object.assign({ 'Color': r.color, 'Sizes': rowSizesLabel(r) }, baseProps, ldThreadProps(r.color),
                    (i === 0 && specialRequestsValue) ? { 'Special Requests': specialRequestsValue.slice(0, 500) } : {})
                }));
              } else {
                const props = Object.assign({ 'Color': state.color, 'Sizes': sizesLabel() }, baseProps, ldThreadProps(state.color));
                if (specialRequestsValue) props['Special Requests'] = specialRequestsValue.slice(0, 500);
                line_items = [{
                  title: `${PRODUCT_NAME} - ${state.color}`,
                  quantity: state.qty,
                  price: per.toFixed(2),
                  taxable: false,
                  properties: props
                }];
              }

              let customerNote = `Custom beanie: ${state.qty} units, ${sides.join(', ')} embroidery${designId ? ` — Design ${designId}` : ''}`;
              if (mixOn()) customerNote += `\n\nColor mix:\n${orderMixDetail()}`;
              else customerNote += `\nSizes: ${sizesLabel()}`;
              if (specialRequestsValue) customerNote += `\n\nSpecial requests:\n${specialRequestsValue.slice(0, 500)}`;

              const orderTags = designId ? [`design-${designId}`, 'custom-cap-configurator'] : ['custom-cap-configurator'];
              orderTags.push('custom-beanie');
              if (mixOn()) orderTags.push('color-mix');
              if (specialRequestsValue) orderTags.push('has-special-requests');

              const { resp, data } = await ldFetchCheckout({
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body: JSON.stringify({
                  line_items: line_items,
                  customer_note: customerNote,
                  checkout_attachments: !designId ? attachments : undefined,
                  /* tax handling is now decided by the server from customer address */
                  email: _lastSavedEmail || undefined,
                  tags: orderTags,
                  fb: fbCheckoutContext,
                  product_key: 'beanie', sides_count: Math.max(1, sides.length || 1) /* server re-derives per-hat price */
                })
              });
              
              if(!resp.ok) {
                console.error('Draft order failed:', data);
                throw new Error(data.error || 'Order failed');
              }

              const emailPayload = {
                to: _lastSavedEmail,
                bcc: 'wholesale@liftdown.com',
                replyTo: 'wholesale@liftdown.com',
                subject: `Your custom beanie order${designId ? ` - ${designId}` : ''}`,
                html: window.LiftDownConfiguratorEmails.order({
                  product: PRODUCT_NAME, color: state.color,
                  mix: mixOn() ? state.mix.map(row => `${row.color}: ${row.qty}${rowSizesSuffix(row)}`) : [],
                  sizes: sizesLabel(), quantity: state.qty,
                  placements: sides.join(', '), reference: designId,
                  unitPrice: formatMoney(per), subtotal: formatMoney(per * state.qty),
                  instructions: specialRequestsValue.slice(0, 500),
                  designURL: designLink, checkoutURL: data.invoice_url, attachmentCount: attachments.length
                }),
                attachments: attachments
              };

              /* Send the courtesy email with a 10s timeout. Awaiting it ensures the
                 request actually leaves the browser before we navigate (keepalive beanies
                 body at 64KB and would silently drop it). If Resend is slow/down, the
                 timeout fires and checkout still proceeds. */
              /* Skip the courtesy email entirely when we don't have a recipient — Shopify checkout will collect a real email. */
              if (_lastSavedEmail && !data.receipt_managed) {
                if (procText) procText.textContent = 'Sending your email';
                try {
                  const emailController = new AbortController();
                  const emailTimeout = setTimeout(() => emailController.abort(), 10000);
                  const emailResp = await fetch(EMAIL_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(emailPayload),
                    signal: emailController.signal
                  });
                  clearTimeout(emailTimeout);
                  if (!emailResp.ok) console.error('[email] send failed status:', emailResp.status);
                } catch (emailErr) {
                  console.error('[email] send failed:', emailErr);
                }
              }

              checkoutNavigationPending = true;
              window.location.href = data.invoice_url;
              
            } catch(e) {
              checkoutNavigationPending = false;
              console.error('Order error:', e);
              processing.classList.remove('show');
              ctaEl.disabled = false;
              /* Keep the UI message generic — raw error strings can leak internals. Full error is in console for support triage. */
              console.error('[order] failed:', e);
              showOrderError('Something went wrong — please try again. Email <a href="mailto:wholesale@liftdown.com" style="color:inherit;text-decoration:underline;">wholesale@liftdown.com</a> if this persists.');
            }
          }

          /* Gate submit buttons on valid email so the final click never wastes a tap */
          /* Stricter than RFC but matches what Shopify will accept: no consecutive/leading/trailing dots in local or domain. */
          const isValidEmail = (v) => /^[^\s@.]+(?:\.[^\s@.]+)*@[^\s@.]+(?:\.[^\s@.]+)+$/.test(String(v || '').trim());
          const syncSaveBtn = () => {
            /* Blank email = link-only save (no email sent), so it stays clickable. */
            const v = saveEmailInput.value.trim();
            saveSubmit.disabled = !(v === '' || isValidEmail(v));
          };
          const syncOrderBtn = () => { ctaEl.disabled = false; /* email no longer gates checkout — invalid/blank falls through and Shopify collects it */ };
          /* Mirror email between the two panels so switching never forces a re-type */
          saveEmailInput.addEventListener('input', () => {
            if (orderEmailInput.value !== saveEmailInput.value) orderEmailInput.value = saveEmailInput.value;
            syncSaveBtn();
            syncOrderBtn();
          });
          orderEmailInput.addEventListener('input', () => {
            if (saveEmailInput.value !== orderEmailInput.value) saveEmailInput.value = orderEmailInput.value;
            syncOrderBtn();
            syncSaveBtn();
          });
          syncSaveBtn();
          syncOrderBtn();

          /* ========== SAVE / ORDER PANEL TOGGLES ========== */
          function showSavePanel() {
            orderPanel.style.display = 'none';
            savePanel.style.display = 'block';
            /* Carry over whatever's already typed (or the last saved email) */
            if (!saveEmailInput.value) {
              saveEmailInput.value = orderEmailInput.value || _lastSavedEmail || '';
            }
            syncSaveBtn();
            setTimeout(() => saveEmailInput && saveEmailInput.focus(), 50);
          }
          function showOrderPanel() {
            hideActionsError();
            const locs = countDesigns();
            if(!locs) { showActionsError('Add a logo or text before checking out. Just want blank beanies, no embroidery? <a href="/pages/b2b-order-form" style="color:inherit;text-decoration:underline;">Order blanks here</a>.'); trackEvent('BlankCapPrompted', { where: 'actions-row' }); return; }
            if(state.qty<50) { showActionsError('Minimum order quantity is 50 beanies. Only need a few? <a href="/pages/custom-hats-inquiry#d715-inquiry" style="color:inherit;text-decoration:underline;">Contact us about your project</a>.'); return; }
            savePanel.style.display = 'none';
            orderPanel.style.display = 'block';
            if (!orderEmailInput.value) {
              orderEmailInput.value = saveEmailInput.value || _lastSavedEmail || '';
            }
            hideOrderError();
            syncOrderBtn();
            setTimeout(() => orderEmailInput.focus(), 50);
          }
          if (saveToggleBtn) saveToggleBtn.onclick = () => {
            showSavePanel();
            /* If email is already valid, skip the extra tap — submit straight through */
            if (savePanel.style.display === 'block' && isValidEmail(saveEmailInput.value)) {
              saveSubmit.click();
            }
          };
          if (orderToggleBtn) orderToggleBtn.onclick = () => {
            showOrderPanel();
            /* If email is already valid, skip the extra tap — submit straight through */
            if (orderPanel.style.display === 'block' && isValidEmail(orderEmailInput.value)) {
              ctaEl.click();
            }
          };

          /* Order panel submit — ctaEl (#ldm-cta) now lives INSIDE the order panel */
          ctaEl.onclick = async () => {
            const entered = orderEmailInput.value.trim();
            _lastSavedEmail = isValidEmail(entered) ? entered.toLowerCase() : '';
            hideOrderError();
            await runCheckoutFlow();
          };
          orderEmailInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' && !ctaEl.disabled) { e.preventDefault(); ctaEl.click(); }
          });

          /* ========== ANALYTICS HELPERS ========== */
          function trackEvent(eventName, data, eventId) {
            if (typeof fbq === 'function') {
              if (eventId) {
                fbq('trackCustom', eventName, data || {}, { eventID: eventId });
              } else {
                fbq('trackCustom', eventName, data || {});
              }
            }
            /* Also fire a custom DOM event for any external analytics */
            window.dispatchEvent(new CustomEvent('ldm:' + eventName, { detail: data || {} }));
          }

          /* ========== LOCAL AUTO-SAVE ========== */
          const LS_KEY = 'ldm_autosave_beanie';
          const LS_DESIGNS_KEY = 'ldm_autosave_beanie_designs';
          let _autoSaveTimer = null;
          let _lastBitmapSig = null;
          function autoSave() {
const ldThreadSaveSequence = ++ldThreadAutoSaveSequence;

            clearTimeout(_autoSaveTimer);
            _autoSaveTimer = setTimeout(async () => {
let ldThreadPreviousHeavy, ldThreadPreviousBitmapSig = _lastBitmapSig, ldThreadHeavyWritten = false;

              try {
const threadFeature = ldThreadHasOverrides();
if (threadFeature) ldThreadPreviousHeavy = localStorage.getItem(LS_DESIGNS_KEY);
const threadSources = {};
if (threadFeature) {
  for (const side of getDesignSides()) {
    const d = state.designs[side];
    if (d.mode !== 'text' && Object.keys(window.LiftDownThreadColors.sanitizeMap(d.threadByColor, { colors: COLORS, mode: d.mode })).length) {
      threadSources[side] = await ldThreadFitRaster(await window.LiftDownThreadColors.originalSource(d));
    }
  }
}
if (ldThreadSaveSequence !== ldThreadAutoSaveSequence) return;

                /* Light config: cheap to stringify, written on every debounce tick.
                   Heavy base64 bitmaps live under a separate key and are only rewritten
                   when a design actually changes — qty clicks and logo drags no longer
                   serialize megabytes on the main thread. */
                const payload = { color: state.color, qty: state.qty,
                  mix: state.mix ? state.mix.map(r => ({ color: r.color, qty: r.qty, s: r.s, xl: r.xl })) : null,
                  sizes: state.sizes, side: state.side,
                  specialRequests: (specialRequestsEl && specialRequestsEl.value) || '', designs: {} };
                for (const s of ['Front']) {
                  const d = state.designs[s];
                  if (d.data || d.textConfig.text.trim()) {
                    payload.designs[s] = ({ ...{
                      placement: d.placement, mode: d.mode,
                      textConfig: d.textConfig, fileName: d.file?.name || null
                    }, ...(threadFeature ? ldThreadLocalMetadata(d) : {}) });
                  }
                }
                (threadFeature ? undefined : localStorage.setItem(LS_KEY, JSON.stringify(payload)));
                const sig = (threadFeature ? ldThreadFingerprint() : ['Front'].map(s => (state.designs[s].data || '').length).join(','));
if (threadFeature) payload._threadSnapshot = sig;
                if (sig !== _lastBitmapSig) {
                  (threadFeature ? undefined : (_lastBitmapSig = sig));
                  const bitmaps = {};
if (threadFeature) (bitmaps._threadSources = threadSources, bitmaps._threadSnapshot = sig);
                  for (const s of ['Front']) {
                    if (state.designs[s].data) bitmaps[s] = state.designs[s].data;
                  }
                  ((localStorage.setItem(LS_DESIGNS_KEY, JSON.stringify(bitmaps)), ldThreadHeavyWritten = threadFeature), threadFeature ? (_lastBitmapSig = sig) : undefined);
                }
              
if (threadFeature) localStorage.setItem(LS_KEY, JSON.stringify(payload));
} catch (e) {
if (ldThreadHeavyWritten) {
  try {
    if (ldThreadPreviousHeavy == null) localStorage.removeItem(LS_DESIGNS_KEY);
    else localStorage.setItem(LS_DESIGNS_KEY, ldThreadPreviousHeavy);
  } catch (_) { /* Snapshot tokens prevent a mixed restore if rollback also fails. */ }
  _lastBitmapSig = ldThreadPreviousBitmapSig;
}
 /* quota exceeded — ignore */ }
            }, 1000);
          }

          function restoreFromLocalStorage() {
            try {
              const raw = localStorage.getItem(LS_KEY);
              if (!raw) return false;
              const saved = JSON.parse(raw);
              if (saved.color && COLORS.includes(saved.color)) state.color = saved.color;
              if (saved.qty >= 50 && saved.qty <= 99999) { state.qty = saved.qty; qtyEl.value = saved.qty; }
              if (Array.isArray(saved.mix) && saved.mix.length) {
                const rows = saved.mix
                  .filter(r => r && COLORS.includes(r.color))
                  .map(r => ({ color: r.color, qty: Math.min(99999, Math.max(50, r.qty | 0)), s: 0, xl: 0 }));
                state.mix = rows.length ? rows : null;
              }
              mixPreviewColor = null;
              if (mixOn() && !state.mix.some(row => row.color === state.color)) state.color = state.mix[0].color;
              if (saved.sizes) {
                state.sizes = { s: 0, xl: 0 };
                if (state.sizes.s || state.sizes.xl) openGlobalSizes();
              }
              if (typeof saved.specialRequests === 'string' && specialRequestsEl) {
                specialRequestsEl.value = saved.specialRequests;
                if (saved.specialRequests.trim() && specialRequestsWrap) {
                  setSpecialRequestsExpanded(true);
                }
              }
              let bitmaps = {};
              try { bitmaps = JSON.parse(localStorage.getItem(LS_DESIGNS_KEY) || '{}'); } catch (e2) {}
if ((saved._threadSnapshot || bitmaps._threadSnapshot) && saved._threadSnapshot !== bitmaps._threadSnapshot) return false;
              if (saved.designs) {
                for (const s of ['Front']) {
                  const sd = saved.designs[s];
                  if (!sd) continue;
                  const d = state.designs[s];
ldThreadRestoreMetadata(d, sd, bitmaps._threadSources && bitmaps._threadSources[s], sd.data || bitmaps[s]);
                  if (sd.data || bitmaps[s]) d.data = sd.data || bitmaps[s];
                  if (sd.placement) d.placement = { ...d.placement, ...sd.placement };
                  if (sd.textConfig) d.textConfig = { ...d.textConfig, ...sd.textConfig };
                  if (sd.mode) d.mode = sd.mode;
                  if (sd.fileName) d.file = { name: sd.fileName, type: '' };
                  else if (sd.data) d.file = { name: 'Restored design', type: '' };
                }
              }
              return true;
            } catch (e) { return false; }
          }

          /* Hook auto-save into state-changing actions */
          const _origUpdatePricing = updatePricing;
          updatePricing = function() { _origUpdatePricing(); autoSave(); updateProgress(); };
          /* Persist Special Requests to localStorage as the user types (debounced via autoSave). */
          if (specialRequestsEl) specialRequestsEl.addEventListener('input', autoSave);

          /* ========== STEP PROGRESS BAR ========== */
          function updateProgress() {
            const steps = $$('.ldm-progress-step');
            const lines = [$$('#ldm-prog-line-1')[0], $$('#ldm-prog-line-2')[0]];
            const hasColor = !!state.color;
            const hasDesign = ['Front'].some(s => !!state.designs[s].data);
            const hasQty = state.qty >= 50;

            steps.forEach((s, i) => {
              s.classList.remove('active', 'done');
              if (i === 0 && hasColor) s.classList.add('done');
              if (i === 1 && hasDesign) s.classList.add('done');
              else if (i === 1 && hasColor) s.classList.add('active');
              if (i === 2 && hasDesign && hasQty) s.classList.add('done');
              else if (i === 2 && hasDesign) s.classList.add('active');
              /* Show checkmark for done steps */
              const dot = s.querySelector('.ldm-progress-dot');
              if (s.classList.contains('done')) {
                dot.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
              } else {
                dot.textContent = i + 1;
              }
            });
            if (lines[0]) lines[0].classList.toggle('filled', hasColor && hasDesign);
            if (lines[1]) lines[1].classList.toggle('filled', hasDesign && hasQty);

            /* Highlight save design when design exists */
            const saveDesignEl = $('#ldm-save-design');
            if (saveDesignEl) saveDesignEl.classList.toggle('has-design', hasDesign);
          }

          /* ========== EXIT INTENT ========== */
          let _exitShown = false;

          /* Ad-landing params: ?qty=50 and/or ?color=Navy%20Blue let campaigns (e.g.
             Google Shopping) drop visitors onto a specific quantity/color so the page
             price matches the ad price. Only affects links that carry the params —
             default/organic traffic still starts at 25. Skipped entirely on ?design links
             (those restore the saved design instead). */
          function applyUrlParams() {
            const params = new URLSearchParams(window.location.search);
            const c = params.get('color');
            if (c) {
              const match = COLORS.find(x => x.toLowerCase() === c.toLowerCase());
              if (match) setPreviewColor(match);
            }
            const q = parseInt(params.get('qty'), 10);
            if (!mixOn() && Number.isFinite(q) && q >= 50 && q <= 99999) {
              state.qty = q;
              if (qtyEl) qtyEl.value = q;
            }
          }

          /* ========== INIT ========== */
          /* Switching styles starts fresh; direct visits and saved links keep their restore behavior. */
          const initParams = new URLSearchParams(window.location.search);
          const hasUrlDesign = initParams.has('design');
          const freshRequested = initParams.get('new_design') === '1';
          const startFresh = freshRequested && !hasUrlDesign;
          if (startFresh) {
            for (const key of [LS_KEY, LS_DESIGNS_KEY]) {
              try { localStorage.removeItem(key); } catch (e) { /* Storage can be unavailable. */ }
            }
          }
          if (freshRequested) {
            initParams.delete('new_design');
            const remainingQuery = initParams.toString();
            try {
              window.history.replaceState(window.history.state, '', window.location.pathname +
                (remainingQuery ? '?' + remainingQuery : '') + window.location.hash);
            } catch (e) { /* A blocked history update must not stop the configurator. */ }
          }
          if (!hasUrlDesign && !startFresh) { restoreFromLocalStorage(); applyUrlParams(); }
          renderSwatches();
          renderTabs();
          syncViewBtns();
          updateStage();
          updateUploadUI();
          renderMix();
          updatePricing();
          updateProgress();
         
          if (hasUrlDesign) restoreFromURL();
          /* Reveal after init to prevent flash of unstyled content */
          const gridEl = $('#ldm-grid');
          if (gridEl) gridEl.style.opacity = '1';
          const cfgEl = $('.ldm-config');
          if (cfgEl) cfgEl.style.opacity = '1';

          /* ViewContent pixel: gives Meta retargeting a much larger audience pool than firing only
             on InitiateCheckout. Once-per-load — not on tab refocus. */
          try {
            if (typeof fbq === 'function') {
              const startingValue = (TIERS[0].price + EMB_PRICE) * 50;
              fbq('track', 'ViewContent', {
                content_name: P.title,
                content_category: 'Custom Caps',
                content_ids: [String(P.id || P.handle || '')],
                content_type: 'product',
                value: startingValue,
                currency: 'USD'
              }, { eventID: genEventId('vc') });
            }
          } catch (e) {}

        });
